// This file is auto-generated by @hey-api/openapi-ts

export type WhatsAppMessageSend = {
  config: number
  type: Type3DaEnum
  content: WhatsAppMessageContent
  /**
   * WhatsApp message ID to reply to (wamid...).
   */
  reply_to_message_id?: string | null
  recipient: number
}

export type WhatsAppMessageContent =
  | TemplateSendContent
  | TextSendContent
  | FileSendContent

export type FileSendContent = {
  link?: string
  attachment?: number
  caption?: string
}

export type TextSendContent = {
  body: string
  preview_url?: boolean
}

export type TemplateSendContent = {
  name: string
  language: string
  components?: Array<{
    [key: string]: unknown
  }>
}

/**
 * * `text` - Text
 * * `image` - Imagine
 * * `video` - Video
 * * `audio` - Audio
 * * `document` - Document
 * * `template` - Șablon
 */
export type Type3DaEnum =
  | 'text'
  | 'image'
  | 'video'
  | 'audio'
  | 'document'
  | 'template'

/**
 * * `text` - Text
 * * `image` - Imagine
 * * `video` - Video
 * * `audio` - Audio
 * * `document` - Document
 * * `template` - Șablon
 */
export const Type3DaEnum = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  DOCUMENT: 'document',
  TEMPLATE: 'template'
} as const

export type WhatsAppConfigUpdateReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  waba_id: string
  app_id: string
  app_secret: string
  phone_number_id: string
  readonly display_phone_number: string
  access_token: string
  webhook_verify_token?: string
  status: Status926Enum
  readonly last_verified_at: string | null
  readonly last_error_code: string | null
  readonly last_error_message: string | null
  readonly account: string | null
  readonly created_by_user: string
}

export type WhatsAppConfigUpdateWritable = {
  waba_id: string
  app_id: string
  app_secret: string
  phone_number_id: string
  access_token: string
  webhook_verify_token?: string
  status: Status926Enum
}

/**
 * * `CONNECTED` - Conectat
 * * `DISCONNECTED` - Deconectat
 * * `TOKEN_EXPIRED` - Token expirat
 */
export type Status926Enum = 'CONNECTED' | 'DISCONNECTED' | 'TOKEN_EXPIRED'

/**
 * * `CONNECTED` - Conectat
 * * `DISCONNECTED` - Deconectat
 * * `TOKEN_EXPIRED` - Token expirat
 */
export const Status926Enum = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED'
} as const

export type WhatsAppConfigCreateReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  waba_id: string
  app_id: string
  app_secret: string
  phone_number_id: string
  readonly display_phone_number: string
  access_token: string
  webhook_verify_token?: string
  status: Status926Enum
  readonly last_verified_at: string | null
  readonly last_error_code: string | null
  readonly last_error_message: string | null
  readonly account: string | null
  readonly updated_by_user: string | null
}

export type WhatsAppConfigCreateWritable = {
  waba_id: string
  app_id: string
  app_secret: string
  phone_number_id: string
  access_token: string
  webhook_verify_token?: string
  status: Status926Enum
}

/**
 * * `hours` - Hours
 * * `days` - Days
 * * `weeks` - Weeks
 */
export type WaitTypeEnum = 'hours' | 'days' | 'weeks'

/**
 * * `hours` - Hours
 * * `days` - Days
 * * `weeks` - Weeks
 */
export const WaitTypeEnum = {
  HOURS: 'hours',
  DAYS: 'days',
  WEEKS: 'weeks'
} as const

export type VoipYeastarCredentialsReadable = {
  /**
   * Base API URL. Must end with '/' e.g. https://pbx.example.com/
   */
  VOIP_MAIN_URL: string
  VOIP_USERNAME: string
}

export type VoipYeastarCredentialsWritable = {
  /**
   * Base API URL. Must end with '/' e.g. https://pbx.example.com/
   */
  VOIP_MAIN_URL: string
  VOIP_USERNAME: string
  VOIP_PASSWORD: string
}

export type VoipConfigurationReadable = {
  readonly id: number
  provider: ProviderEnum
  credentials: VoipYeastarCredentialsReadable
  is_active?: boolean
  readonly created_at: string | null
  readonly modified_at: string | null
}

export type VoipConfigurationWritable = {
  provider: ProviderEnum
  credentials: VoipYeastarCredentialsWritable
  is_active?: boolean
}

/**
 * * `yeastar` - Yeastar
 */
export type ProviderEnum = 'yeastar'

/**
 * * `yeastar` - Yeastar
 */
export const ProviderEnum = {
  YEASTAR: 'yeastar'
} as const

export type ViewedLeadReadable = {
  readonly id: number
  lead: ReturnShortLeadReadable
  readonly last_seen: string
  created_by: string
  account: string | null
}

export type ViewedLeadWritable = {
  lead: ReturnShortLeadWritable
  created_by: string
  account: string | null
}

export type ReturnShortLeadReadable = {
  readonly id: number
  owner: ReturnUserReadable
  contact: ShortContactReadable
  /**
   * Denumire Companie sau Persoană
   */
  readonly name: string | null
  /**
   * Date
   */
  readonly data: unknown
  status: ReturnLeadStatusReadable
  /**
   * Adresă
   */
  readonly address: string | null
  attachment: AttachmentReadable
  tags: Array<TagReadable>
}

export type ReturnShortLeadWritable = {
  owner: ReturnUserWritable
  contact: ShortContactWritable
  status: ReturnLeadStatusWritable
  attachment: AttachmentWritable
  tags: Array<TagWritable>
}

export type TagReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  color: string
  readonly account: string | null
}

export type TagWritable = {
  name: string
  color: string
}

export type AttachmentReadable = {
  readonly id: number
  versions: Array<unknown>
  readonly modified_at: string | null
  created_at?: string | null
  file: string
  title?: string
  status?: AttachmentStatusEnum
  type?: AttachmentType
  metadata?: unknown
  account?: string | null
}

export type AttachmentWritable = {
  versions: Array<unknown>
  created_at?: string | null
  file: string
  title?: string
  status?: AttachmentStatusEnum
  type?: AttachmentType
  metadata?: unknown
  account?: string | null
}

/**
 * * `document` - Document
 * * `company_logo` - Logo-ul companiei
 * * `lead_avatar` - Avatarul lead-ului
 * * `import_file` - Fișier Import Lead
 * * `task_file` - Fișier Task
 * * `call_file` - Fișier Apel
 * * `export_file` - Fișier de export
 * * `image` - Imagine
 * * `video` - Video
 * * `audio` - Audio
 */
export type AttachmentType =
  | 'document'
  | 'company_logo'
  | 'lead_avatar'
  | 'import_file'
  | 'task_file'
  | 'call_file'
  | 'export_file'
  | 'image'
  | 'video'
  | 'audio'

/**
 * * `document` - Document
 * * `company_logo` - Logo-ul companiei
 * * `lead_avatar` - Avatarul lead-ului
 * * `import_file` - Fișier Import Lead
 * * `task_file` - Fișier Task
 * * `call_file` - Fișier Apel
 * * `export_file` - Fișier de export
 * * `image` - Imagine
 * * `video` - Video
 * * `audio` - Audio
 */
export const AttachmentType = {
  DOCUMENT: 'document',
  COMPANY_LOGO: 'company_logo',
  LEAD_AVATAR: 'lead_avatar',
  IMPORT_FILE: 'import_file',
  TASK_FILE: 'task_file',
  CALL_FILE: 'call_file',
  EXPORT_FILE: 'export_file',
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio'
} as const

/**
 * * `pending` - În așteptare
 * * `uploaded` - Încărcat
 */
export type AttachmentStatusEnum = 'pending' | 'uploaded'

/**
 * * `pending` - În așteptare
 * * `uploaded` - Încărcat
 */
export const AttachmentStatusEnum = {
  PENDING: 'pending',
  UPLOADED: 'uploaded'
} as const

export type ReturnLeadStatusReadable = {
  readonly id: number
  lead_type: LeadTypeReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  is_conversion?: boolean
  requires_opportunity?: boolean
  requires_refusal_reason?: boolean
  allowed_transition_statuses?: Array<number>
}

export type ReturnLeadStatusWritable = {
  lead_type: LeadTypeWritable
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  is_conversion?: boolean
  requires_opportunity?: boolean
  requires_refusal_reason?: boolean
  allowed_transition_statuses?: Array<number>
}

export type LeadTypeReadable = {
  readonly id: number
  responsible?: string | null
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type LeadTypeWritable = {
  responsible?: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type ShortContactReadable = {
  readonly id: number
  phone_numbers?: Array<ContactPhoneNumberNested>
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name: string
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon fix valid
   */
  readonly landline_number_valid: boolean | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  readonly email_valid: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Cont
   */
  readonly account: string | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type ShortContactWritable = {
  phone_numbers?: Array<ContactPhoneNumberNested>
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name: string
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type ContactPhoneNumberNested = {
  id?: number
  number: number
  is_primary?: boolean
}

export type ReturnUserReadable = {
  id: string
  email: string
  first_name: string
  last_name: string
  readonly name: string
  phone_number?: number | null
  sip?: string | null
  countries?: Array<string> | null
  archived?: boolean
}

export type ReturnUserWritable = {
  id: string
  email: string
  first_name: string
  last_name: string
  phone_number?: number | null
  sip?: string | null
  countries?: Array<string> | null
  archived?: boolean
}

export type Vehicle = {
  registration_number?: string
  brand?: string
  model?: string
}

export type ValuesReadable = {
  id?: number | null
  readonly modified_at: string | null
  readonly created_at: string | null
  function_type?: FunctionTypeEnum
  field_name: string
  label?: string | null
  show_in_chart?: boolean
  readonly account: string | null
  readonly report: number | null
}

export type ValuesWritable = {
  id?: number | null
  function_type?: FunctionTypeEnum
  field_name: string
  label?: string | null
  show_in_chart?: boolean
}

/**
 * * `first` - First
 * * `last` - Last
 * * `sum` - Sum
 * * `count` - Count
 * * `avg` - Average
 * * `conversion` - Conversion
 */
export type FunctionTypeEnum =
  | 'first'
  | 'last'
  | 'sum'
  | 'count'
  | 'avg'
  | 'conversion'

/**
 * * `first` - First
 * * `last` - Last
 * * `sum` - Sum
 * * `count` - Count
 * * `avg` - Average
 * * `conversion` - Conversion
 */
export const FunctionTypeEnum = {
  FIRST: 'first',
  LAST: 'last',
  SUM: 'sum',
  COUNT: 'count',
  AVG: 'avg',
  CONVERSION: 'conversion'
} as const

export type User = {
  first_name: string
  last_name: string
}

export type UniqueFieldsResponse = {
  lead_unique_fields: Array<UniqueFieldDropdown>
  contact_unique_fields: Array<UniqueFieldDropdown>
}

export type UniqueFieldDropdown = {
  key: string
  label: string
}

/**
 * * `text` - Text
 * * `number` - Număr
 * * `boolean` - Casetă de bifare
 * * `date` - Dată
 * * `select` - Selectare
 * * `multiselect` - Selecție multiplă
 */
export type Type83fEnum =
  | 'text'
  | 'number'
  | 'boolean'
  | 'date'
  | 'select'
  | 'multiselect'

/**
 * * `text` - Text
 * * `number` - Număr
 * * `boolean` - Casetă de bifare
 * * `date` - Dată
 * * `select` - Selectare
 * * `multiselect` - Selecție multiplă
 */
export const Type83fEnum = {
  TEXT: 'text',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  DATE: 'date',
  SELECT: 'select',
  MULTISELECT: 'multiselect'
} as const

/**
 * * `csv` - Csv
 * * `excel` - Excel
 */
export type Type5DfEnum = 'csv' | 'excel'

/**
 * * `csv` - Csv
 * * `excel` - Excel
 */
export const Type5DfEnum = {
  CSV: 'csv',
  EXCEL: 'excel'
} as const

/**
 * * `scheduled` - Scheduled
 * * `manual` - Manual
 */
export type TriggerEnum = 'scheduled' | 'manual'

/**
 * * `scheduled` - Scheduled
 * * `manual` - Manual
 */
export const TriggerEnum = {
  SCHEDULED: 'scheduled',
  MANUAL: 'manual'
} as const

export type TotalsField = {
  label: string
  value: number
}

export type TopUserReadable = {
  id: string
  readonly name: string
  count?: number
}

export type TopUserWritable = {
  id: string
  count?: number
}

export type TopProductsExportRequest = {
  date_from: string
  date_to: string
  category?: number | null
  owner?: string | null
  pipeline?: number | null
  status?: number | null
  ordering?: OrderingEnum
  limit?: number
  currency?: number | null
  format?: FormatEnum
}

/**
 * * `csv` - Csv
 * * `xlsx` - Xlsx
 */
export type FormatEnum = 'csv' | 'xlsx'

/**
 * * `csv` - Csv
 * * `xlsx` - Xlsx
 */
export const FormatEnum = {
  CSV: 'csv',
  XLSX: 'xlsx'
} as const

/**
 * * `total_value` - total_value
 * * `-total_value` - -total_value
 * * `opportunity_count` - opportunity_count
 * * `-opportunity_count` - -opportunity_count
 */
export type OrderingEnum =
  | 'total_value'
  | '-total_value'
  | 'opportunity_count'
  | '-opportunity_count'

/**
 * * `total_value` - total_value
 * * `-total_value` - -total_value
 * * `opportunity_count` - opportunity_count
 * * `-opportunity_count` - -opportunity_count
 */
export const OrderingEnum = {
  TOTAL_VALUE: 'total_value',
  '-TOTAL_VALUE': '-total_value',
  OPPORTUNITY_COUNT: 'opportunity_count',
  '-OPPORTUNITY_COUNT': '-opportunity_count'
} as const

export type TopProductResponse = {
  products: Array<TopProductItem>
  total_value: number
}

export type TopProductItem = {
  product_id: number
  product_name: string
  category_id: number | null
  category_name: string | null
  currency?: string | null
  opportunity_count: number
  total_value: number
}

export type TasksReadable = {
  past_tasks: DashboardTaskReadable
  current_tasks: DashboardTaskReadable
  future_tasks: DashboardTaskReadable
}

export type TasksWritable = {
  past_tasks: DashboardTaskWritable
  current_tasks: DashboardTaskWritable
  future_tasks: DashboardTaskWritable
}

export type DashboardTaskReadable = {
  total_tasks: number
  tasks: Array<TaskReadable>
}

export type DashboardTaskWritable = {
  total_tasks: number
  tasks: Array<TaskWritable>
}

export type TaskReadable = {
  readonly id: number
  status?: number
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Titlu
   */
  title: string
  /**
   * Repetat
   */
  repeated?: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Termen limită
   */
  deadline?: string | null
  /**
   * Finalizat la
   */
  completed_at?: string | null
  /**
   * Este reminder
   */
  is_reminder?: boolean
  /**
   * Memento
   */
  reminder?: string
  /**
   * Memento după zile
   */
  reminder_after_days?: number | null
  /**
   * Prioritate
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Număr de așteptare
   */
  waiting_count?: number | null
  /**
   * ID sarcină calendar
   */
  calendar_task_id?: number | null
  /**
   * Creează eveniment Outlook
   */
  create_outlook_event?: boolean
  /**
   * ID eveniment Outlook
   */
  outlook_event_id?: string | null
  /**
   * Tip
   */
  type?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Pasul secvenței
   */
  sequence_step?: number | null
  /**
   * Responsabil
   */
  owner?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  client?: number | null
}

export type TaskWritable = {
  status?: number
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Titlu
   */
  title: string
  /**
   * Repetat
   */
  repeated?: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Termen limită
   */
  deadline?: string | null
  /**
   * Finalizat la
   */
  completed_at?: string | null
  /**
   * Este reminder
   */
  is_reminder?: boolean
  /**
   * Memento
   */
  reminder?: string
  /**
   * Memento după zile
   */
  reminder_after_days?: number | null
  /**
   * Prioritate
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Număr de așteptare
   */
  waiting_count?: number | null
  /**
   * ID sarcină calendar
   */
  calendar_task_id?: number | null
  /**
   * Creează eveniment Outlook
   */
  create_outlook_event?: boolean
  /**
   * ID eveniment Outlook
   */
  outlook_event_id?: string | null
  /**
   * Tip
   */
  type?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Pasul secvenței
   */
  sequence_step?: number | null
  /**
   * Responsabil
   */
  owner?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  client?: number | null
}

export type TaskTypeReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code?: string | null
  allow_manual_creation?: boolean
  readonly account: string | null
}

export type TaskTypeWritable = {
  name: string
  code?: string | null
  allow_manual_creation?: boolean
}

export type TaskStatusUpdateReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly code: string
  color?: string
  order: number
  is_active?: boolean
  readonly account: string | null
}

export type TaskStatusUpdateWritable = {
  name: string
  color?: string
  order: number
  is_active?: boolean
}

export type TaskStatusRetrieveReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  order: number
  is_active?: boolean
  readonly account: string | null
}

export type TaskStatusRetrieveWritable = {
  name: string
  code: string
  color?: string
  order: number
  is_active?: boolean
}

export type TaskStatusCreateReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  order: number
  is_active?: boolean
}

export type TaskStatusCreateWritable = {
  name: string
  code: string
  color?: string
  order: number
  is_active?: boolean
}

export type TaskKanbanReadable = {
  readonly title: string
  /**
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  readonly priority: number | null
  readonly deadline: string | null
  owner: ReturnUserReadable
  type: ReturnShortTaskTypeReadable
  status: TaskStatusRetrieveReadable
  readonly created_at: string | null
  readonly modified_at: string | null
}

export type TaskKanbanWritable = {
  owner: ReturnUserWritable
  type: ReturnShortTaskTypeWritable
  status: TaskStatusRetrieveWritable
}

export type ReturnShortTaskTypeReadable = {
  readonly id: number
  name: string
  code?: string | null
  readonly form: Array<{
    [key: string]: string
  }>
}

export type ReturnShortTaskTypeWritable = {
  name: string
  code?: string | null
}

export type SystemTaskTypeReadable = {
  readonly id: number
  readonly name: string
  readonly modified_at: string | null
  readonly created_at: string | null
  code?: string | null
  allow_manual_creation?: boolean
  readonly account: string | null
}

export type SystemTaskTypeWritable = {
  code?: string | null
  allow_manual_creation?: boolean
}

/**
 * * `task` - Task
 * * `outlook` - Outlook
 * * `gmail` - Gmail
 * * `messenger` - Messenger
 */
export type StepTypeEnum = 'task' | 'outlook' | 'gmail' | 'messenger'

/**
 * * `task` - Task
 * * `outlook` - Outlook
 * * `gmail` - Gmail
 * * `messenger` - Messenger
 */
export const StepTypeEnum = {
  TASK: 'task',
  OUTLOOK: 'outlook',
  GMAIL: 'gmail',
  MESSENGER: 'messenger'
} as const

/**
 * * `confirm_imported_file` - Confirm Imported File
 * * `confirm_field_mapping` - Confirm Field Mapping
 * * `check_for_possible_duplicates` - Check For Possible Duplicates
 * * `pipeline_status_mapping` - Pipeline Status Mapping
 * * `start_import` - Start Import
 * * `completed` - Completed
 */
export type StepEnum =
  | 'confirm_imported_file'
  | 'confirm_field_mapping'
  | 'check_for_possible_duplicates'
  | 'pipeline_status_mapping'
  | 'start_import'
  | 'completed'

/**
 * * `confirm_imported_file` - Confirm Imported File
 * * `confirm_field_mapping` - Confirm Field Mapping
 * * `check_for_possible_duplicates` - Check For Possible Duplicates
 * * `pipeline_status_mapping` - Pipeline Status Mapping
 * * `start_import` - Start Import
 * * `completed` - Completed
 */
export const StepEnum = {
  CONFIRM_IMPORTED_FILE: 'confirm_imported_file',
  CONFIRM_FIELD_MAPPING: 'confirm_field_mapping',
  CHECK_FOR_POSSIBLE_DUPLICATES: 'check_for_possible_duplicates',
  PIPELINE_STATUS_MAPPING: 'pipeline_status_mapping',
  START_IMPORT: 'start_import',
  COMPLETED: 'completed'
} as const

export type StepReadable = {
  readonly id: number
  email_message?: string | null
  email_subject?: string | null
  readonly modified_at: string | null
  readonly created_at: string | null
  step_type?: StepTypeEnum
  title: string
  description?: string | null
  number?: number
  wait_time?: number
  wait_type?: WaitTypeEnum
  enabled?: boolean
  readonly account: string | null
  readonly sequence: number
}

export type StepWritable = {
  email_message?: string | null
  email_subject?: string | null
  step_type?: StepTypeEnum
  title: string
  description?: string | null
  number?: number
  wait_time?: number
  wait_type?: WaitTypeEnum
  enabled?: boolean
}

/**
 * * `not_started` - Not Started
 * * `progress` - Progress
 * * `failed` - Failed
 * * `wrong_file` - Wrong File
 * * `completed` - Completed
 */
export type StatusF6fEnum =
  | 'not_started'
  | 'progress'
  | 'failed'
  | 'wrong_file'
  | 'completed'

/**
 * * `not_started` - Not Started
 * * `progress` - Progress
 * * `failed` - Failed
 * * `wrong_file` - Wrong File
 * * `completed` - Completed
 */
export const StatusF6fEnum = {
  NOT_STARTED: 'not_started',
  PROGRESS: 'progress',
  FAILED: 'failed',
  WRONG_FILE: 'wrong_file',
  COMPLETED: 'completed'
} as const

/**
 * * `online` - Online
 * * `offline` - Offline
 */
export type SourceTypeEnum = 'online' | 'offline'

/**
 * * `online` - Online
 * * `offline` - Offline
 */
export const SourceTypeEnum = {
  ONLINE: 'online',
  OFFLINE: 'offline'
} as const

export type SourceShortReadable = {
  readonly id: number
  name: string
  expression?: string | null
  url?: string | null
}

export type SourceShortWritable = {
  name: string
  expression?: string | null
  url?: string | null
}

export type SourceReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug: string | null
  readonly account: string | null
}

export type SourceWritable = {
  name: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug: string | null
}

/**
 * * `inbound` - Inbound
 * * `outbound` - Outbound
 */
export type ChannelEnum = 'inbound' | 'outbound'

/**
 * * `inbound` - Inbound
 * * `outbound` - Outbound
 */
export const ChannelEnum = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound'
} as const

export type ShortTaskTypeReadable = {
  readonly id: number
  name: string
}

export type ShortTaskTypeWritable = {
  name: string
}

export type ShortSeniorJobPositionReadable = {
  readonly id: number
  title: string
}

export type ShortSeniorJobPositionWritable = {
  title: string
}

export type ShortOpportunityReadable = {
  readonly id: number
  /**
   * Nume
   */
  name?: string | null
  /**
   * Valoare
   */
  readonly value: string | null
  currency: CurrencyReadable
  /**
   * Probabilitate
   */
  probability?: number
  contact: ShortContactReadable
  status: OpportunityStatusReadable
  /**
   * Data închiderii
   */
  close_date?: string | null
}

export type ShortOpportunityWritable = {
  /**
   * Nume
   */
  name?: string | null
  currency: CurrencyWritable
  /**
   * Probabilitate
   */
  probability?: number
  contact: ShortContactWritable
  status: OpportunityStatusWritable
  /**
   * Data închiderii
   */
  close_date?: string | null
}

export type OpportunityStatusReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  requires_refusal_reason?: boolean
  requires_contract?: boolean
  pipeline?: number | null
  allowed_transition_statuses?: Array<number>
}

export type OpportunityStatusWritable = {
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  requires_refusal_reason?: boolean
  requires_contract?: boolean
  pipeline?: number | null
  allowed_transition_statuses?: Array<number>
}

export type CurrencyReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  ratio?: number
  name: string
  code?: string | null
  symbol: string
  is_default?: boolean
  readonly account: string | null
}

export type CurrencyWritable = {
  ratio?: number
  name: string
  code?: string | null
  symbol: string
  is_default?: boolean
}

export type ShortJobPositionReadable = {
  readonly id: number
  title: string
  senior_position: ShortSeniorJobPositionReadable
}

export type ShortJobPositionWritable = {
  title: string
  senior_position: ShortSeniorJobPositionWritable
}

export type SettingReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  follow_up_limit?: number
  log_types?: Array<string>
  pbx_value?: number | null
  readonly account: string | null
}

export type SettingWritable = {
  follow_up_limit?: number
  log_types?: Array<string>
  pbx_value?: number | null
}

export type SequenceLead = {
  leads: Array<number>
}

export type SequenceReadable = {
  readonly id: number
  readonly steps_count: number
  readonly stats_leads: number
  readonly stats_active: number
  readonly stats_failed: number
  readonly stats_success: number
  readonly steps: Array<ReturnShortStepReadable>
  readonly modified_at: string | null
  readonly created_at: string | null
  title?: string | null
  readonly account: string | null
}

export type SequenceWritable = {
  title?: string | null
}

export type ReturnShortStepReadable = {
  readonly id: number
  title: string
}

export type ReturnShortStepWritable = {
  title: string
}

export type SeniorJobPositionReadable = {
  readonly id: number
  title: string
  readonly modified_at: string | null
  readonly created_at: string | null
}

export type SeniorJobPositionWritable = {
  title: string
}

export type SalesFunnelShortOpportunityReadable = {
  readonly id: number
  name?: string | null
  readonly value: string | null
  probability?: number
  close_date?: string | null
  currency: SalesFunnelCurrencyReadable
  contact: SalesFunnelShortContactReadable
  status: SalesFunnelOpportunityStatusReadable
}

export type SalesFunnelShortOpportunityWritable = {
  name?: string | null
  probability?: number
  close_date?: string | null
  currency: SalesFunnelCurrencyWritable
  contact: SalesFunnelShortContactWritable
  status: SalesFunnelOpportunityStatusWritable
}

export type SalesFunnelOpportunityStatusReadable = {
  readonly id: number
  name: string
  code: string
}

export type SalesFunnelOpportunityStatusWritable = {
  name: string
  code: string
}

export type SalesFunnelShortContactReadable = {
  readonly id: number
  first_name: string
  last_name?: string | null
  phone_numbers?: Array<ContactPhoneNumberNested>
  job_title?: string | null
}

export type SalesFunnelShortContactWritable = {
  first_name: string
  last_name?: string | null
  phone_numbers?: Array<ContactPhoneNumberNested>
  job_title?: string | null
}

export type SalesFunnelCurrencyReadable = {
  readonly id: number
  name: string
  ratio?: number
  symbol: string
}

export type SalesFunnelCurrencyWritable = {
  name: string
  ratio?: number
  symbol: string
}

export type SalesFunnelReport = {
  id?: number
  name?: string
  code?: number
  count?: number
  conversion_rate?: number
}

export type SalesFunnelReadable = {
  readonly id: number
  attachment: AttachmentReadable
  contact: ReturnContactReadable
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  owner: ReturnUserReadable
  status: ReturnLeadStatusReadable
  /**
   * Ordine în status
   */
  status_order?: string | null
  opportunity: SalesFunnelShortOpportunityReadable
  task: ReturnOpportunityShortTaskReadable
  readonly created_at: string | null
  readonly modified_at: string | null
  country: CountryReadable
  tags: Array<TagReadable>
}

export type SalesFunnelWritable = {
  attachment: AttachmentWritable
  contact: ReturnContactWritable
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  owner: ReturnUserWritable
  status: ReturnLeadStatusWritable
  /**
   * Ordine în status
   */
  status_order?: string | null
  opportunity: SalesFunnelShortOpportunityWritable
  task: ReturnOpportunityShortTaskWritable
  country: CountryWritable
  tags: Array<TagWritable>
}

export type CountryReadable = {
  readonly id: number
  name: string
  code: string
  alpha_3?: string | null
  continent?: string | null
  readonly modified_at: string | null
  readonly created_at: string | null
}

export type CountryWritable = {
  name: string
  code: string
  alpha_3?: string | null
  continent?: string | null
}

export type ReturnOpportunityShortTaskReadable = {
  readonly id: number
  description?: string | null
  title: string
  deadline?: string | null
  status: TaskStatusRetrieveReadable | null
}

export type ReturnOpportunityShortTaskWritable = {
  description?: string | null
  title: string
  deadline?: string | null
  status: TaskStatusRetrieveWritable | null
}

export type ReturnContactReadable = {
  readonly id: number
  phone_numbers?: Array<ContactPhoneNumberNested>
  created_by: User
  job_position: ShortJobPositionReadable
  senior_position: ShortSeniorJobPositionReadable
  opportunities: Array<ContactOpportunityReadable>
  leads: Array<ContactLeadReadable>
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name: string
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon fix valid
   */
  readonly landline_number_valid: boolean | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  readonly email_valid: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Cont
   */
  readonly account: string | null
  client?: number | null
}

export type ReturnContactWritable = {
  phone_numbers?: Array<ContactPhoneNumberNested>
  created_by: User
  job_position: ShortJobPositionWritable
  senior_position: ShortSeniorJobPositionWritable
  opportunities: Array<ContactOpportunityWritable>
  leads: Array<ContactLeadWritable>
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name: string
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type ContactLeadReadable = {
  readonly id: number
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  created_at?: string | null
  old_id?: string | null
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Data schimbării responsabilului
   */
  change_owner_at?: string | null
  /**
   * Scor
   */
  score?: number | null
  linkedin?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Data planificată demo
   */
  planned_demo_date?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  /**
   * Încercări de contact
   */
  contact_attempts?: number
  /**
   * Site valid
   */
  website_valid?: boolean | null
  /**
   * Primul contact
   */
  first_touch_at?: string | null
  /**
   * Ultimul contact
   */
  last_touch_at?: string | null
  /**
   * Data conversiei
   */
  conversion_at?: string | null
  /**
   * Rang
   */
  rank?: number | null
  /**
   * Prioritate
   */
  priority_score?: number
  /**
   * Date
   */
  data?: unknown
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  product_of_interest?: ProductOfInterestEnum | NullEnum | null
  /**
   * Link avatar
   */
  readonly avatar_legacy_url: string | null
  custom_field_values?: unknown
  /**
   * Identification number, e.g. IDNP
   */
  identification_number?: string | null
  /**
   * Filială
   */
  branch?: number | null
  /**
   * Sursă
   */
  source?: number | null
  /**
   * Responsabil
   */
  owner?: string | null
  /**
   * Responsabil anterior
   */
  previous_owner?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  /**
   * Dimensiunea companiei
   */
  size?: number | null
  /**
   * Țară
   */
  country?: number | null
  region?: number | null
  city?: number | null
  /**
   * Industrie
   */
  industry?: number | null
  /**
   * Sub-industrie
   */
  sub_industry?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  /**
   * Contact principal
   */
  primary_contact?: number | null
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Cont
   */
  account?: string | null
  lead_type?: number | null
  client?: number | null
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type ContactLeadWritable = {
  created_at?: string | null
  old_id?: string | null
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Data schimbării responsabilului
   */
  change_owner_at?: string | null
  /**
   * Scor
   */
  score?: number | null
  linkedin?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Data planificată demo
   */
  planned_demo_date?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  /**
   * Încercări de contact
   */
  contact_attempts?: number
  /**
   * Site valid
   */
  website_valid?: boolean | null
  /**
   * Primul contact
   */
  first_touch_at?: string | null
  /**
   * Ultimul contact
   */
  last_touch_at?: string | null
  /**
   * Data conversiei
   */
  conversion_at?: string | null
  /**
   * Rang
   */
  rank?: number | null
  /**
   * Prioritate
   */
  priority_score?: number
  /**
   * Date
   */
  data?: unknown
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  product_of_interest?: ProductOfInterestEnum | NullEnum | null
  custom_field_values?: unknown
  /**
   * Identification number, e.g. IDNP
   */
  identification_number?: string | null
  /**
   * Filială
   */
  branch?: number | null
  /**
   * Sursă
   */
  source?: number | null
  /**
   * Responsabil
   */
  owner?: string | null
  /**
   * Responsabil anterior
   */
  previous_owner?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  /**
   * Dimensiunea companiei
   */
  size?: number | null
  /**
   * Țară
   */
  country?: number | null
  region?: number | null
  city?: number | null
  /**
   * Industrie
   */
  industry?: number | null
  /**
   * Sub-industrie
   */
  sub_industry?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  /**
   * Contact principal
   */
  primary_contact?: number | null
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Cont
   */
  account?: string | null
  lead_type?: number | null
  client?: number | null
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type NullEnum = unknown

export const NullEnum = {} as const

/**
 * * `casco` - CASCO
 */
export type ProductOfInterestEnum = 'casco'

/**
 * * `casco` - CASCO
 */
export const ProductOfInterestEnum = {
  CASCO: 'casco'
} as const

export type ContactOpportunityReadable = {
  readonly id: number
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  readonly value: string | null
  /**
   * Valoare de bază
   */
  value_base?: string
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Identificator
   */
  identifier?: number | null
  /**
   * Probabilitate
   */
  probability?: number
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  readonly account: string | null
  /**
   * Monedă
   */
  currency?: number | null
  contact?: number | null
  /**
   * Produs
   */
  product?: number | null
  lead?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  /**
   * Creat de
   */
  created_by?: string | null
  /**
   * Responsabil
   */
  owner?: string | null
  client?: number | null
  /**
   * Produse
   */
  products?: Array<number>
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type ContactOpportunityWritable = {
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare de bază
   */
  value_base?: string
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Identificator
   */
  identifier?: number | null
  /**
   * Probabilitate
   */
  probability?: number
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Monedă
   */
  currency?: number | null
  contact?: number | null
  /**
   * Produs
   */
  product?: number | null
  lead?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  /**
   * Creat de
   */
  created_by?: string | null
  /**
   * Responsabil
   */
  owner?: string | null
  client?: number | null
  /**
   * Produse
   */
  products?: Array<number>
  /**
   * Etichete
   */
  tags?: Array<number>
}

/**
 * * `APPROVED` - APPROVED
 * * `PENDING` - PENDING
 * * `REJECTED` - REJECTED
 * * `PAUSED` - PAUSED
 * * `DISABLED` - DISABLED
 */
export type ReturnWhatsAppMessageTemplateStatusEnum =
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED'
  | 'PAUSED'
  | 'DISABLED'

/**
 * * `APPROVED` - APPROVED
 * * `PENDING` - PENDING
 * * `REJECTED` - REJECTED
 * * `PAUSED` - PAUSED
 * * `DISABLED` - DISABLED
 */
export const ReturnWhatsAppMessageTemplateStatusEnum = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  PAUSED: 'PAUSED',
  DISABLED: 'DISABLED'
} as const

export type ReturnWhatsAppMessageTemplateReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  meta_template_id: string
  name: string
  language: string
  status?: ReturnWhatsAppMessageTemplateStatusEnum
  category?: CategoryEnum
  sub_category?: string
  parameter_format?: ParameterFormatEnum
  components?: unknown
  readonly account: string | null
  integration: number
}

export type ReturnWhatsAppMessageTemplateWritable = {
  meta_template_id: string
  name: string
  language: string
  status?: ReturnWhatsAppMessageTemplateStatusEnum
  category?: CategoryEnum
  sub_category?: string
  parameter_format?: ParameterFormatEnum
  components?: unknown
  integration: number
}

/**
 * * `POSITIONAL` - POSITIONAL
 * * `NAMED` - NAMED
 */
export type ParameterFormatEnum = 'POSITIONAL' | 'NAMED'

/**
 * * `POSITIONAL` - POSITIONAL
 * * `NAMED` - NAMED
 */
export const ParameterFormatEnum = {
  POSITIONAL: 'POSITIONAL',
  NAMED: 'NAMED'
} as const

/**
 * * `MARKETING` - MARKETING
 * * `UTILITY` - UTILITY
 * * `AUTHENTICATION` - AUTHENTICATION
 */
export type CategoryEnum = 'MARKETING' | 'UTILITY' | 'AUTHENTICATION'

/**
 * * `MARKETING` - MARKETING
 * * `UTILITY` - UTILITY
 * * `AUTHENTICATION` - AUTHENTICATION
 */
export const CategoryEnum = {
  MARKETING: 'MARKETING',
  UTILITY: 'UTILITY',
  AUTHENTICATION: 'AUTHENTICATION'
} as const

/**
 * * `sent` - Trimis
 * * `delivered` - Livrat
 * * `read` - Citit
 * * `failed` - Eșuat
 * * `queued` - În așteptare
 */
export type ReturnWhatsAppMessageStatusEnum =
  | 'sent'
  | 'delivered'
  | 'read'
  | 'failed'
  | 'queued'

/**
 * * `sent` - Trimis
 * * `delivered` - Livrat
 * * `read` - Citit
 * * `failed` - Eșuat
 * * `queued` - În așteptare
 */
export const ReturnWhatsAppMessageStatusEnum = {
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed',
  QUEUED: 'queued'
} as const

/**
 * * `OUTBOUND` - Ieșire
 * * `INBOUND` - Intrare
 */
export type ReturnWhatsAppMessageDirectionEnum = 'OUTBOUND' | 'INBOUND'

/**
 * * `OUTBOUND` - Ieșire
 * * `INBOUND` - Intrare
 */
export const ReturnWhatsAppMessageDirectionEnum = {
  OUTBOUND: 'OUTBOUND',
  INBOUND: 'INBOUND'
} as const

export type ReturnWhatsAppMessageReadable = {
  readonly id: number
  recipient: ContactPhoneReadable
  attachment: AttachmentReadable
  integration: ReturnWhatsAppConfig
  created_by_user: ReturnUserReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  direction: ReturnWhatsAppMessageDirectionEnum
  type: Type3DaEnum
  payload?: unknown
  wa_message_id?: string | null
  recipient_type?: RecipientTypeEnum
  status?: ReturnWhatsAppMessageStatusEnum
  status_synced_at?: string | null
  sent_at?: string | null
  delivered_at?: string | null
  read_at?: string | null
  fail_code?: string | null
  fail_reason?: string | null
  fail_is_retryable?: boolean
  readonly account: string | null
}

export type ReturnWhatsAppMessageWritable = {
  recipient: ContactPhoneWritable
  attachment: AttachmentWritable
  created_by_user: ReturnUserWritable
  direction: ReturnWhatsAppMessageDirectionEnum
  type: Type3DaEnum
  payload?: unknown
  wa_message_id?: string | null
  recipient_type?: RecipientTypeEnum
  status?: ReturnWhatsAppMessageStatusEnum
  status_synced_at?: string | null
  sent_at?: string | null
  delivered_at?: string | null
  read_at?: string | null
  fail_code?: string | null
  fail_reason?: string | null
  fail_is_retryable?: boolean
}

/**
 * * `individual` - individual
 * * `group` - Grup
 */
export type RecipientTypeEnum = 'individual' | 'group'

/**
 * * `individual` - individual
 * * `group` - Grup
 */
export const RecipientTypeEnum = {
  INDIVIDUAL: 'individual',
  GROUP: 'group'
} as const

export type ReturnWhatsAppConfig = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  readonly waba_id: string
  readonly app_id: string
  readonly app_secret: string
  readonly phone_number_id: string
  readonly display_phone_number: string
  readonly access_token: string
  readonly webhook_verify_token: string
  status: Status926Enum
  readonly last_verified_at: string | null
  readonly last_error_code: string | null
  readonly last_error_message: string | null
  readonly account: string | null
  readonly created_by_user: string
  readonly updated_by_user: string | null
}

export type ContactPhoneReadable = {
  readonly id: number
  contact: number
  number: number
  is_primary?: boolean
}

export type ContactPhoneWritable = {
  contact: number
  number: number
  is_primary?: boolean
}

export type ReturnTaskReadable = {
  readonly id: number
  owner: ReturnUserReadable
  created_by: ReturnUserReadable
  opportunity: ReturnShortOpportunityReadable
  lead: ReturnShortLeadReadable
  type: ReturnShortTaskTypeReadable
  status: TaskStatusRetrieveReadable | null
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Titlu
   */
  title: string
  /**
   * Repetat
   */
  repeated?: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Termen limită
   */
  deadline?: string | null
  /**
   * Finalizat la
   */
  completed_at?: string | null
  /**
   * Este reminder
   */
  is_reminder?: boolean
  /**
   * Memento
   */
  reminder?: string
  /**
   * Memento după zile
   */
  reminder_after_days?: number | null
  /**
   * Prioritate
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  /**
   * Ordine în status
   */
  status_order: string | null
  /**
   * Număr de așteptare
   */
  waiting_count?: number | null
  /**
   * ID sarcină calendar
   */
  calendar_task_id?: number | null
  /**
   * Creează eveniment Outlook
   */
  create_outlook_event?: boolean
  /**
   * ID eveniment Outlook
   */
  outlook_event_id?: string | null
  readonly account: string | null
  /**
   * Pasul secvenței
   */
  sequence_step?: number | null
  client?: number | null
}

export type ReturnTaskWritable = {
  owner: ReturnUserWritable
  created_by: ReturnUserWritable
  opportunity: ReturnShortOpportunityWritable
  lead: ReturnShortLeadWritable
  type: ReturnShortTaskTypeWritable
  status: TaskStatusRetrieveWritable | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Titlu
   */
  title: string
  /**
   * Repetat
   */
  repeated?: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Termen limită
   */
  deadline?: string | null
  /**
   * Finalizat la
   */
  completed_at?: string | null
  /**
   * Este reminder
   */
  is_reminder?: boolean
  /**
   * Memento
   */
  reminder?: string
  /**
   * Memento după zile
   */
  reminder_after_days?: number | null
  /**
   * Prioritate
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  /**
   * Ordine în status
   */
  status_order: string | null
  /**
   * Număr de așteptare
   */
  waiting_count?: number | null
  /**
   * ID sarcină calendar
   */
  calendar_task_id?: number | null
  /**
   * Creează eveniment Outlook
   */
  create_outlook_event?: boolean
  /**
   * ID eveniment Outlook
   */
  outlook_event_id?: string | null
  /**
   * Pasul secvenței
   */
  sequence_step?: number | null
  client?: number | null
}

export type ReturnShortOpportunityReadable = {
  readonly id: number
  readonly currency: string
  /**
   * Valoare
   */
  readonly value: string | null
  lead?: number | null
  client?: number | null
}

export type ReturnShortOpportunityWritable = {
  lead?: number | null
  client?: number | null
}

export type ReturnSuccess = {
  success?: boolean
  message?: string
}

export type ReturnSubIndustryReadable = {
  readonly id: number
  industry: IndustryReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly account: string | null
}

export type ReturnSubIndustryWritable = {
  industry: IndustryWritable
  name: string
}

export type IndustryReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly account: string | null
}

export type IndustryWritable = {
  name: string
}

export type ReturnStepReadable = {
  readonly id: number
  readonly stats_leads: number
  readonly stats_active: number
  readonly stats_failed: number
  readonly stats_success: number
  readonly modified_at: string | null
  readonly created_at: string | null
  step_type?: StepTypeEnum
  title: string
  description?: string | null
  number: number
  wait_time?: number
  wait_type?: WaitTypeEnum
  enabled?: boolean
  email_message?: string | null
  email_subject?: string | null
  readonly account: string | null
  sequence: number
}

export type ReturnStepWritable = {
  step_type?: StepTypeEnum
  title: string
  description?: string | null
  number: number
  wait_time?: number
  wait_type?: WaitTypeEnum
  enabled?: boolean
  email_message?: string | null
  email_subject?: string | null
  sequence: number
}

export type ReturnShortTaskReadable = {
  readonly id: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Titlu
   */
  title: string
  type: ReturnShortTaskTypeReadable
  lead: ReturnShortLeadReadable
  /**
   * Finalizat la
   */
  completed_at?: string | null
  owner: ReturnUserReadable
  /**
   * Termen limită
   */
  deadline?: string | null
  status: TaskStatusRetrieveReadable | null
}

export type ReturnShortTaskWritable = {
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Titlu
   */
  title: string
  type: ReturnShortTaskTypeWritable
  lead: ReturnShortLeadWritable
  /**
   * Finalizat la
   */
  completed_at?: string | null
  owner: ReturnUserWritable
  /**
   * Termen limită
   */
  deadline?: string | null
  status: TaskStatusRetrieveWritable | null
}

export type ReturnShortProductReadable = {
  readonly id: number
  name: string
}

export type ReturnShortProductWritable = {
  name: string
}

export type ReturnShortLeadTypeReadable = {
  name: string
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly account: string | null
}

export type ReturnShortLeadTypeWritable = {
  name: string
}

export type ReturnShortLeadSequenceReadable = {
  current_step: StepReadable
  /**
   * Stare
   */
  status?: LeadSequenceStatus
  lead: ReturnShortLeadReadable
}

export type ReturnShortLeadSequenceWritable = {
  current_step: StepWritable
  /**
   * Stare
   */
  status?: LeadSequenceStatus
  lead: ReturnShortLeadWritable
}

/**
 * * `active` - Activ
 * * `failed` - Eșuat
 * * `success` - Succes
 */
export type LeadSequenceStatus = 'active' | 'failed' | 'success'

/**
 * * `active` - Activ
 * * `failed` - Eșuat
 * * `success` - Succes
 */
export const LeadSequenceStatus = {
  ACTIVE: 'active',
  FAILED: 'failed',
  SUCCESS: 'success'
} as const

export type ReturnShortCurrencyReadable = {
  readonly id: number
  name: string
  symbol: string
}

export type ReturnShortCurrencyWritable = {
  name: string
  symbol: string
}

export type ReturnShortContractReadable = {
  readonly id: number
  /**
   * Număr
   */
  number: string
  /**
   * Semnat la
   */
  signed_at?: string | null
  /**
   * Valoare
   */
  value: number
  product: ProductReadable
  /**
   * Termen limită la
   */
  deadline_at?: string | null
  currency: CurrencyReadable
  owner: ReturnUserReadable
}

export type ReturnShortContractWritable = {
  /**
   * Număr
   */
  number: string
  /**
   * Semnat la
   */
  signed_at?: string | null
  /**
   * Valoare
   */
  value: number
  product: ProductWritable
  /**
   * Termen limită la
   */
  deadline_at?: string | null
  currency: CurrencyWritable
  owner: ReturnUserWritable
}

export type ProductReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  sku?: string
  description?: string
  price?: string | null
  is_active?: boolean
  source?: string | null
  readonly account: string | null
  category?: number | null
  uom?: number | null
  currency?: number | null
}

export type ProductWritable = {
  name: string
  code: string
  sku?: string
  description?: string
  price?: string | null
  is_active?: boolean
  source?: string | null
  category?: number | null
  uom?: number | null
  currency?: number | null
}

export type ReturnShortContactReadable = {
  readonly id: number
  /**
   * Nume
   */
  first_name: string
  /**
   * Prenume
   */
  last_name?: string | null
  email?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
}

export type ReturnShortContactWritable = {
  /**
   * Nume
   */
  first_name: string
  /**
   * Prenume
   */
  last_name?: string | null
  email?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
}

export type ReturnShortCallReadable = {
  readonly id: number
  attachment: AttachmentReadable
}

export type ReturnShortCallWritable = {
  attachment: AttachmentWritable
}

export type ReturnSalesReport = {
  id: number
  name: string
  code: string
  count: number
  conversion_rate: number
}

export type ReturnReportsWeightDiagram = {
  total: number
  data: Array<DataPoint>
}

export type DataPoint = {
  name: string
  value: number
}

export type ReturnReportsTypes = {
  results: Array<string>
}

export type ReturnReportsTableReadable = {
  count: number
  total_pages: number
  per_page: number
  current_page: number
  results: Array<{
    [key: string]: string
  }>
  headers: Array<HeadersField>
  filters: Array<ReportFilterReadable>
  totals: Array<TotalsField>
}

export type ReturnReportsTableWritable = {
  count: number
  total_pages: number
  per_page: number
  current_page: number
  results: Array<{
    [key: string]: string
  }>
  headers: Array<HeadersField>
  filters: Array<ReportFilterWritable>
  totals: Array<TotalsField>
}

export type ReportFilterReadable = {
  id?: number | null
  field_type: {
    type?:
      | 'Input'
      | 'Date'
      | 'DateTime'
      | 'Radio'
      | 'Select'
      | 'File'
      | 'PhoneNumber'
      | 'Number'
      | 'Link'
    name?: string
    label?: string
    filter_name?: string
    props?:
      | {
          rule?: {
            [key: string]: unknown
          } | null
        }
      | {
          options?: Array<string> | null
          rule?: {
            [key: string]: unknown
          } | null
        }
      | {
          api?: string | null
          rule?: {
            [key: string]: unknown
          } | null
        }
      | null
  }
  readonly modified_at: string | null
  readonly created_at: string | null
  field_name: string
  label?: string | null
  filter_operator?: FilterOperatorEnum | NullEnum | null
  filter_value?: Array<string> | null
  readonly account: string | null
  readonly report: number | null
}

export type ReportFilterWritable = {
  id?: number | null
  field_type: {
    type?:
      | 'Input'
      | 'Date'
      | 'DateTime'
      | 'Radio'
      | 'Select'
      | 'File'
      | 'PhoneNumber'
      | 'Number'
      | 'Link'
    name?: string
    label?: string
    filter_name?: string
    props?:
      | {
          rule?: {
            [key: string]: unknown
          } | null
        }
      | {
          options?: Array<string> | null
          rule?: {
            [key: string]: unknown
          } | null
        }
      | {
          api?: string | null
          rule?: {
            [key: string]: unknown
          } | null
        }
      | null
  }
  field_name: string
  label?: string | null
  filter_operator?: FilterOperatorEnum | NullEnum | null
  filter_value?: Array<string> | null
}

/**
 * * `lt` - Lt
 * * `lte` - Lte
 * * `gt` - Gt
 * * `gte` - Gte
 * * `isnull` - Is Null
 * * `in` - In
 * * `equal` - Equal
 * * `range` - Range
 * * `icontains` - Contains
 */
export type FilterOperatorEnum =
  | 'lt'
  | 'lte'
  | 'gt'
  | 'gte'
  | 'isnull'
  | 'in'
  | 'equal'
  | 'range'
  | 'icontains'

/**
 * * `lt` - Lt
 * * `lte` - Lte
 * * `gt` - Gt
 * * `gte` - Gte
 * * `isnull` - Is Null
 * * `in` - In
 * * `equal` - Equal
 * * `range` - Range
 * * `icontains` - Contains
 */
export const FilterOperatorEnum = {
  LT: 'lt',
  LTE: 'lte',
  GT: 'gt',
  GTE: 'gte',
  ISNULL: 'isnull',
  IN: 'in',
  EQUAL: 'equal',
  RANGE: 'range',
  ICONTAINS: 'icontains'
} as const

export type HeadersField = {
  field_name: string
  label: string
  field_type: Fields
}

export type Fields = {
  type: string
  name: string
  label: string
  filter_name: string
  props: PropField
}

export type PropField = {
  api?: string
  rule?: string
  options: Array<[string, string]>
}

export type ReturnReportsChart = {
  date: string
  value: number
}

export type ReturnProfileReadable = {
  id: string
  email: string
  readonly name: string
  readonly is_microsoft_logged: boolean
  readonly is_gmail_logged: boolean
  readonly is_messenger_logged: boolean
}

export type ReturnProfileWritable = {
  id: string
  email: string
}

export type ReturnProductReadable = {
  readonly id: number
  name: string
  code: string
  sku?: string
  description?: string
  price?: string | null
  is_active?: boolean
  source?: string | null
  currency: ProductCurrency
  uom: ProductUoMReadable
  category: ProductCategoryReadable
  readonly account: string | null
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly line_total: string
  readonly opportunity_count: number
}

export type ReturnProductWritable = {
  name: string
  code: string
  sku?: string
  description?: string
  price?: string | null
  is_active?: boolean
  source?: string | null
  uom: ProductUoMWritable
  category: ProductCategoryWritable
}

export type ProductCategoryReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  description?: string
}

export type ProductCategoryWritable = {
  name: string
  code: string
  description?: string
}

export type ProductUoMReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  code: string
  name: string
  description?: string
}

export type ProductUoMWritable = {
  code: string
  name: string
  description?: string
}

export type ProductCurrency = {
  readonly id: number
  readonly name: string
  readonly symbol: string
  readonly ratio: number
  readonly is_default: boolean
}

export type ReturnOwnerReadable = {
  id: string
  email: string
  readonly name: string
}

export type ReturnOwnerWritable = {
  id: string
  email: string
}

export type ReturnOutlookMailboxReadable = {
  readonly id: number
  from_email?: string | null
  from_name: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  readonly auth_link: string
}

export type ReturnOutlookMailboxWritable = {
  from_email?: string | null
  from_name: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
}

/**
 * * `connected` - Connected
 * * `logged_out` - Logged Out
 */
export type MailboxStatus = 'connected' | 'logged_out'

/**
 * * `connected` - Connected
 * * `logged_out` - Logged Out
 */
export const MailboxStatus = {
  CONNECTED: 'connected',
  LOGGED_OUT: 'logged_out'
} as const

/**
 * * `outlook` - Outlook
 * * `gmail` - Gmail
 * * `messenger` - Messenger
 */
export type MailboxTypeEnum = 'outlook' | 'gmail' | 'messenger'

/**
 * * `outlook` - Outlook
 * * `gmail` - Gmail
 * * `messenger` - Messenger
 */
export const MailboxTypeEnum = {
  OUTLOOK: 'outlook',
  GMAIL: 'gmail',
  MESSENGER: 'messenger'
} as const

export type ReturnOpportunityStatusReadable = {
  readonly id: number
  pipeline: ReturnOpportunityPipelineNomenclatorReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  requires_refusal_reason?: boolean
  requires_contract?: boolean
  allowed_transition_statuses?: Array<number>
}

export type ReturnOpportunityStatusWritable = {
  pipeline: ReturnOpportunityPipelineNomenclatorWritable
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  requires_refusal_reason?: boolean
  requires_contract?: boolean
  allowed_transition_statuses?: Array<number>
}

export type ReturnOpportunityPipelineNomenclatorReadable = {
  readonly id: number
  responsible: ReturnUserReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  readonly account: string | null
}

export type ReturnOpportunityPipelineNomenclatorWritable = {
  responsible: ReturnUserWritable
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type ReturnOpportunityProductReadable = {
  readonly id: number
  opportunity: ReturnOpportunityReadable
  lead: ReturnLeadReadable
  currency: CurrencyReadable
  uom: ProductUoMReadable
  product: ReturnProductReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * Cantitate
   */
  quantity?: string | null
  /**
   * Preț personalizat
   */
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  readonly account: string | null
}

export type ReturnOpportunityProductWritable = {
  opportunity: ReturnOpportunityWritable
  lead: ReturnLeadWritable
  currency: CurrencyWritable
  uom: ProductUoMWritable
  product: ReturnProductWritable
  /**
   * Cantitate
   */
  quantity?: string | null
  /**
   * Preț personalizat
   */
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
}

export type ReturnLeadReadable = {
  readonly id: number
  /**
   * Cont
   */
  readonly account: string | null
  attachment: AttachmentReadable
  created_by: ReturnUserReadable
  owner: ReturnUserReadable
  contact: ReturnContactReadable
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  source: SourceShortReadable
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  status: ReturnLeadStatusReadable
  /**
   * Comentariu
   */
  comment?: string | null
  industry: IndustryReadable
  sub_industry: ReturnSubIndustryReadable
  size: CompanySizeReadable
  reason: ReasonReadable
  linkedin?: string | null
  country: CountryReadable
  region: RegionReadable
  city: CityReadable
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  tags: Array<TagReadable>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  readonly deleted_at: string | null
  readonly match_fields: Array<string>
  lead_type: ReturnShortLeadTypeReadable
  /**
   * Identification number, e.g. IDNP
   */
  identification_number?: string | null
  product_of_interest?: ProductOfInterestEnum | NullEnum | null
}

export type ReturnLeadWritable = {
  attachment: AttachmentWritable
  created_by: ReturnUserWritable
  owner: ReturnUserWritable
  contact: ReturnContactWritable
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  source: SourceShortWritable
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  status: ReturnLeadStatusWritable
  /**
   * Comentariu
   */
  comment?: string | null
  industry: IndustryWritable
  sub_industry: ReturnSubIndustryWritable
  size: CompanySizeWritable
  reason: ReasonWritable
  linkedin?: string | null
  country: CountryWritable
  region: RegionWritable
  city: CityWritable
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  tags: Array<TagWritable>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  lead_type: ReturnShortLeadTypeWritable
  /**
   * Identification number, e.g. IDNP
   */
  identification_number?: string | null
  product_of_interest?: ProductOfInterestEnum | NullEnum | null
}

export type CityReadable = {
  readonly id: number
  name: string
  /**
   * CUATM code (CodStatistic)
   */
  code: string | null
  readonly modified_at: string | null
  created_at?: string | null
  region: number
  account: string | null
}

export type CityWritable = {
  name: string
  /**
   * CUATM code (CodStatistic)
   */
  code: string | null
  created_at?: string | null
  region: number
  account: string | null
}

export type RegionReadable = {
  readonly id: number
  name: string
  /**
   * CUATM code (CodStatistic)
   */
  code: string | null
  readonly modified_at: string | null
  created_at?: string | null
  country: number
  account: string | null
}

export type RegionWritable = {
  name: string
  /**
   * CUATM code (CodStatistic)
   */
  code: string | null
  created_at?: string | null
  country: number
  account: string | null
}

export type ReasonReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly account: string | null
}

export type ReasonWritable = {
  name: string
}

export type CompanySizeReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly account: string | null
}

export type CompanySizeWritable = {
  name: string
}

export type ReturnOpportunityReadable = {
  readonly id: number
  owner: ReturnUserReadable
  products: Array<ProductReadable>
  product: ProductReadable
  reason: OpportunityReasonReadable
  currency: CurrencyReadable
  contact: ShortContactReadable
  status: ReturnOpportunityStatusReadable
  lead: ReturnLeadReadable | null
  tags: Array<TagReadable>
  client: ClientShortReadable | null
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  readonly value: string | null
  /**
   * Valoare de bază
   */
  readonly value_base: string
  /**
   * Ordine în status
   */
  readonly status_order: string | null
  /**
   * Identificator
   */
  readonly identifier: number | null
  /**
   * Probabilitate
   */
  probability?: number
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  readonly account: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  contracts: Array<ReturnShortContractReadable> | null
}

export type ReturnOpportunityWritable = {
  owner: ReturnUserWritable
  products: Array<ProductWritable>
  product: ProductWritable
  reason: OpportunityReasonWritable
  currency: CurrencyWritable
  contact: ShortContactWritable
  status: ReturnOpportunityStatusWritable
  lead: ReturnLeadWritable | null
  tags: Array<TagWritable>
  client: ClientShortWritable | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Probabilitate
   */
  probability?: number
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Creat de
   */
  created_by?: string | null
  contracts: Array<ReturnShortContractWritable> | null
}

export type ClientShortReadable = {
  readonly id: number
  name: string | null
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly account: string | null
}

export type ClientShortWritable = {
  name: string | null
}

export type OpportunityReasonReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly account: string | null
}

export type OpportunityReasonWritable = {
  name: string
}

/**
 * * `task` - Task
 * * `task_change` - Task Change
 * * `opportunity_change` - Opportunity Change
 * * `document_change` - Document Change
 * * `lead_change` - Lead Change
 * * `lead_status_changed` - Lead Status Changed
 * * `lead_reactivated` - Lead Reactivated
 * * `lead_deleted` - Lead Deleted
 * * `contact_change` - Contact Change
 * * `contract_change` - Contract Change
 * * `si_asig_sync` - Si Asig Sync
 * * `lead` - Lead
 * * `opportunity` - Opportunity
 * * `contract` - Contract
 * * `client` - Client
 * * `chat` - Chat
 * * `call` - Call
 * * `email` - Email
 * * `meeting` - Meeting
 * * `note` - Note
 * * `lead_sequence_change` - Lead Sequence Change
 * * `error` - Error
 * * `form` - Form
 * * `lead_generation` - Lead Generation
 */
export type ReturnLogsTypeEnum =
  | 'task'
  | 'task_change'
  | 'opportunity_change'
  | 'document_change'
  | 'lead_change'
  | 'lead_status_changed'
  | 'lead_reactivated'
  | 'lead_deleted'
  | 'contact_change'
  | 'contract_change'
  | 'si_asig_sync'
  | 'lead'
  | 'opportunity'
  | 'contract'
  | 'client'
  | 'chat'
  | 'call'
  | 'email'
  | 'meeting'
  | 'note'
  | 'lead_sequence_change'
  | 'error'
  | 'form'
  | 'lead_generation'

/**
 * * `task` - Task
 * * `task_change` - Task Change
 * * `opportunity_change` - Opportunity Change
 * * `document_change` - Document Change
 * * `lead_change` - Lead Change
 * * `lead_status_changed` - Lead Status Changed
 * * `lead_reactivated` - Lead Reactivated
 * * `lead_deleted` - Lead Deleted
 * * `contact_change` - Contact Change
 * * `contract_change` - Contract Change
 * * `si_asig_sync` - Si Asig Sync
 * * `lead` - Lead
 * * `opportunity` - Opportunity
 * * `contract` - Contract
 * * `client` - Client
 * * `chat` - Chat
 * * `call` - Call
 * * `email` - Email
 * * `meeting` - Meeting
 * * `note` - Note
 * * `lead_sequence_change` - Lead Sequence Change
 * * `error` - Error
 * * `form` - Form
 * * `lead_generation` - Lead Generation
 */
export const ReturnLogsTypeEnum = {
  TASK: 'task',
  TASK_CHANGE: 'task_change',
  OPPORTUNITY_CHANGE: 'opportunity_change',
  DOCUMENT_CHANGE: 'document_change',
  LEAD_CHANGE: 'lead_change',
  LEAD_STATUS_CHANGED: 'lead_status_changed',
  LEAD_REACTIVATED: 'lead_reactivated',
  LEAD_DELETED: 'lead_deleted',
  CONTACT_CHANGE: 'contact_change',
  CONTRACT_CHANGE: 'contract_change',
  SI_ASIG_SYNC: 'si_asig_sync',
  LEAD: 'lead',
  OPPORTUNITY: 'opportunity',
  CONTRACT: 'contract',
  CLIENT: 'client',
  CHAT: 'chat',
  CALL: 'call',
  EMAIL: 'email',
  MEETING: 'meeting',
  NOTE: 'note',
  LEAD_SEQUENCE_CHANGE: 'lead_sequence_change',
  ERROR: 'error',
  FORM: 'form',
  LEAD_GENERATION: 'lead_generation'
} as const

/**
 * * `incoming` - Incoming
 * * `outgoing` - Outgoing
 */
export type ReturnLogsDirectionEnum = 'incoming' | 'outgoing'

/**
 * * `incoming` - Incoming
 * * `outgoing` - Outgoing
 */
export const ReturnLogsDirectionEnum = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing'
} as const

export type ReturnLogsReadable = {
  readonly id: number
  contact: ShortContactReadable
  created_by: ReturnUserReadable
  opportunity: ReturnShortOpportunityReadable
  lead: ReturnShortLeadReadable
  task: ReturnShortTaskReadable
  call: ReturnShortCallReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  old_id?: string | null
  description: string
  /**
   * Description [ro]
   */
  description_ro?: string | null
  /**
   * Description [ru]
   */
  description_ru?: string | null
  /**
   * Description [en]
   */
  description_en?: string | null
  /**
   * Description [it]
   */
  description_it?: string | null
  full_description?: string | null
  is_hidden?: boolean
  type: ReturnLogsTypeEnum
  action: ActionEnum
  meeting_with?: Array<string>
  meeting_on?: string | null
  outlook_event_id?: string | null
  direction?: ReturnLogsDirectionEnum | NullEnum | null
  comment?: string | null
  additional_data?: unknown
  email_id?: string | null
  is_pinned?: boolean
  readonly account: string | null
  sequence_step?: number | null
  lead_sequence?: number | null
}

export type ReturnLogsWritable = {
  contact: ShortContactWritable
  created_by: ReturnUserWritable
  opportunity: ReturnShortOpportunityWritable
  lead: ReturnShortLeadWritable
  task: ReturnShortTaskWritable
  old_id?: string | null
  description: string
  /**
   * Description [ro]
   */
  description_ro?: string | null
  /**
   * Description [ru]
   */
  description_ru?: string | null
  /**
   * Description [en]
   */
  description_en?: string | null
  /**
   * Description [it]
   */
  description_it?: string | null
  full_description?: string | null
  is_hidden?: boolean
  type: ReturnLogsTypeEnum
  action: ActionEnum
  meeting_with?: Array<string>
  meeting_on?: string | null
  outlook_event_id?: string | null
  direction?: ReturnLogsDirectionEnum | NullEnum | null
  comment?: string | null
  additional_data?: unknown
  email_id?: string | null
  is_pinned?: boolean
  sequence_step?: number | null
  lead_sequence?: number | null
}

/**
 * * `created` - Created
 * * `updated` - Updated
 * * `completed` - Completed
 * * `deleted` - Deleted
 * * `expired` - Expired
 * * `rejected` - Rejected
 */
export type ActionEnum =
  | 'created'
  | 'updated'
  | 'completed'
  | 'deleted'
  | 'expired'
  | 'rejected'

/**
 * * `created` - Created
 * * `updated` - Updated
 * * `completed` - Completed
 * * `deleted` - Deleted
 * * `expired` - Expired
 * * `rejected` - Rejected
 */
export const ActionEnum = {
  CREATED: 'created',
  UPDATED: 'updated',
  COMPLETED: 'completed',
  DELETED: 'deleted',
  EXPIRED: 'expired',
  REJECTED: 'rejected'
} as const

export type ReturnLogoutMailbox = {
  logout_link: string
}

export type ReturnLoginMailbox = {
  success?: boolean
  message?: string
  auth_link: string
}

export type ReturnLeadTypeReadable = {
  readonly id: number
  responsible: ReturnUserReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  readonly account: string | null
}

export type ReturnLeadTypeWritable = {
  responsible: ReturnUserWritable
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type ReturnJobPositionReadable = {
  readonly id: number
  senior_position: SeniorJobPositionReadable
  title: string
}

export type ReturnJobPositionWritable = {
  senior_position: SeniorJobPositionWritable
  title: string
}

export type ReturnImportPreview = {
  /**
   * This data contains fields from file imported to preview. It has the json representation of a csv file as a nested list of strings. The first list has the column names, and every list after that has the values
   */
  data: Array<Array<string>>
}

export type ReturnImportReadable = {
  readonly id: number
  type?: Type5DfEnum
  notes?: string | null
  headers?: {
    lead_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
    contact_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
  }
  attachment: AttachmentReadable
  owner: ReturnOwnerReadable
  create_type?: CreateTypeEnum
  unique_verify?: Array<string>
  step?: StepEnum
  progress?: number
  status?: StatusF6fEnum
  lead_type?: number | null
  status_mapping?: {
    [key: string]: number
  }
  status_column?: number
  duplicates?: unknown
  existing_duplicates?: unknown
  pipeline?: number
}

export type ReturnImportWritable = {
  type?: Type5DfEnum
  notes?: string | null
  headers?: {
    lead_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
    contact_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
  }
  attachment: AttachmentWritable
  owner: ReturnOwnerWritable
  create_type?: CreateTypeEnum
  unique_verify?: Array<string>
  step?: StepEnum
  progress?: number
  status?: StatusF6fEnum
  lead_type?: number | null
  status_mapping?: {
    [key: string]: number
  }
  status_column?: number
  duplicates?: unknown
  existing_duplicates?: unknown
  pipeline?: number
}

/**
 * * `create_records` - Create Records
 * * `create_update_records` - Create Update Records
 */
export type CreateTypeEnum = 'create_records' | 'create_update_records'

/**
 * * `create_records` - Create Records
 * * `create_update_records` - Create Update Records
 */
export const CreateTypeEnum = {
  CREATE_RECORDS: 'create_records',
  CREATE_UPDATE_RECORDS: 'create_update_records'
} as const

export type ReturnFields = {
  fields: Array<Fields>
}

export type ReturnEmailAuthUrl = {
  auth_link: string
}

export type ReturnDynamicSearchList = {
  count: number
  total_pages: number
  per_page: number
  current_page: number
  results: Array<{
    [key: string]: string
  }>
  headers: Array<unknown>
}

export type ReturnDocumentReadable = {
  readonly id: number
  attachment: AttachmentReadable
  lead: ReturnShortLeadReadable
  category: DocumentCategoryReadable
  owner: ReturnUserReadable
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  created_at?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * URL fișier vechi
   */
  readonly file_legacy_url: string | null
  /**
   * Este public
   */
  is_public?: boolean
  account?: string | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type ReturnDocumentWritable = {
  attachment: AttachmentWritable
  lead: ReturnShortLeadWritable
  category: DocumentCategoryWritable
  owner: ReturnUserWritable
  created_at?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * Este public
   */
  is_public?: boolean
  account?: string | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type DocumentCategoryReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  readonly account: string | null
}

export type DocumentCategoryWritable = {
  name: string
}

/**
 * * `signed` - Semnat
 * * `closed` - Închis
 */
export type ReturnContractStatusEnum = 'signed' | 'closed'

/**
 * * `signed` - Semnat
 * * `closed` - Închis
 */
export const ReturnContractStatusEnum = {
  SIGNED: 'signed',
  CLOSED: 'closed'
} as const

export type ReturnContractReadable = {
  readonly id: number
  currency: ReturnShortCurrencyReadable
  owner: ReturnOwnerReadable
  opportunity: ReturnShortOpportunityReadable
  product: ReturnShortProductReadable
  /**
   * Număr
   */
  number: string
  /**
   * Valoare
   */
  value: number
  /**
   * Valoare de bază
   */
  value_base?: number
  /**
   * Stare
   */
  status?: ReturnContractStatusEnum
  /**
   * Semnat la
   */
  signed_at?: string | null
  valid_from?: string | null
  valid_to?: string | null
  vehicle: Vehicle
  readonly synced_at: string | null
  created_at?: string | null
  readonly modified_at: string | null
  account?: string | null
}

export type ReturnContractWritable = {
  currency: ReturnShortCurrencyWritable
  owner: ReturnOwnerWritable
  opportunity: ReturnShortOpportunityWritable
  product: ReturnShortProductWritable
  /**
   * Număr
   */
  number: string
  /**
   * Valoare
   */
  value: number
  /**
   * Valoare de bază
   */
  value_base?: number
  /**
   * Stare
   */
  status?: ReturnContractStatusEnum
  /**
   * Semnat la
   */
  signed_at?: string | null
  valid_from?: string | null
  valid_to?: string | null
  vehicle: Vehicle
  created_at?: string | null
  account?: string | null
}

export type ReportStatsTotalObj = {
  current: number
  relative_diff: number
}

export type ReportStats = {
  total_invoices: ReportStatsTotalObj
  total_paid: ReportStatsTotalObj
  total_unpaid: ReportStatsTotalObj
  total_amount: ReportStatsTotalObj
}

export type ReportReturnReadable = {
  readonly id: number
  name?: string | null
  instance_type?: InstanceTypeEnum
  chart_type?: ChartTypeEnum | NullEnum | null
  chart_value?: ValuesReadable
  filters?: Array<ReportFilterReadable>
  groups?: Array<GroupReadable>
  values?: Array<ValuesReadable>
  fields?: Array<FieldReadable>
}

export type ReportReturnWritable = {
  name?: string | null
  instance_type?: InstanceTypeEnum
  chart_type?: ChartTypeEnum | NullEnum | null
  chart_value?: ValuesWritable
  filters?: Array<ReportFilterWritable>
  groups?: Array<GroupWritable>
  values?: Array<ValuesWritable>
  fields?: Array<FieldWritable>
}

export type FieldReadable = {
  id?: number | null
  readonly modified_at: string | null
  readonly created_at: string | null
  field_name: string
  label?: string | null
  readonly account: string | null
  readonly report: number | null
}

export type FieldWritable = {
  id?: number | null
  field_name: string
  label?: string | null
}

export type GroupReadable = {
  id?: number | null
  readonly modified_at: string | null
  readonly created_at: string | null
  field_name: string
  label?: string | null
  readonly account: string | null
  readonly report: number | null
}

export type GroupWritable = {
  id?: number | null
  field_name: string
  label?: string | null
}

/**
 * * `pie` - Pie
 * * `bar` - Bar
 * * `line` - Line
 * * `funnel` - Funnel
 */
export type ChartTypeEnum = 'pie' | 'bar' | 'line' | 'funnel'

/**
 * * `pie` - Pie
 * * `bar` - Bar
 * * `line` - Line
 * * `funnel` - Funnel
 */
export const ChartTypeEnum = {
  PIE: 'pie',
  BAR: 'bar',
  LINE: 'line',
  FUNNEL: 'funnel'
} as const

/**
 * * `Lead` - Lead
 * * `Opportunity` - Opportunity
 * * `Task` - Task
 * * `Touch` - Touch
 * * `Call` - Call
 * * `Email` - Email
 */
export type InstanceTypeEnum =
  | 'Lead'
  | 'Opportunity'
  | 'Task'
  | 'Touch'
  | 'Call'
  | 'Email'

/**
 * * `Lead` - Lead
 * * `Opportunity` - Opportunity
 * * `Task` - Task
 * * `Touch` - Touch
 * * `Call` - Call
 * * `Email` - Email
 */
export const InstanceTypeEnum = {
  LEAD: 'Lead',
  OPPORTUNITY: 'Opportunity',
  TASK: 'Task',
  TOUCH: 'Touch',
  CALL: 'Call',
  EMAIL: 'Email'
} as const

export type ReportInvoiceExport = {
  ids: Array<number>
}

export type ReportReadable = {
  readonly id: number
  name?: string | null
  instance_type?: InstanceTypeEnum
  chart_type?: ChartTypeEnum | NullEnum | null
  chart_value?: number | null
  filters?: Array<ReportFilterReadable>
  groups?: Array<GroupReadable>
  values?: Array<ValuesReadable>
  fields?: Array<FieldReadable>
}

export type ReportWritable = {
  name?: string | null
  instance_type?: InstanceTypeEnum
  chart_type?: ChartTypeEnum | NullEnum | null
  chart_value?: number | null
  filters?: Array<ReportFilterWritable>
  groups?: Array<GroupWritable>
  values?: Array<ValuesWritable>
  fields?: Array<FieldWritable>
}

export type RenderedInitialEmail = {
  subject: unknown
  body: unknown
}

export type ReceiveCurrencyReadable = {
  readonly id: number
  name: string
  symbol: string
}

export type ReceiveCurrencyWritable = {
  name: string
  symbol: string
}

export type ProductUoMUpdateReadable = {
  name: string
  readonly code: string
  description?: string
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly account: string | null
}

export type ProductUoMUpdateWritable = {
  name: string
  description?: string
}

export type ProductCategoryUpdateReadable = {
  name: string
  readonly code: string
  description?: string
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly account: string | null
}

export type ProductCategoryUpdateWritable = {
  name: string
  description?: string
}

export type PresetTaskReadable = {
  readonly id: number
  title: string
  type: ShortTaskTypeReadable
  /**
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  readonly created_at: string | null
  readonly modified_at: string | null
  description?: string | null
}

export type PresetTaskWritable = {
  title: string
  type: ShortTaskTypeWritable
  /**
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  description?: string | null
}

export type PatchedWhatsAppConfigUpdateReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  waba_id?: string
  app_id?: string
  app_secret?: string
  phone_number_id?: string
  readonly display_phone_number?: string
  access_token?: string
  webhook_verify_token?: string
  status?: Status926Enum
  readonly last_verified_at?: string | null
  readonly last_error_code?: string | null
  readonly last_error_message?: string | null
  readonly account?: string | null
  readonly created_by_user?: string
}

export type PatchedWhatsAppConfigUpdateWritable = {
  waba_id?: string
  app_id?: string
  app_secret?: string
  phone_number_id?: string
  access_token?: string
  webhook_verify_token?: string
  status?: Status926Enum
}

export type PatchedVoipConfigurationReadable = {
  readonly id?: number
  provider?: ProviderEnum
  credentials?: VoipYeastarCredentialsReadable
  is_active?: boolean
  readonly created_at?: string | null
  readonly modified_at?: string | null
}

export type PatchedVoipConfigurationWritable = {
  provider?: ProviderEnum
  credentials?: VoipYeastarCredentialsWritable
  is_active?: boolean
}

export type PatchedTaskTypeReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  code?: string | null
  allow_manual_creation?: boolean
  readonly account?: string | null
}

export type PatchedTaskTypeWritable = {
  name?: string
  code?: string | null
  allow_manual_creation?: boolean
}

export type PatchedTaskStatusUpdateReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly code?: string
  color?: string
  order?: number
  is_active?: boolean
  readonly account?: string | null
}

export type PatchedTaskStatusUpdateWritable = {
  name?: string
  color?: string
  order?: number
  is_active?: boolean
}

export type PatchedTaskReadable = {
  readonly id?: number
  status?: number
  readonly deleted_at?: string | null
  readonly deleted_by_cascade?: boolean
  readonly modified_at?: string | null
  readonly created_at?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Titlu
   */
  title?: string
  /**
   * Repetat
   */
  repeated?: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Termen limită
   */
  deadline?: string | null
  /**
   * Finalizat la
   */
  completed_at?: string | null
  /**
   * Este reminder
   */
  is_reminder?: boolean
  /**
   * Memento
   */
  reminder?: string
  /**
   * Memento după zile
   */
  reminder_after_days?: number | null
  /**
   * Prioritate
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Număr de așteptare
   */
  waiting_count?: number | null
  /**
   * ID sarcină calendar
   */
  calendar_task_id?: number | null
  /**
   * Creează eveniment Outlook
   */
  create_outlook_event?: boolean
  /**
   * ID eveniment Outlook
   */
  outlook_event_id?: string | null
  /**
   * Tip
   */
  type?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Pasul secvenței
   */
  sequence_step?: number | null
  /**
   * Responsabil
   */
  owner?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  client?: number | null
}

export type PatchedTaskWritable = {
  status?: number
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Titlu
   */
  title?: string
  /**
   * Repetat
   */
  repeated?: number
  /**
   * Descriere
   */
  description?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Termen limită
   */
  deadline?: string | null
  /**
   * Finalizat la
   */
  completed_at?: string | null
  /**
   * Este reminder
   */
  is_reminder?: boolean
  /**
   * Memento
   */
  reminder?: string
  /**
   * Memento după zile
   */
  reminder_after_days?: number | null
  /**
   * Prioritate
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Număr de așteptare
   */
  waiting_count?: number | null
  /**
   * ID sarcină calendar
   */
  calendar_task_id?: number | null
  /**
   * Creează eveniment Outlook
   */
  create_outlook_event?: boolean
  /**
   * ID eveniment Outlook
   */
  outlook_event_id?: string | null
  /**
   * Tip
   */
  type?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Pasul secvenței
   */
  sequence_step?: number | null
  /**
   * Responsabil
   */
  owner?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  client?: number | null
}

export type PatchedTagReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  color?: string
  readonly account?: string | null
}

export type PatchedTagWritable = {
  name?: string
  color?: string
}

export type PatchedSourceReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug?: string | null
  readonly account?: string | null
}

export type PatchedSourceWritable = {
  name?: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug?: string | null
}

export type PatchedSequenceReadable = {
  readonly id?: number
  readonly steps_count?: number
  readonly stats_leads?: number
  readonly stats_active?: number
  readonly stats_failed?: number
  readonly stats_success?: number
  readonly steps?: Array<ReturnShortStepReadable>
  readonly modified_at?: string | null
  readonly created_at?: string | null
  title?: string | null
  readonly account?: string | null
}

export type PatchedSequenceWritable = {
  title?: string | null
}

export type PatchedSeniorJobPositionReadable = {
  readonly id?: number
  title?: string
  readonly modified_at?: string | null
  readonly created_at?: string | null
}

export type PatchedSeniorJobPositionWritable = {
  title?: string
}

export type PatchedReturnUserReadable = {
  id?: string
  email?: string
  first_name?: string
  last_name?: string
  readonly name?: string
  phone_number?: number | null
  sip?: string | null
  countries?: Array<string> | null
  archived?: boolean
}

export type PatchedReturnUserWritable = {
  id?: string
  email?: string
  first_name?: string
  last_name?: string
  phone_number?: number | null
  sip?: string | null
  countries?: Array<string> | null
  archived?: boolean
}

export type PatchedReturnSuccess = {
  success?: boolean
  message?: string
}

export type PatchedReturnSubIndustryReadable = {
  readonly id?: number
  industry?: IndustryReadable
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly account?: string | null
}

export type PatchedReturnSubIndustryWritable = {
  industry?: IndustryWritable
  name?: string
}

export type PatchedReturnStepReadable = {
  readonly id?: number
  readonly stats_leads?: number
  readonly stats_active?: number
  readonly stats_failed?: number
  readonly stats_success?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  step_type?: StepTypeEnum
  title?: string
  description?: string | null
  number?: number
  wait_time?: number
  wait_type?: WaitTypeEnum
  enabled?: boolean
  email_message?: string | null
  email_subject?: string | null
  readonly account?: string | null
  sequence?: number
}

export type PatchedReturnStepWritable = {
  step_type?: StepTypeEnum
  title?: string
  description?: string | null
  number?: number
  wait_time?: number
  wait_type?: WaitTypeEnum
  enabled?: boolean
  email_message?: string | null
  email_subject?: string | null
  sequence?: number
}

export type PatchedReturnOutlookMailboxReadable = {
  readonly id?: number
  from_email?: string | null
  from_name?: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  readonly auth_link?: string
}

export type PatchedReturnOutlookMailboxWritable = {
  from_email?: string | null
  from_name?: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
}

export type PatchedReturnOpportunityStatusReadable = {
  readonly id?: number
  pipeline?: ReturnOpportunityPipelineNomenclatorReadable
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
  requires_refusal_reason?: boolean
  requires_contract?: boolean
  allowed_transition_statuses?: Array<number>
}

export type PatchedReturnOpportunityStatusWritable = {
  pipeline?: ReturnOpportunityPipelineNomenclatorWritable
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
  requires_refusal_reason?: boolean
  requires_contract?: boolean
  allowed_transition_statuses?: Array<number>
}

export type PatchedReturnOpportunityReadable = {
  readonly id?: number
  owner?: ReturnUserReadable
  products?: Array<ProductReadable>
  product?: ProductReadable
  reason?: OpportunityReasonReadable
  currency?: CurrencyReadable
  contact?: ShortContactReadable
  status?: ReturnOpportunityStatusReadable
  lead?: ReturnLeadReadable | null
  tags?: Array<TagReadable>
  client?: ClientShortReadable | null
  readonly deleted_at?: string | null
  readonly deleted_by_cascade?: boolean
  readonly modified_at?: string | null
  readonly created_at?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  readonly value?: string | null
  /**
   * Valoare de bază
   */
  readonly value_base?: string
  /**
   * Ordine în status
   */
  readonly status_order?: string | null
  /**
   * Identificator
   */
  readonly identifier?: number | null
  /**
   * Probabilitate
   */
  probability?: number
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  readonly account?: string | null
  /**
   * Creat de
   */
  created_by?: string | null
  contracts?: Array<ReturnShortContractReadable> | null
}

export type PatchedReturnOpportunityWritable = {
  owner?: ReturnUserWritable
  products?: Array<ProductWritable>
  product?: ProductWritable
  reason?: OpportunityReasonWritable
  currency?: CurrencyWritable
  contact?: ShortContactWritable
  status?: ReturnOpportunityStatusWritable
  lead?: ReturnLeadWritable | null
  tags?: Array<TagWritable>
  client?: ClientShortWritable | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Probabilitate
   */
  probability?: number
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Creat de
   */
  created_by?: string | null
  contracts?: Array<ReturnShortContractWritable> | null
}

export type PatchedReturnLeadStatusReadable = {
  readonly id?: number
  lead_type?: LeadTypeReadable
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
  is_conversion?: boolean
  requires_opportunity?: boolean
  requires_refusal_reason?: boolean
  allowed_transition_statuses?: Array<number>
}

export type PatchedReturnLeadStatusWritable = {
  lead_type?: LeadTypeWritable
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
  is_conversion?: boolean
  requires_opportunity?: boolean
  requires_refusal_reason?: boolean
  allowed_transition_statuses?: Array<number>
}

export type PatchedReturnLeadReadable = {
  readonly id?: number
  /**
   * Cont
   */
  readonly account?: string | null
  attachment?: AttachmentReadable
  created_by?: ReturnUserReadable
  owner?: ReturnUserReadable
  contact?: ReturnContactReadable
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  source?: SourceShortReadable
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  status?: ReturnLeadStatusReadable
  /**
   * Comentariu
   */
  comment?: string | null
  industry?: IndustryReadable
  sub_industry?: ReturnSubIndustryReadable
  size?: CompanySizeReadable
  reason?: ReasonReadable
  linkedin?: string | null
  country?: CountryReadable
  region?: RegionReadable
  city?: CityReadable
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  tags?: Array<TagReadable>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  readonly deleted_at?: string | null
  readonly match_fields?: Array<string>
  lead_type?: ReturnShortLeadTypeReadable
  /**
   * Identification number, e.g. IDNP
   */
  identification_number?: string | null
  product_of_interest?: ProductOfInterestEnum | NullEnum | null
}

export type PatchedReturnLeadWritable = {
  attachment?: AttachmentWritable
  created_by?: ReturnUserWritable
  owner?: ReturnUserWritable
  contact?: ReturnContactWritable
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  source?: SourceShortWritable
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  status?: ReturnLeadStatusWritable
  /**
   * Comentariu
   */
  comment?: string | null
  industry?: IndustryWritable
  sub_industry?: ReturnSubIndustryWritable
  size?: CompanySizeWritable
  reason?: ReasonWritable
  linkedin?: string | null
  country?: CountryWritable
  region?: RegionWritable
  city?: CityWritable
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  tags?: Array<TagWritable>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  lead_type?: ReturnShortLeadTypeWritable
  /**
   * Identification number, e.g. IDNP
   */
  identification_number?: string | null
  product_of_interest?: ProductOfInterestEnum | NullEnum | null
}

export type PatchedReturnJobPositionReadable = {
  readonly id?: number
  senior_position?: SeniorJobPositionReadable
  title?: string
}

export type PatchedReturnJobPositionWritable = {
  senior_position?: SeniorJobPositionWritable
  title?: string
}

export type PatchedReturnDocumentReadable = {
  readonly id?: number
  attachment?: AttachmentReadable
  lead?: ReturnShortLeadReadable
  category?: DocumentCategoryReadable
  owner?: ReturnUserReadable
  readonly deleted_at?: string | null
  readonly deleted_by_cascade?: boolean
  readonly modified_at?: string | null
  created_at?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * URL fișier vechi
   */
  readonly file_legacy_url?: string | null
  /**
   * Este public
   */
  is_public?: boolean
  account?: string | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type PatchedReturnDocumentWritable = {
  attachment?: AttachmentWritable
  lead?: ReturnShortLeadWritable
  category?: DocumentCategoryWritable
  owner?: ReturnUserWritable
  created_at?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * Este public
   */
  is_public?: boolean
  account?: string | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type PatchedReturnContractReadable = {
  readonly id?: number
  currency?: ReturnShortCurrencyReadable
  owner?: ReturnOwnerReadable
  opportunity?: ReturnShortOpportunityReadable
  product?: ReturnShortProductReadable
  /**
   * Număr
   */
  number?: string
  /**
   * Valoare
   */
  value?: number
  /**
   * Valoare de bază
   */
  value_base?: number
  /**
   * Stare
   */
  status?: ReturnContractStatusEnum
  /**
   * Semnat la
   */
  signed_at?: string | null
  valid_from?: string | null
  valid_to?: string | null
  vehicle?: Vehicle
  readonly synced_at?: string | null
  created_at?: string | null
  readonly modified_at?: string | null
  account?: string | null
}

export type PatchedReturnContractWritable = {
  currency?: ReturnShortCurrencyWritable
  owner?: ReturnOwnerWritable
  opportunity?: ReturnShortOpportunityWritable
  product?: ReturnShortProductWritable
  /**
   * Număr
   */
  number?: string
  /**
   * Valoare
   */
  value?: number
  /**
   * Valoare de bază
   */
  value_base?: number
  /**
   * Stare
   */
  status?: ReturnContractStatusEnum
  /**
   * Semnat la
   */
  signed_at?: string | null
  valid_from?: string | null
  valid_to?: string | null
  vehicle?: Vehicle
  created_at?: string | null
  account?: string | null
}

export type PatchedReportReadable = {
  readonly id?: number
  name?: string | null
  instance_type?: InstanceTypeEnum
  chart_type?: ChartTypeEnum | NullEnum | null
  chart_value?: number | null
  filters?: Array<ReportFilterReadable>
  groups?: Array<GroupReadable>
  values?: Array<ValuesReadable>
  fields?: Array<FieldReadable>
}

export type PatchedReportWritable = {
  name?: string | null
  instance_type?: InstanceTypeEnum
  chart_type?: ChartTypeEnum | NullEnum | null
  chart_value?: number | null
  filters?: Array<ReportFilterWritable>
  groups?: Array<GroupWritable>
  values?: Array<ValuesWritable>
  fields?: Array<FieldWritable>
}

export type PatchedReasonReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly account?: string | null
}

export type PatchedReasonWritable = {
  name?: string
}

export type PatchedProductUoMUpdateReadable = {
  name?: string
  readonly code?: string
  description?: string
  readonly created_at?: string | null
  readonly modified_at?: string | null
  readonly account?: string | null
}

export type PatchedProductUoMUpdateWritable = {
  name?: string
  description?: string
}

export type PatchedProductCategoryUpdateReadable = {
  name?: string
  readonly code?: string
  description?: string
  readonly created_at?: string | null
  readonly modified_at?: string | null
  readonly account?: string | null
}

export type PatchedProductCategoryUpdateWritable = {
  name?: string
  description?: string
}

export type PatchedProductReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly code?: string
  sku?: string
  description?: string
  price?: string | null
  is_active?: boolean
  source?: string | null
  category?: number | null
  uom?: number | null
  currency?: number | null
}

export type PatchedProductWritable = {
  name?: string
  sku?: string
  description?: string
  price?: string | null
  is_active?: boolean
  source?: string | null
  category?: number | null
  uom?: number | null
  currency?: number | null
}

export type PatchedPresetTaskReadable = {
  readonly id?: number
  title?: string
  type?: ShortTaskTypeReadable
  /**
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  readonly created_at?: string | null
  readonly modified_at?: string | null
  description?: string | null
}

export type PatchedPresetTaskWritable = {
  title?: string
  type?: ShortTaskTypeWritable
  /**
   * 1 --> highest priority;
   * 2 --> medium;
   * 3 --> lowest;
   *
   */
  priority?: number | null
  description?: string | null
}

export type PatchedOpportunityProductReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  /**
   * Cantitate
   */
  quantity?: string | null
  /**
   * Preț personalizat
   */
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  readonly account?: string | null
  /**
   * Produs
   */
  product?: number
  /**
   * Oportunitate
   */
  opportunity?: number
  /**
   * Unitate de măsură
   */
  uom?: number | null
  /**
   * Monedă
   */
  currency?: number | null
}

export type PatchedOpportunityProductWritable = {
  /**
   * Cantitate
   */
  quantity?: string | null
  /**
   * Preț personalizat
   */
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  /**
   * Produs
   */
  product?: number
  /**
   * Oportunitate
   */
  opportunity?: number
  /**
   * Unitate de măsură
   */
  uom?: number | null
  /**
   * Monedă
   */
  currency?: number | null
}

export type PatchedOpportunityPipelineNomenclatorReadable = {
  readonly id?: number
  responsible?: string | null
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type PatchedOpportunityPipelineNomenclatorWritable = {
  responsible?: string | null
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type PatchedOpportunityReadable = {
  readonly id?: number
  owner?: string
  readonly deleted_at?: string | null
  readonly deleted_by_cascade?: boolean
  readonly modified_at?: string | null
  readonly created_at?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  value?: string | null
  /**
   * Valoare de bază
   */
  value_base?: string
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Identificator
   */
  readonly identifier?: number | null
  /**
   * Probabilitate
   */
  probability?: number
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Monedă
   */
  currency?: number | null
  contact?: number | null
  /**
   * Produs
   */
  product?: number | null
  lead?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  /**
   * Creat de
   */
  readonly created_by?: string | null
  client?: number | null
  /**
   * Produse
   */
  products?: Array<number>
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type PatchedOpportunityWritable = {
  owner?: string
  create_task?: boolean
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  value?: string | null
  /**
   * Valoare de bază
   */
  value_base?: string
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Probabilitate
   */
  probability?: number
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Monedă
   */
  currency?: number | null
  contact?: number | null
  /**
   * Produs
   */
  product?: number | null
  lead?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  client?: number | null
  /**
   * Produse
   */
  products?: Array<number>
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type PatchedMessengerMailboxReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name?: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type PatchedMessengerMailboxWritable = {
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name?: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type PatchedMergeOpportunitiesReadable = {
  readonly id?: number
  opportunity_to_merge?: number
}

export type PatchedMergeOpportunitiesWritable = {
  opportunity_to_merge?: number
}

export type PatchedMergeLeadReadable = {
  readonly id?: number
  lead_to_merge?: number
}

export type PatchedMergeLeadWritable = {
  lead_to_merge?: number
}

export type PatchedListViewReadable = {
  name?: string | null
  is_private?: boolean
  filter_logic?: string | null
  fields?: Array<ListViewFieldReadable>
  filters?: Array<ListViewFilter>
  shared_users?: Array<string>
}

export type PatchedListViewWritable = {
  name?: string | null
  is_private?: boolean
  filter_logic?: string | null
  fields?: Array<ListViewFieldWritable>
  filters?: Array<ListViewFilter>
  shared_users?: Array<string>
}

export type ListViewFilter = {
  value: Array<string>
  field_name: string
  filter_operator?: FilterOperatorEnum | NullEnum | null
  order: number
}

export type ListViewFieldReadable = {
  label?: string | null
  name: string
  readonly field_type: string
  order?: number | null
}

export type ListViewFieldWritable = {
  label?: string | null
  name: string
  order?: number | null
}

export type PatchedLeadTypeReadable = {
  readonly id?: number
  responsible?: string | null
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type PatchedLeadTypeWritable = {
  responsible?: string | null
  name?: string
  code?: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type PatchedLeadSequenceUpdate = {
  /**
   * Pasul curent
   */
  current_step?: number | null
  /**
   * Stare
   */
  status?: LeadSequenceStatus
}

export type PatchedLeadScoreRatingReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  criterion?: CriterionEnum
  to_add?: boolean
  expression?: ExpressionEnum
  add_score?: number
  value?: Array<string>
  readonly account?: string | null
}

export type PatchedLeadScoreRatingWritable = {
  criterion?: CriterionEnum
  to_add?: boolean
  expression?: ExpressionEnum
  add_score?: number
  value?: Array<string>
}

/**
 * * `equal` - Equal
 * * `lt` - Lt
 * * `lte` - Lte
 * * `gt` - Gt
 * * `gte` - Gte
 * * `in` - In
 */
export type ExpressionEnum = 'equal' | 'lt' | 'lte' | 'gt' | 'gte' | 'in'

/**
 * * `equal` - Equal
 * * `lt` - Lt
 * * `lte` - Lte
 * * `gt` - Gt
 * * `gte` - Gte
 * * `in` - In
 */
export const ExpressionEnum = {
  EQUAL: 'equal',
  LT: 'lt',
  LTE: 'lte',
  GT: 'gt',
  GTE: 'gte',
  IN: 'in'
} as const

/**
 * * `country` - Country
 * * `replied` - Replied
 * * `source_website` - Source Website
 * * `status` - Status
 * * `date_of_last_reply` - Date Of Last Reply
 * * `rank` - Rank
 */
export type CriterionEnum =
  | 'country'
  | 'replied'
  | 'source_website'
  | 'status'
  | 'date_of_last_reply'
  | 'rank'

/**
 * * `country` - Country
 * * `replied` - Replied
 * * `source_website` - Source Website
 * * `status` - Status
 * * `date_of_last_reply` - Date Of Last Reply
 * * `rank` - Rank
 */
export const CriterionEnum = {
  COUNTRY: 'country',
  REPLIED: 'replied',
  SOURCE_WEBSITE: 'source_website',
  STATUS: 'status',
  DATE_OF_LAST_REPLY: 'date_of_last_reply',
  RANK: 'rank'
} as const

export type PatchedInvoiceUpdateReadable = {
  received_amount?: number | null
  status?: InvoiceStatus
  pay_date?: string | null
}

export type PatchedInvoiceUpdateWritable = {
  contacts?: Array<number>
  received_amount?: number | null
  status?: InvoiceStatus
  pay_date?: string | null
}

/**
 * * `paid` - Paid
 * * `unpaid` - Unpaid
 * * `draft` - Draft
 * * `canceled` - Canceled
 */
export type InvoiceStatus = 'paid' | 'unpaid' | 'draft' | 'canceled'

/**
 * * `paid` - Paid
 * * `unpaid` - Unpaid
 * * `draft` - Draft
 * * `canceled` - Canceled
 */
export const InvoiceStatus = {
  PAID: 'paid',
  UNPAID: 'unpaid',
  DRAFT: 'draft',
  CANCELED: 'canceled'
} as const

export type PatchedInvoiceReadable = {
  readonly id?: number
  contacts?: Array<ReturnShortContactReadable>
  lead?: ReturnShortLeadReadable
  product?: ProductReadable
  currency?: CurrencyReadable
  received_currency?: ReceiveCurrencyReadable
  amounts?: Array<InvoiceAmountReadable>
  readonly total_quantity?: number
  readonly deleted_at?: string | null
  readonly deleted_by_cascade?: boolean
  readonly modified_at?: string | null
  readonly created_at?: string | null
  product_name?: string | null
  title?: string
  due_date?: string | null
  remind_periodicity?: number
  email_message?: string | null
  status?: InvoiceStatus
  pay_date?: string | null
  invoice_number?: string
  received_amount?: number | null
  total_amount?: number | null
  additional_emails?: Array<string> | null
  readonly account?: string | null
  created_by?: string | null
}

export type PatchedInvoiceWritable = {
  contacts?: Array<ReturnShortContactWritable>
  lead?: ReturnShortLeadWritable
  product?: ProductWritable
  currency?: CurrencyWritable
  received_currency?: ReceiveCurrencyWritable
  amounts?: Array<InvoiceAmountWritable>
  product_name?: string | null
  title?: string
  due_date?: string | null
  remind_periodicity?: number
  email_message?: string | null
  status?: InvoiceStatus
  pay_date?: string | null
  invoice_number?: string
  received_amount?: number | null
  total_amount?: number | null
  additional_emails?: Array<string> | null
  created_by?: string | null
}

export type InvoiceAmountReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  title: string
  quantity: number
  amount: number
  tax?: number
  total: number
  readonly account: string | null
  readonly invoice: number
}

export type InvoiceAmountWritable = {
  title: string
  quantity: number
  amount: number
  tax?: number
  total: number
}

export type PatchedInternalCurrencyReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  ratio?: number
  name?: string
  code?: string | null
  symbol?: string
  is_default?: boolean
}

export type PatchedInternalCurrencyWritable = {
  ratio?: number
  name?: string
  code?: string | null
  symbol?: string
  is_default?: boolean
}

export type PatchedInformationReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  title?: string
  description?: string
  readonly account?: string | null
}

export type PatchedInformationWritable = {
  title?: string
  description?: string
}

export type PatchedIndustryReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly account?: string | null
}

export type PatchedIndustryWritable = {
  name?: string
}

export type PatchedImportReadable = {
  readonly id?: number
  type?: Type5DfEnum
  notes?: string | null
  headers?: {
    lead_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
    contact_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
  }
  attachment?: number | null
  owner?: string | null
  create_type?: CreateTypeEnum
  unique_verify?: Array<string>
  step?: StepEnum
  progress?: number
  status?: StatusF6fEnum
  lead_type?: number | null
  status_mapping?: {
    [key: string]: number
  }
  status_column?: number
  duplicates?: Array<{
    fields?: Array<string>
    values?: Array<string>
  }>
  existing_duplicates?: Array<{
    field?: string
    values?: Array<string>
  }>
  defaults?: {
    lead?: {
      lead_type?: number
      status?: number
    }
    contact?: {
      owner?: number
    }
  }
  pipeline?: number
}

export type PatchedImportWritable = {
  type?: Type5DfEnum
  notes?: string | null
  headers?: {
    lead_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
    contact_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
  }
  attachment?: number | null
  owner?: string | null
  create_type?: CreateTypeEnum
  unique_verify?: Array<string>
  step?: StepEnum
  progress?: number
  status?: StatusF6fEnum
  lead_type?: number | null
  status_mapping?: {
    [key: string]: number
  }
  status_column?: number
  duplicates?: Array<{
    fields?: Array<string>
    values?: Array<string>
  }>
  existing_duplicates?: Array<{
    field?: string
    values?: Array<string>
  }>
  defaults?: {
    lead?: {
      lead_type?: number
      status?: number
    }
    contact?: {
      owner?: number
    }
  }
  pipeline?: number
}

export type PatchedGmailMailboxReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name?: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type PatchedGmailMailboxWritable = {
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name?: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

/**
 * Makes the listed fields read-only for operators; operator-submitted values are ignored.
 */
export type PatchedExtendedLeadReadable = {
  readonly id?: number
  contacts?: Array<ExtendedContactLeadReadable>
  contact?: ExtendedContactLeadReadable
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  /**
   * Sursă
   */
  source?: number | null
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  owner?: string
  /**
   * Filială
   */
  branch?: number | null
  status?: number
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Industrie
   */
  industry?: number | null
  /**
   * Sub-industrie
   */
  sub_industry?: number | null
  /**
   * Dimensiunea companiei
   */
  size?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  linkedin?: string | null
  /**
   * Țară
   */
  country?: number | null
  region?: number | null
  city?: number | null
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  /**
   * Etichete
   */
  tags?: Array<number>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: unknown
  lead_type?: number | null
  /**
   * Număr de identificare. Tipuri permise: IDNP, IDNO. Trebuie să aibă 13 cifre. IDNP începe cu "2" sau "09", IDNO începe cu "1".
   */
  identification_number?: string | null
}

/**
 * Makes the listed fields read-only for operators; operator-submitted values are ignored.
 */
export type PatchedExtendedLeadWritable = {
  contacts?: Array<ExtendedContactLeadWritable>
  contact?: ExtendedContactLeadWritable
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  /**
   * Sursă
   */
  source?: number | null
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  owner?: string
  /**
   * Filială
   */
  branch?: number | null
  status?: number
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Industrie
   */
  industry?: number | null
  /**
   * Sub-industrie
   */
  sub_industry?: number | null
  /**
   * Dimensiunea companiei
   */
  size?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  linkedin?: string | null
  /**
   * Țară
   */
  country?: number | null
  region?: number | null
  city?: number | null
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  /**
   * Etichete
   */
  tags?: Array<number>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: unknown
  lead_type?: number | null
  /**
   * Număr de identificare. Tipuri permise: IDNP, IDNO. Trebuie să aibă 13 cifre. IDNP începe cu "2" sau "09", IDNO începe cu "1".
   */
  identification_number?: string | null
  contract_number?: string
}

export type ExtendedContactLeadReadable = {
  id?: number | null
  phone_numbers?: Array<ContactPhoneNumberNested>
  is_primary?: boolean | null
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon fix valid
   */
  readonly landline_number_valid: boolean | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  readonly email_valid: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Cont
   */
  readonly account: string | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type ExtendedContactLeadWritable = {
  id?: number | null
  phone_numbers?: Array<ContactPhoneNumberNested>
  is_primary?: boolean | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type PatchedExtendedContactReadable = {
  readonly id?: number
  phone_numbers?: Array<ContactPhoneNumberNested>
  readonly deleted_at?: string | null
  readonly deleted_by_cascade?: boolean
  readonly modified_at?: string | null
  readonly created_at?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon fix valid
   */
  readonly landline_number_valid?: boolean | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  readonly email_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Cont
   */
  readonly account?: string | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type PatchedExtendedContactWritable = {
  phone_numbers?: Array<ContactPhoneNumberNested>
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type PatchedEmailTemplateReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  title?: string
  subject?: string
  message?: string
  is_public?: boolean
  readonly account?: string | null
  created_by?: string | null
}

export type PatchedEmailTemplateWritable = {
  title?: string
  subject?: string
  message?: string
  is_public?: boolean
  created_by?: string | null
}

export type PatchedDocumentCategoryReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly account?: string | null
}

export type PatchedDocumentCategoryWritable = {
  name?: string
}

export type PatchedCustomFieldUpdateReadable = {
  readonly id?: number
  /**
   * Key [en]
   */
  key_en?: string | null
  /**
   * Key [ro]
   */
  key_ro?: string | null
  /**
   * Key [ru]
   */
  key_ru?: string | null
  /**
   * Key [it]
   */
  key_it?: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type?: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type?: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  is_required?: boolean
  validation_rules?: {
    min?: number
    max?: number
    pattern?: string
  }
  options?: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  default_value?: unknown
}

export type PatchedCustomFieldUpdateWritable = {
  /**
   * Key [en]
   */
  key_en?: string | null
  /**
   * Key [ro]
   */
  key_ro?: string | null
  /**
   * Key [ru]
   */
  key_ru?: string | null
  /**
   * Key [it]
   */
  key_it?: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type?: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type?: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  is_required?: boolean
  validation_rules?: {
    min?: number
    max?: number
    pattern?: string
  }
  options?: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  default_value?: unknown
}

/**
 * * `lead` - Lead
 * * `opportunity` - Oportunitate
 * * `contact` - Contact
 */
export type EntityTypeEnum = 'lead' | 'opportunity' | 'contact'

/**
 * * `lead` - Lead
 * * `opportunity` - Oportunitate
 * * `contact` - Contact
 */
export const EntityTypeEnum = {
  LEAD: 'lead',
  OPPORTUNITY: 'opportunity',
  CONTACT: 'contact'
} as const

export type PatchedCurrencyReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  ratio?: number
  name?: string
  code?: string | null
  symbol?: string
  is_default?: boolean
  readonly account?: string | null
}

export type PatchedCurrencyWritable = {
  ratio?: number
  name?: string
  code?: string | null
  symbol?: string
  is_default?: boolean
}

export type PatchedCountryReadable = {
  readonly id?: number
  name?: string
  code?: string
  alpha_3?: string | null
  continent?: string | null
  readonly modified_at?: string | null
  readonly created_at?: string | null
}

export type PatchedCountryWritable = {
  name?: string
  code?: string
  alpha_3?: string | null
  continent?: string | null
}

export type PatchedContactPhoneReadable = {
  readonly id?: number
  contact?: number
  number?: number
  is_primary?: boolean
}

export type PatchedContactPhoneWritable = {
  contact?: number
  number?: number
  is_primary?: boolean
}

export type PatchedCompanySizeReadable = {
  readonly id?: number
  readonly modified_at?: string | null
  readonly created_at?: string | null
  name?: string
  readonly account?: string | null
}

export type PatchedCompanySizeWritable = {
  name?: string
}

/**
 * Schema-only variant that types the `criteria` object for the CASCO family.
 *
 * Drives the OpenAPI docs for the campaign endpoints (the single family today), not
 * runtime: the runtime serializer keeps `criteria` as free JSON and validates it via
 * the generator. When a second family appears, wrap the per-family variants in a
 * drf_spectacular PolymorphicProxySerializer again (see views.py).
 */
export type PatchedCascoCampaign = {
  /**
   * Nume
   */
  name?: string
  generator_key?: GeneratorKey
  is_active?: boolean
  run_time?: string
  criteria?: CascoCriteria
}

/**
 * Validation schema for CASCO cross-sell campaign criteria.
 */
export type CascoCriteria = {
  issued_window_days?: number
  max_vehicle_age_years?: number | null
  excluded_casco_packages?: Array<ExcludedCascoPackagesEnum> | null
}

/**
 * * `standard` - standard
 * * `comfort` - comfort
 * * `fifty_fifty` - fifty_fifty
 * * `mini` - mini
 */
export type ExcludedCascoPackagesEnum =
  | 'standard'
  | 'comfort'
  | 'fifty_fifty'
  | 'mini'

/**
 * * `standard` - standard
 * * `comfort` - comfort
 * * `fifty_fifty` - fifty_fifty
 * * `mini` - mini
 */
export const ExcludedCascoPackagesEnum = {
  STANDARD: 'standard',
  COMFORT: 'comfort',
  FIFTY_FIFTY: 'fifty_fifty',
  MINI: 'mini'
} as const

/**
 * * `casco_cross_sell` - CASCO cross-sell
 */
export type GeneratorKey = 'casco_cross_sell'

/**
 * * `casco_cross_sell` - CASCO cross-sell
 */
export const GeneratorKey = {
  CASCO_CROSS_SELL: 'casco_cross_sell'
} as const

export type PatchedCallReadable = {
  readonly id?: number
  agent?: ReturnUserReadable
  contact?: ShortContactReadable
  readonly modified_at?: string | null
  created_at?: string | null
  old_id?: string | null
  call_duration?: number
  end_at?: string
  answered?: boolean
  start_at?: string
  to_phone_number?: number | null
  readonly file_legacy_url?: string | null
  from_phone_number?: number | null
  type?: CallTypeEnum
  account?: string | null
  attachment?: number | null
}

export type PatchedCallWritable = {
  agent?: ReturnUserWritable
  contact?: ShortContactWritable
  created_at?: string | null
  old_id?: string | null
  call_duration?: number
  end_at?: string
  answered?: boolean
  start_at?: string
  to_phone_number?: number | null
  from_phone_number?: number | null
  type?: CallTypeEnum
  account?: string | null
  attachment?: number | null
}

/**
 * * `incoming` - Incoming
 * * `outgoing` - Outgoing
 * * `missed` - Missed
 */
export type CallTypeEnum = 'incoming' | 'outgoing' | 'missed'

/**
 * * `incoming` - Incoming
 * * `outgoing` - Outgoing
 * * `missed` - Missed
 */
export const CallTypeEnum = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
  MISSED: 'missed'
} as const

export type PatchedBulkSetTag = {
  leads?: Array<number>
  tag?: number
}

export type PatchedBulkSetBranch = {
  leads?: Array<number>
  branch?: number
}

export type PatchedBulkAsigneeLead = {
  leads?: Array<number>
  assignee_to?: string
  change_owner_at?: string
}

export type PatchedAttachmentUpdate = {
  title?: string
  metadata?: unknown
}

export type PaginatedVoipConfigurationListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<VoipConfigurationReadable>
}

export type PaginatedVoipConfigurationListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<VoipConfigurationWritable>
}

export type PaginatedViewedLeadListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ViewedLeadReadable>
}

export type PaginatedViewedLeadListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ViewedLeadWritable>
}

export type PaginatedTaskTypeListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TaskTypeReadable>
}

export type PaginatedTaskTypeListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TaskTypeWritable>
}

export type PaginatedTaskStatusCreateListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TaskStatusCreateReadable>
}

export type PaginatedTaskStatusCreateListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TaskStatusCreateWritable>
}

export type PaginatedTaskKanbanListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TaskKanbanReadable>
}

export type PaginatedTaskKanbanListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TaskKanbanWritable>
}

export type PaginatedTagListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TagReadable>
}

export type PaginatedTagListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<TagWritable>
}

export type PaginatedSystemTaskTypeListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SystemTaskTypeReadable>
}

export type PaginatedSystemTaskTypeListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SystemTaskTypeWritable>
}

export type PaginatedSourceListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SourceReadable>
}

export type PaginatedSourceListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SourceWritable>
}

export type PaginatedSequenceListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SequenceReadable>
}

export type PaginatedSequenceListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SequenceWritable>
}

export type PaginatedSeniorJobPositionListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SeniorJobPositionReadable>
}

export type PaginatedSeniorJobPositionListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SeniorJobPositionWritable>
}

export type PaginatedSalesFunnelListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SalesFunnelReadable>
}

export type PaginatedSalesFunnelListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<SalesFunnelWritable>
}

export type PaginatedReturnWhatsAppMessageTemplateListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnWhatsAppMessageTemplateReadable>
}

export type PaginatedReturnWhatsAppMessageTemplateListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnWhatsAppMessageTemplateWritable>
}

export type PaginatedReturnWhatsAppMessageListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnWhatsAppMessageReadable>
}

export type PaginatedReturnWhatsAppMessageListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnWhatsAppMessageWritable>
}

export type PaginatedReturnWhatsAppConfigListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnWhatsAppConfig>
}

export type PaginatedReturnWhatsAppConfigListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<any>
}

export type PaginatedReturnUserListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnUserReadable>
}

export type PaginatedReturnUserListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnUserWritable>
}

export type PaginatedReturnTaskListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnTaskReadable>
}

export type PaginatedReturnTaskListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnTaskWritable>
}

export type PaginatedReturnSubIndustryListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnSubIndustryReadable>
}

export type PaginatedReturnSubIndustryListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnSubIndustryWritable>
}

export type PaginatedReturnStepListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnStepReadable>
}

export type PaginatedReturnStepListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnStepWritable>
}

export type PaginatedReturnShortLeadSequenceListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnShortLeadSequenceReadable>
}

export type PaginatedReturnShortLeadSequenceListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnShortLeadSequenceWritable>
}

export type PaginatedReturnProductListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnProductReadable>
}

export type PaginatedReturnProductListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnProductWritable>
}

export type PaginatedReturnOutlookMailboxListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOutlookMailboxReadable>
}

export type PaginatedReturnOutlookMailboxListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOutlookMailboxWritable>
}

export type PaginatedReturnOpportunityStatusListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityStatusReadable>
}

export type PaginatedReturnOpportunityStatusListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityStatusWritable>
}

export type PaginatedReturnOpportunityProductListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityProductReadable>
}

export type PaginatedReturnOpportunityProductListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityProductWritable>
}

export type PaginatedReturnOpportunityPipelineNomenclatorListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityPipelineNomenclatorReadable>
}

export type PaginatedReturnOpportunityPipelineNomenclatorListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityPipelineNomenclatorWritable>
}

export type PaginatedReturnOpportunityListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityReadable>
}

export type PaginatedReturnOpportunityListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnOpportunityWritable>
}

export type PaginatedReturnLogsListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLogsReadable>
}

export type PaginatedReturnLogsListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLogsWritable>
}

export type PaginatedReturnLeadTypeListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLeadTypeReadable>
}

export type PaginatedReturnLeadTypeListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLeadTypeWritable>
}

export type PaginatedReturnLeadStatusListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLeadStatusReadable>
}

export type PaginatedReturnLeadStatusListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLeadStatusWritable>
}

export type PaginatedReturnLeadListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLeadReadable>
}

export type PaginatedReturnLeadListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnLeadWritable>
}

export type PaginatedReturnJobPositionListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnJobPositionReadable>
}

export type PaginatedReturnJobPositionListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnJobPositionWritable>
}

export type PaginatedReturnImportListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnImportReadable>
}

export type PaginatedReturnImportListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnImportWritable>
}

export type PaginatedReturnDynamicSearchListList = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnDynamicSearchList>
}

export type PaginatedReturnDocumentListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnDocumentReadable>
}

export type PaginatedReturnDocumentListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnDocumentWritable>
}

export type PaginatedReturnContractListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnContractReadable>
}

export type PaginatedReturnContractListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnContractWritable>
}

export type PaginatedReturnContactListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnContactReadable>
}

export type PaginatedReturnContactListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReturnContactWritable>
}

export type PaginatedRegionListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<RegionReadable>
}

export type PaginatedRegionListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<RegionWritable>
}

export type PaginatedReasonListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReasonReadable>
}

export type PaginatedReasonListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ReasonWritable>
}

export type PaginatedProductUoMListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ProductUoMReadable>
}

export type PaginatedProductUoMListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ProductUoMWritable>
}

export type PaginatedProductCategoryListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ProductCategoryReadable>
}

export type PaginatedProductCategoryListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ProductCategoryWritable>
}

export type PaginatedPresetTaskListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<PresetTaskReadable>
}

export type PaginatedPresetTaskListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<PresetTaskWritable>
}

export type PaginatedOpportunityPipelineListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<OpportunityPipelineReadable>
}

export type PaginatedOpportunityPipelineListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<OpportunityPipelineWritable>
}

export type OpportunityPipelineReadable = {
  readonly id: number
  country: CountryReadable | null
  name?: string | null
  lead: ReturnShortLeadReadable | null
  client: ClientShortReadable | null
  value?: string | null
  currency: ReceiveCurrencyReadable
  task: ReturnOpportunityShortTaskReadable
  close_date?: string | null
  readonly created_at: string | null
  status: ReturnOpportunityStatusReadable
  owner: ReturnUserReadable
}

export type OpportunityPipelineWritable = {
  country: CountryWritable | null
  name?: string | null
  lead: ReturnShortLeadWritable | null
  client: ClientShortWritable | null
  value?: string | null
  currency: ReceiveCurrencyWritable
  task: ReturnOpportunityShortTaskWritable
  close_date?: string | null
  status: ReturnOpportunityStatusWritable
  owner: ReturnUserWritable
}

export type PaginatedMessengerMailboxListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<MessengerMailboxReadable>
}

export type PaginatedMessengerMailboxListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<MessengerMailboxWritable>
}

export type MessengerMailboxReadable = {
  readonly id: number
  readonly modified_at: string | null
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type MessengerMailboxWritable = {
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type PaginatedListViewReturnListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ListViewReturnReadable>
}

export type PaginatedListViewReturnListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ListViewReturnWritable>
}

export type ListViewReturnReadable = {
  readonly id: number
  name?: string | null
  is_private?: boolean
  filter_logic?: string | null
  fields?: Array<ListViewReturnFieldReadable>
  filters?: Array<ListViewReturnFilterReadable>
  created_by?: string | null
  readonly shared_users: Array<string>
}

export type ListViewReturnWritable = {
  name?: string | null
  is_private?: boolean
  filter_logic?: string | null
  fields?: Array<ListViewReturnFieldWritable>
  filters?: Array<ListViewReturnFilterWritable>
  created_by?: string | null
}

export type ListViewReturnFilterReadable = {
  readonly id: number
  value: Array<string>
  field_name: string
  filter_operator?: FilterOperatorEnum | NullEnum | null
  order: number
}

export type ListViewReturnFilterWritable = {
  value: Array<string>
  field_name: string
  filter_operator?: FilterOperatorEnum | NullEnum | null
  order: number
}

export type ListViewReturnFieldReadable = {
  readonly id: number
  label?: string | null
  name: string
  order?: number | null
}

export type ListViewReturnFieldWritable = {
  label?: string | null
  name: string
  order?: number | null
}

export type PaginatedListViewListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ListViewReadable>
}

export type PaginatedListViewListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ListViewWritable>
}

export type ListViewReadable = {
  name?: string | null
  is_private?: boolean
  filter_logic?: string | null
  fields?: Array<ListViewFieldReadable>
  filters?: Array<ListViewFilter>
  shared_users?: Array<string>
}

export type ListViewWritable = {
  name?: string | null
  is_private?: boolean
  filter_logic?: string | null
  fields?: Array<ListViewFieldWritable>
  filters?: Array<ListViewFilter>
  shared_users?: Array<string>
}

export type PaginatedLeadSequenceReturnListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<LeadSequenceReturnReadable>
}

export type PaginatedLeadSequenceReturnListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<LeadSequenceReturnWritable>
}

export type LeadSequenceReturnReadable = {
  sequence: SequenceReadable
  current_step: StepReadable
  /**
   * Stare
   */
  status?: LeadSequenceStatus
}

export type LeadSequenceReturnWritable = {
  sequence: SequenceWritable
  current_step: StepWritable
  /**
   * Stare
   */
  status?: LeadSequenceStatus
}

export type PaginatedLeadScoreRatingListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<LeadScoreRatingReadable>
}

export type PaginatedLeadScoreRatingListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<LeadScoreRatingWritable>
}

export type LeadScoreRatingReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  criterion: CriterionEnum
  to_add?: boolean
  expression: ExpressionEnum
  add_score?: number
  value?: Array<string>
  readonly account: string | null
}

export type LeadScoreRatingWritable = {
  criterion: CriterionEnum
  to_add?: boolean
  expression: ExpressionEnum
  add_score?: number
  value?: Array<string>
}

export type PaginatedLeadGenerationRunListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<LeadGenerationRunReadable>
}

export type PaginatedLeadGenerationRunListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<LeadGenerationRunWritable>
}

export type LeadGenerationRunReadable = {
  readonly id: number
  campaign: GeneratorKey
  status: LeadGenerationRunStatusEnum
  trigger: TriggerEnum
  triggered_by: ReturnOwnerReadable
  readonly created_at: string | null
  readonly finished_at: string | null
  readonly candidates_total: number
  readonly leads_created: number
  readonly leads_updated: number
  readonly rejected: number
  readonly errors: number
  readonly error_details: Array<string>
}

export type LeadGenerationRunWritable = {
  campaign: GeneratorKey
  status: LeadGenerationRunStatusEnum
  trigger: TriggerEnum
  triggered_by: ReturnOwnerWritable
}

/**
 * * `started` - Started
 * * `running` - Running
 * * `finished` - Finished
 * * `finished_with_errors` - Finished with errors
 * * `failed` - Failed
 * * `reaped` - Reaped
 */
export type LeadGenerationRunStatusEnum =
  | 'started'
  | 'running'
  | 'finished'
  | 'finished_with_errors'
  | 'failed'
  | 'reaped'

/**
 * * `started` - Started
 * * `running` - Running
 * * `finished` - Finished
 * * `finished_with_errors` - Finished with errors
 * * `failed` - Failed
 * * `reaped` - Reaped
 */
export const LeadGenerationRunStatusEnum = {
  STARTED: 'started',
  RUNNING: 'running',
  FINISHED: 'finished',
  FINISHED_WITH_ERRORS: 'finished_with_errors',
  FAILED: 'failed',
  REAPED: 'reaped'
} as const

export type PaginatedInvoiceListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<InvoiceReadable>
}

export type PaginatedInvoiceListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<InvoiceWritable>
}

export type InvoiceReadable = {
  readonly id: number
  contacts: Array<ReturnShortContactReadable>
  lead: ReturnShortLeadReadable
  product: ProductReadable
  currency: CurrencyReadable
  received_currency: ReceiveCurrencyReadable
  amounts: Array<InvoiceAmountReadable>
  readonly total_quantity: number
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  product_name?: string | null
  title: string
  due_date?: string | null
  remind_periodicity: number
  email_message?: string | null
  status?: InvoiceStatus
  pay_date?: string | null
  invoice_number: string
  received_amount?: number | null
  total_amount?: number | null
  additional_emails?: Array<string> | null
  readonly account: string | null
  created_by?: string | null
}

export type InvoiceWritable = {
  contacts: Array<ReturnShortContactWritable>
  lead: ReturnShortLeadWritable
  product: ProductWritable
  currency: CurrencyWritable
  received_currency: ReceiveCurrencyWritable
  amounts: Array<InvoiceAmountWritable>
  product_name?: string | null
  title: string
  due_date?: string | null
  remind_periodicity: number
  email_message?: string | null
  status?: InvoiceStatus
  pay_date?: string | null
  invoice_number: string
  received_amount?: number | null
  total_amount?: number | null
  additional_emails?: Array<string> | null
  created_by?: string | null
}

export type PaginatedInternalCurrencyListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<InternalCurrencyReadable>
}

export type PaginatedInternalCurrencyListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<InternalCurrencyWritable>
}

export type InternalCurrencyReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  ratio?: number
  name: string
  code?: string | null
  symbol: string
  is_default?: boolean
}

export type InternalCurrencyWritable = {
  ratio?: number
  name: string
  code?: string | null
  symbol: string
  is_default?: boolean
}

export type PaginatedInformationListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<InformationReadable>
}

export type PaginatedInformationListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<InformationWritable>
}

export type InformationReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  title: string
  description: string
  readonly account: string | null
}

export type InformationWritable = {
  title: string
  description: string
}

export type PaginatedIndustryListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<IndustryReadable>
}

export type PaginatedIndustryListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<IndustryWritable>
}

export type PaginatedGmailMailboxListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<GmailMailboxReadable>
}

export type PaginatedGmailMailboxListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<GmailMailboxWritable>
}

export type GmailMailboxReadable = {
  readonly id: number
  readonly modified_at: string | null
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type GmailMailboxWritable = {
  created_at?: string | null
  mailbox_type?: MailboxTypeEnum
  status?: MailboxStatus
  auth_data?: unknown
  from_email?: string | null
  from_name: string
  last_imap_sync_at?: string | null
  last_error?: string | null
  account?: string | null
  agent?: string | null
}

export type PaginatedGlobalSearchListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<GlobalSearchReadable>
}

export type PaginatedGlobalSearchListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<GlobalSearchWritable>
}

export type GlobalSearchReadable = {
  readonly id: number
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Filială
   */
  branch?: number | null
  source: SourceReadable
  readonly created_at: string | null
  readonly modified_at: string | null
  owner: ReturnUserReadable
  primary_contact: ShortContactReadable
  status: ReturnLeadStatusReadable
  reason: ReasonReadable
  opportunities: Array<ShortOpportunityReadable>
  country: CountryReadable
  industry: IndustryReadable
}

export type GlobalSearchWritable = {
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Filială
   */
  branch?: number | null
  source: SourceWritable
  owner: ReturnUserWritable
  primary_contact: ShortContactWritable
  status: ReturnLeadStatusWritable
  reason: ReasonWritable
  opportunities: Array<ShortOpportunityWritable>
  country: CountryWritable
  industry: IndustryWritable
}

export type PaginatedExportListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ExportReadable>
}

export type PaginatedExportListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ExportWritable>
}

export type ExportReadable = {
  readonly id: number
  attachment: AttachmentReadable
  created_by: ReturnUserReadable
  readonly modified_at: string | null
  readonly created_at: string | null
  type?: ExportTypeEnum
  format?: FormatEnum
  status?: ExportStatusEnum
  task_id?: string | null
  error?: string | null
  ready_at?: string | null
  readonly account: string | null
}

export type ExportWritable = {
  attachment: AttachmentWritable
  created_by: ReturnUserWritable
  type?: ExportTypeEnum
  format?: FormatEnum
  status?: ExportStatusEnum
  task_id?: string | null
  error?: string | null
  ready_at?: string | null
}

/**
 * * `pending` - Pending
 * * `done` - Done
 * * `failed` - Failed
 */
export type ExportStatusEnum = 'pending' | 'done' | 'failed'

/**
 * * `pending` - Pending
 * * `done` - Done
 * * `failed` - Failed
 */
export const ExportStatusEnum = {
  PENDING: 'pending',
  DONE: 'done',
  FAILED: 'failed'
} as const

/**
 * * `top_products` - Top Products
 * * `category_distribution` - Category Distribution
 */
export type ExportTypeEnum = 'top_products' | 'category_distribution'

/**
 * * `top_products` - Top Products
 * * `category_distribution` - Category Distribution
 */
export const ExportTypeEnum = {
  TOP_PRODUCTS: 'top_products',
  CATEGORY_DISTRIBUTION: 'category_distribution'
} as const

export type PaginatedEmailTemplateListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<EmailTemplateReadable>
}

export type PaginatedEmailTemplateListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<EmailTemplateWritable>
}

export type EmailTemplateReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  title: string
  subject: string
  message: string
  is_public?: boolean
  readonly account: string | null
  created_by?: string | null
}

export type EmailTemplateWritable = {
  title: string
  subject: string
  message: string
  is_public?: boolean
  created_by?: string | null
}

export type PaginatedDropdownList = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<Dropdown>
}

export type Dropdown = {
  key: number
  label: string
}

export type PaginatedDocumentCategoryListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<DocumentCategoryReadable>
}

export type PaginatedDocumentCategoryListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<DocumentCategoryWritable>
}

export type PaginatedCustomFieldRetrieveListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CustomFieldRetrieveReadable>
}

export type PaginatedCustomFieldRetrieveListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CustomFieldRetrieveWritable>
}

export type CustomFieldRetrieveReadable = {
  readonly id: number
  /**
   * Key [en]
   */
  readonly key_en: string | null
  /**
   * Key [ro]
   */
  readonly key_ro: string | null
  /**
   * Key [ru]
   */
  readonly key_ru: string | null
  /**
   * Key [it]
   */
  readonly key_it: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  readonly is_required: boolean
  validation_rules: {
    min?: number
    max?: number
    pattern?: string
  }
  options: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  readonly default_value: unknown
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly deleted_at: string | null
}

export type CustomFieldRetrieveWritable = {
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type: EntityTypeEnum | NullEnum | null
  validation_rules: {
    min?: number
    max?: number
    pattern?: string
  }
  options: Array<{
    value?: string
    label?: string
  }>
}

export type PaginatedCurrencyListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CurrencyReadable>
}

export type PaginatedCurrencyListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CurrencyWritable>
}

export type PaginatedCountryListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CountryReadable>
}

export type PaginatedCountryListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CountryWritable>
}

export type PaginatedContinentListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<Continent>
}

export type PaginatedContinentListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<any>
}

export type Continent = {
  readonly name: string
}

export type PaginatedContactPhoneListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ContactPhoneReadable>
}

export type PaginatedContactPhoneListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ContactPhoneWritable>
}

export type PaginatedContactListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ContactReadable>
}

export type PaginatedContactListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ContactWritable>
}

export type ContactReadable = {
  readonly id: number
  phone_numbers?: Array<ContactPhoneNumberNested>
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name: string
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon fix valid
   */
  readonly landline_number_valid: boolean | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  readonly email_valid: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Cont
   */
  readonly account: string | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type ContactWritable = {
  phone_numbers?: Array<ContactPhoneNumberNested>
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name: string
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type PaginatedCompanySizeListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CompanySizeReadable>
}

export type PaginatedCompanySizeListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CompanySizeWritable>
}

export type PaginatedClientStatusListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ClientStatusReadable>
}

export type PaginatedClientStatusListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ClientStatusWritable>
}

export type ClientStatusReadable = {
  readonly id: number
  name: string
  color?: string
  allowed_transition_statuses?: Array<number>
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly account: string | null
}

export type ClientStatusWritable = {
  name: string
  color?: string
  allowed_transition_statuses?: Array<number>
}

export type PaginatedClientListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ClientReadable>
}

export type PaginatedClientListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<ClientWritable>
}

export type ClientReadable = {
  readonly id: number
  name: string | null
  status: ClientStatusReadable
  primary_contact: ReturnShortContactReadable
  identification_number: string
  created_by: User
  person_type?: string | null
  readonly created_at: string | null
  readonly modified_at: string | null
  readonly account: string | null
}

export type ClientWritable = {
  name: string | null
  status: ClientStatusWritable
  primary_contact: ReturnShortContactWritable
  identification_number: string
  created_by: User
  person_type?: string | null
}

export type PaginatedCityListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CityReadable>
}

export type PaginatedCityListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CityWritable>
}

export type PaginatedCascoCampaignList = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CascoCampaign>
}

/**
 * Schema-only variant that types the `criteria` object for the CASCO family.
 *
 * Drives the OpenAPI docs for the campaign endpoints (the single family today), not
 * runtime: the runtime serializer keeps `criteria` as free JSON and validates it via
 * the generator. When a second family appears, wrap the per-family variants in a
 * drf_spectacular PolymorphicProxySerializer again (see views.py).
 */
export type CascoCampaign = {
  name: string
  generator_key: GeneratorKey
  is_active?: boolean
  run_time?: string
  criteria: CascoCriteria
}

export type PaginatedCallListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CallReadable>
}

export type PaginatedCallListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<CallWritable>
}

export type CallReadable = {
  readonly id: number
  agent: ReturnUserReadable
  contact: ShortContactReadable
  readonly modified_at: string | null
  created_at?: string | null
  old_id?: string | null
  call_duration: number
  end_at?: string
  answered: boolean
  start_at: string
  to_phone_number?: number | null
  readonly file_legacy_url: string | null
  from_phone_number?: number | null
  type: CallTypeEnum
  account?: string | null
  attachment?: number | null
}

export type CallWritable = {
  agent: ReturnUserWritable
  contact: ShortContactWritable
  created_at?: string | null
  old_id?: string | null
  call_duration: number
  end_at?: string
  answered: boolean
  start_at: string
  to_phone_number?: number | null
  from_phone_number?: number | null
  type: CallTypeEnum
  account?: string | null
  attachment?: number | null
}

export type PaginatedAttachmentListReadable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<AttachmentReadable>
}

export type PaginatedAttachmentListWritable = {
  count: number
  next?: number | null
  previous?: number | null
  results: Array<AttachmentWritable>
}

export type OptionsListReturn = {
  results: unknown
}

export type OpportunityProductBulkUpdateItem = {
  id: number
  product: number
  opportunity: number
  quantity?: string | null
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  /**
   * Unitate de măsură
   */
  uom?: number | null
  currency?: number | null
}

export type OpportunityProductBulkCreateItemReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  quantity?: string | null
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  readonly account: string | null
  product: number
  opportunity: number
  /**
   * Unitate de măsură
   */
  uom?: number | null
  currency?: number | null
}

export type OpportunityProductBulkCreateItemWritable = {
  quantity?: string | null
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  product: number
  opportunity: number
  /**
   * Unitate de măsură
   */
  uom?: number | null
  currency?: number | null
}

export type OpportunityProductReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * Cantitate
   */
  quantity?: string | null
  /**
   * Preț personalizat
   */
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  readonly account: string | null
  /**
   * Produs
   */
  product: number
  /**
   * Oportunitate
   */
  opportunity: number
  /**
   * Unitate de măsură
   */
  uom?: number | null
  /**
   * Monedă
   */
  currency?: number | null
}

export type OpportunityProductWritable = {
  /**
   * Cantitate
   */
  quantity?: string | null
  /**
   * Preț personalizat
   */
  custom_price?: string | null
  /**
   * Discount suplimentar (%)
   */
  extra_discount?: string | null
  /**
   * Produs
   */
  product: number
  /**
   * Oportunitate
   */
  opportunity: number
  /**
   * Unitate de măsură
   */
  uom?: number | null
  /**
   * Monedă
   */
  currency?: number | null
}

export type OpportunityPipelineNomenclatorReadable = {
  readonly id: number
  responsible?: string | null
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type OpportunityPipelineNomenclatorWritable = {
  responsible?: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
}

export type OpportunityReadable = {
  readonly id: number
  owner?: string
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  value?: string | null
  /**
   * Valoare de bază
   */
  value_base?: string
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Identificator
   */
  readonly identifier: number | null
  /**
   * Probabilitate
   */
  probability?: number
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Monedă
   */
  currency?: number | null
  contact?: number | null
  /**
   * Produs
   */
  product?: number | null
  lead?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  /**
   * Creat de
   */
  readonly created_by: string | null
  client?: number | null
  /**
   * Produse
   */
  products?: Array<number>
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type OpportunityWritable = {
  owner?: string
  create_task?: boolean
  /**
   * Nume
   */
  name?: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Note
   */
  notes?: string | null
  /**
   * Data închiderii
   */
  close_date?: string | null
  /**
   * Valoare
   */
  value?: string | null
  /**
   * Valoare de bază
   */
  value_base?: string
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Probabilitate
   */
  probability?: number
  /**
   * Câmpuri personalizate
   */
  custom_field_values?: unknown
  /**
   * Monedă
   */
  currency?: number | null
  contact?: number | null
  /**
   * Produs
   */
  product?: number | null
  lead?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  /**
   * Stare
   */
  status?: number | null
  client?: number | null
  /**
   * Produse
   */
  products?: Array<number>
  /**
   * Etichete
   */
  tags?: Array<number>
}

export type OnlineReportReadable = {
  readonly id: number
  leads: number
  readonly conversion_leads: number
  visits: number
  opportunities: number
  readonly conversion_opportunities: number
  signed_contracts: number
  readonly conversion_contracts: number
  sum_signed_contracts: number
  readonly avg_signed_contracts: number
  marketing_cost: number
  readonly roi: number
  readonly cost_per_visit: number
  budget: number
  readonly variation: number
  readonly modified_at: string | null
  created_at?: string | null
  name: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug: string | null
  account: string | null
}

export type OnlineReportWritable = {
  leads: number
  visits: number
  opportunities: number
  signed_contracts: number
  sum_signed_contracts: number
  marketing_cost: number
  budget: number
  created_at?: string | null
  name: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug: string | null
  account: string | null
}

export type OfflineReportReadable = {
  readonly id: number
  leads: number
  opportunities: number
  readonly conversion_opportunities: number
  contracts: number
  readonly conversion_contracts: number
  sum_signed_contracts: number
  readonly avg_signed_contracts: number
  marketing_cost: number
  readonly roi: number
  budget: number
  readonly variation: number
  readonly modified_at: string | null
  created_at?: string | null
  name: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug: string | null
  account: string | null
}

export type OfflineReportWritable = {
  leads: number
  opportunities: number
  contracts: number
  sum_signed_contracts: number
  marketing_cost: number
  budget: number
  created_at?: string | null
  name: string
  expression?: string | null
  source_type?: SourceTypeEnum
  channel?: ChannelEnum
  url?: string | null
  slug: string | null
  account: string | null
}

export type NoteLogs = {
  description: string
  lead?: number | null
  opportunity?: number | null
  task?: number | null
}

export type MonthlyExpensesReadable = {
  readonly id: number
  date: string
  current: number
  budget: number
  source: number
  readonly account: string | null
}

export type MonthlyExpensesWritable = {
  date: string
  current: number
  budget: number
  source: number
}

export type MeetingLogs = {
  description: string
  meeting_with?: Array<string>
  meeting_on?: string | null
  lead?: number | null
  action: ActionEnum
}

export type Mapping = {
  label?: string | null
  field_name: string
}

export type LeadStatusReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  is_conversion?: boolean
  requires_opportunity?: boolean
  requires_refusal_reason?: boolean
  lead_type?: number | null
  allowed_transition_statuses?: Array<number>
}

export type LeadStatusWritable = {
  name: string
  code: string
  color?: string
  is_default?: boolean
  order?: number | null
  is_conversion?: boolean
  requires_opportunity?: boolean
  requires_refusal_reason?: boolean
  lead_type?: number | null
  allowed_transition_statuses?: Array<number>
}

export type LeadSequenceUpdate = {
  /**
   * Pasul curent
   */
  current_step?: number | null
  /**
   * Stare
   */
  status?: LeadSequenceStatus
}

export type LeadInvoiceContactReadable = {
  selected: Array<number>
  additional_emails: Array<string>
  contacts: Array<ContactReadable>
}

export type LeadInvoiceContactWritable = {
  selected: Array<number>
  additional_emails: Array<string>
  contacts: Array<ContactWritable>
}

export type InvoiceUpdateReadable = {
  received_amount?: number | null
  status?: InvoiceStatus
  pay_date?: string | null
}

export type InvoiceUpdateWritable = {
  contacts: Array<number>
  received_amount?: number | null
  status?: InvoiceStatus
  pay_date?: string | null
}

export type ImportReadable = {
  readonly id: number
  type?: Type5DfEnum
  notes?: string | null
  headers?: {
    lead_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
    contact_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
  }
  attachment?: number | null
  owner?: string | null
  create_type?: CreateTypeEnum
  unique_verify?: Array<string>
  step?: StepEnum
  progress?: number
  status?: StatusF6fEnum
  lead_type?: number | null
  status_mapping?: {
    [key: string]: number
  }
  status_column?: number
  duplicates?: Array<{
    fields?: Array<string>
    values?: Array<string>
  }>
  existing_duplicates?: Array<{
    field?: string
    values?: Array<string>
  }>
  defaults?: {
    lead?: {
      lead_type?: number
      status?: number
    }
    contact?: {
      owner?: number
    }
  }
  pipeline?: number
}

export type ImportWritable = {
  type?: Type5DfEnum
  notes?: string | null
  headers?: {
    lead_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
    contact_headers?: Array<{
      column_index: number
      key?: string
      custom_field_id?: number | null
    }>
  }
  attachment?: number | null
  owner?: string | null
  create_type?: CreateTypeEnum
  unique_verify?: Array<string>
  step?: StepEnum
  progress?: number
  status?: StatusF6fEnum
  lead_type?: number | null
  status_mapping?: {
    [key: string]: number
  }
  status_column?: number
  duplicates?: Array<{
    fields?: Array<string>
    values?: Array<string>
  }>
  existing_duplicates?: Array<{
    field?: string
    values?: Array<string>
  }>
  defaults?: {
    lead?: {
      lead_type?: number
      status?: number
    }
    contact?: {
      owner?: number
    }
  }
  pipeline?: number
}

export type HealthCheck = {
  live?: boolean
}

export type HeadersResponse = {
  lead_fields: Array<HeaderField>
  contact_fields: Array<HeaderField>
}

export type HeaderField = {
  key: string
  label: string
  required: boolean
  unique?: boolean
  custom_field_id?: number | null
  type?: string | null
  options?: Array<HeaderCustomFieldOption> | null
}

export type HeaderCustomFieldOption = {
  label: string
  value: string
}

export type FetchSiAsigContract = {
  contract_number: string
}

/**
 * Makes the listed fields read-only for operators; operator-submitted values are ignored.
 */
export type ExtendedLeadReadable = {
  readonly id: number
  contacts?: Array<ExtendedContactLeadReadable>
  contact?: ExtendedContactLeadReadable
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  /**
   * Sursă
   */
  source?: number | null
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  owner?: string
  /**
   * Filială
   */
  branch?: number | null
  status?: number
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Industrie
   */
  industry?: number | null
  /**
   * Sub-industrie
   */
  sub_industry?: number | null
  /**
   * Dimensiunea companiei
   */
  size?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  linkedin?: string | null
  /**
   * Țară
   */
  country?: number | null
  region?: number | null
  city?: number | null
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  /**
   * Etichete
   */
  tags?: Array<number>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: unknown
  lead_type?: number | null
  /**
   * Număr de identificare. Tipuri permise: IDNP, IDNO. Trebuie să aibă 13 cifre. IDNP începe cu "2" sau "09", IDNO începe cu "1".
   */
  identification_number?: string | null
}

/**
 * Makes the listed fields read-only for operators; operator-submitted values are ignored.
 */
export type ExtendedLeadWritable = {
  contacts?: Array<ExtendedContactLeadWritable>
  contact?: ExtendedContactLeadWritable
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  /**
   * Site Web
   */
  website?: string | null
  /**
   * Sursă
   */
  source?: number | null
  /**
   * Site sursă
   */
  source_website?: string | null
  /**
   * Pagina sursă
   */
  source_page?: string | null
  owner?: string
  /**
   * Filială
   */
  branch?: number | null
  status?: number
  /**
   * Ordine în status
   */
  status_order?: string | null
  /**
   * Comentariu
   */
  comment?: string | null
  /**
   * Industrie
   */
  industry?: number | null
  /**
   * Sub-industrie
   */
  sub_industry?: number | null
  /**
   * Dimensiunea companiei
   */
  size?: number | null
  /**
   * Motiv
   */
  reason?: number | null
  linkedin?: string | null
  /**
   * Țară
   */
  country?: number | null
  region?: number | null
  city?: number | null
  /**
   * Adresă
   */
  address?: string | null
  /**
   * Data demo
   */
  demo_date?: string | null
  /**
   * Etichete
   */
  tags?: Array<number>
  /**
   * Campanie UTM
   */
  campaign_utm?: string | null
  custom_field_values?: unknown
  lead_type?: number | null
  /**
   * Număr de identificare. Tipuri permise: IDNP, IDNO. Trebuie să aibă 13 cifre. IDNP începe cu "2" sau "09", IDNO începe cu "1".
   */
  identification_number?: string | null
  contract_number?: string
}

export type ExtendedContactReadable = {
  readonly id: number
  phone_numbers?: Array<ContactPhoneNumberNested>
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon fix valid
   */
  readonly landline_number_valid: boolean | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  readonly email_valid: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  /**
   * Cont
   */
  readonly account: string | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type ExtendedContactWritable = {
  phone_numbers?: Array<ContactPhoneNumberNested>
  /**
   * ID vechi
   */
  old_id?: string | null
  email?: string | null
  /**
   * Nume
   */
  first_name?: string | null
  /**
   * Număr de telefon
   */
  phone_number?: number | null
  /**
   * Număr de telefon fix
   */
  landline_number?: number | null
  /**
   * Prenume
   */
  last_name?: string | null
  /**
   * Nume funcție
   */
  job_title?: string | null
  linkedin?: string | null
  /**
   * Număr de telefon valid
   */
  phone_number_valid?: boolean | null
  /**
   * Date suplimentare
   */
  additional_data?: unknown
  custom_field_values?: Array<{
    field_id: number
    field_type: string
    field_key_en?: string
    field_key_ro?: string
    field_key_ru?: string
    field_key_it?: string
    values: Array<{
      value?: string
    }>
    required?: boolean
  }>
  /**
   * Poziție superioară
   */
  senior_position?: number | null
  /**
   * Funcție
   */
  job_position?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
  /**
   * Leaduri
   */
  leads?: Array<number>
  /**
   * Oportunități
   */
  opportunities?: Array<number>
}

export type ExpensesReturnReadable = {
  online: Array<MonthlyExpensesReadable>
  offline: Array<MonthlyExpensesReadable>
}

export type ExpensesReturnWritable = {
  online: Array<MonthlyExpensesWritable>
  offline: Array<MonthlyExpensesWritable>
}

export type DocumentReadable = {
  readonly id: number
  is_public?: boolean | null
  readonly deleted_at: string | null
  readonly deleted_by_cascade: boolean
  readonly modified_at: string | null
  readonly created_at: string | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * URL fișier vechi
   */
  readonly file_legacy_url: string | null
  readonly account: string | null
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Responsabil
   */
  readonly owner: string
  /**
   * Categorie
   */
  category?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type DocumentWritable = {
  is_public?: boolean | null
  /**
   * ID vechi
   */
  old_id?: string | null
  /**
   * Nume
   */
  name?: string | null
  /**
   * Atașament
   */
  attachment?: number | null
  /**
   * Categorie
   */
  category?: number | null
  lead?: number | null
  /**
   * Oportunitate
   */
  opportunity?: number | null
  client?: number | null
}

export type DashboardTasksReturnReadable = {
  user: TasksReadable
}

export type DashboardTasksReturnWritable = {
  user: TasksWritable
}

export type DashboardReports = {
  date: string
  value: number
}

export type DashboardLeadReadable = {
  readonly id: number
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  status: LeadStatusReadable
  lead_value: number
  currency: string
}

export type DashboardLeadWritable = {
  /**
   * Denumire Companie sau Persoană
   */
  name?: string | null
  status: LeadStatusWritable
  lead_value: number
  currency: string
}

export type CustomFieldUpdateReadable = {
  readonly id: number
  /**
   * Key [en]
   */
  key_en?: string | null
  /**
   * Key [ro]
   */
  key_ro?: string | null
  /**
   * Key [ru]
   */
  key_ru?: string | null
  /**
   * Key [it]
   */
  key_it?: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  is_required?: boolean
  validation_rules?: {
    min?: number
    max?: number
    pattern?: string
  }
  options?: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  default_value?: unknown
}

export type CustomFieldUpdateWritable = {
  /**
   * Key [en]
   */
  key_en?: string | null
  /**
   * Key [ro]
   */
  key_ro?: string | null
  /**
   * Key [ru]
   */
  key_ru?: string | null
  /**
   * Key [it]
   */
  key_it?: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  is_required?: boolean
  validation_rules?: {
    min?: number
    max?: number
    pattern?: string
  }
  options?: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  default_value?: unknown
}

export type CustomFieldCreateReadable = {
  readonly id: number
  /**
   * Key [en]
   */
  key_en?: string | null
  /**
   * Key [ro]
   */
  key_ro?: string | null
  /**
   * Key [ru]
   */
  key_ru?: string | null
  /**
   * Key [it]
   */
  key_it?: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type?: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type?: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  is_required?: boolean
  validation_rules?: {
    min?: number
    max?: number
    pattern?: string
  }
  options?: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  default_value?: unknown
}

export type CustomFieldCreateWritable = {
  /**
   * Key [en]
   */
  key_en?: string | null
  /**
   * Key [ro]
   */
  key_ro?: string | null
  /**
   * Key [ru]
   */
  key_ru?: string | null
  /**
   * Key [it]
   */
  key_it?: string | null
  /**
   * Type of the field
   *
   * * `text` - Text
   * * `number` - Număr
   * * `boolean` - Casetă de bifare
   * * `date` - Dată
   * * `select` - Selectare
   * * `multiselect` - Selecție multiplă
   */
  type?: Type83fEnum
  /**
   * Entity this field applies to
   *
   * * `lead` - Lead
   * * `opportunity` - Oportunitate
   * * `contact` - Contact
   */
  entity_type?: EntityTypeEnum | NullEnum | null
  /**
   * Is this field required?
   */
  is_required?: boolean
  validation_rules?: {
    min?: number
    max?: number
    pattern?: string
  }
  options?: Array<{
    value?: string
    label?: string
  }>
  /**
   * Default value for new records
   */
  default_value?: unknown
}

export type CreateUploadUrl = {
  title: string
  type?: AttachmentType
}

export type ContactConnectionNodes = {
  id: number
  original_id: number
  name?: string | null
  phone?: string | null
  type: string
  links: Array<number>
}

export type CompleteTask = {
  /**
   * Comentariu
   */
  comment?: string | null
}

export type CompanyCreateReadable = {
  readonly id: number
  bank_accounts: Array<CompanyBankAccountReadable>
  readonly modified_at: string | null
  readonly created_at: string | null
  readonly logo_legacy_url: string | null
  name: string
  email: string
  state?: string | null
  city?: string | null
  address?: string | null
  postal_code?: string | null
  invoice_order?: number
  invoice_year?: number
  readonly account: string | null
  attachment?: number | null
  country?: number | null
}

export type CompanyCreateWritable = {
  bank_accounts: Array<CompanyBankAccountWritable>
  name: string
  email: string
  state?: string | null
  city?: string | null
  address?: string | null
  postal_code?: string | null
  invoice_order?: number
  invoice_year?: number
  attachment?: number | null
  country?: number | null
}

export type CompanyBankAccountReadable = {
  readonly id: number
  readonly modified_at: string | null
  readonly created_at: string | null
  swift: string
  bank_name: string
  account_name: string
  bank_iban: string
  bank_address: string
  readonly account: string | null
  readonly company: number
  currency?: number | null
}

export type CompanyBankAccountWritable = {
  swift: string
  bank_name: string
  account_name: string
  bank_iban: string
  bank_address: string
  currency?: number | null
}

export type CompanyReadable = {
  readonly id: number
  attachment: AttachmentReadable
  bank_accounts: Array<CompanyBankAccountReadable>
  readonly modified_at: string | null
  readonly created_at: string | null
  readonly logo_legacy_url: string | null
  name: string
  email: string
  state?: string | null
  city?: string | null
  address?: string | null
  postal_code?: string | null
  invoice_order?: number
  invoice_year?: number
  readonly account: string | null
  country?: number | null
}

export type CompanyWritable = {
  attachment: AttachmentWritable
  bank_accounts: Array<CompanyBankAccountWritable>
  name: string
  email: string
  state?: string | null
  city?: string | null
  address?: string | null
  postal_code?: string | null
  invoice_order?: number
  invoice_year?: number
  country?: number | null
}

export type ChartData = {
  total: number | null
  data: unknown
  mapping: Array<Mapping>
}

export type CategoryDistributionResponse = {
  categories: Array<CategoryDistributionItem>
  total_value: number
  currency?: SalesFunnelCurrency | null
}

export type CategoryDistributionItem = {
  category_id: number | null
  category_name: string | null
  opportunity_count: number
  total_value: number
}

export type CategoryDistributionExportRequest = {
  date_from: string
  date_to: string
  category?: number | null
  owner?: string | null
  pipeline?: number | null
  status?: number | null
  ordering?: OrderingEnum
  limit?: number
  format?: FormatEnum
}

export type CallsReportReadable = {
  id: string
  incoming_calls: number
  outgoing_calls: number
  readonly total_calls: number
  incoming_calls_duration: number
  outgoing_calls_duration: number
  readonly total_calls_duration: number
  incoming_leads: number
  outgoing_leads: number
  readonly total_leads: number
  incoming_signed_contracts: number
  outgoing_signed_contracts: number
  readonly total_signed_contracts: number
  incoming_signed_contracts_value: number
  outgoing_signed_contracts_value: number
  readonly total_signed_contracts_value: number
  incoming_avg_signed_contracts_value: number
  outgoing_avg_signed_contracts_value: number
  readonly total_avg_signed_contracts_value: number
  readonly incoming_pbx_cost: number
  readonly outgoing_pbx_cost: number
  readonly total_pbx_cost: number
  old_id?: string | null
  email: string
  last_name: string
  first_name: string
  phone_number?: number | null
  countries?: Array<string> | null
  last_assign?: string | null
  archived?: boolean
}

export type CallsReportWritable = {
  id: string
  incoming_calls: number
  outgoing_calls: number
  incoming_calls_duration: number
  outgoing_calls_duration: number
  incoming_leads: number
  outgoing_leads: number
  incoming_signed_contracts: number
  outgoing_signed_contracts: number
  incoming_signed_contracts_value: number
  outgoing_signed_contracts_value: number
  incoming_avg_signed_contracts_value: number
  outgoing_avg_signed_contracts_value: number
  old_id?: string | null
  email: string
  last_name: string
  first_name: string
  phone_number?: number | null
  countries?: Array<string> | null
  last_assign?: string | null
  archived?: boolean
}

export type BulkDeleteLead = {
  leads: Array<number>
}

export type AttachmentUpdate = {
  title?: string
  metadata?: unknown
}

export type AttachmentSignedUrl = {
  readonly id: number
  readonly upload_url: string
}

export type AddBulkContacts = {
  connector: string
  leads?: Array<number>
  option: number
}

export type AttachmentsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/attachments'
}

export type AttachmentsListResponses = {
  200: PaginatedAttachmentListReadable
}

export type AttachmentsListResponse =
  AttachmentsListResponses[keyof AttachmentsListResponses]

export type AttachmentsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
  }
  query?: never
  url: '/attachments/{id}'
}

export type AttachmentsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type AttachmentsDestroyResponse =
  AttachmentsDestroyResponses[keyof AttachmentsDestroyResponses]

export type AttachmentsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
  }
  query?: never
  url: '/attachments/{id}'
}

export type AttachmentsRetrieveResponses = {
  200: AttachmentReadable
}

export type AttachmentsRetrieveResponse =
  AttachmentsRetrieveResponses[keyof AttachmentsRetrieveResponses]

export type AttachmentsPartialUpdateData = {
  body?: PatchedAttachmentUpdate
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
  }
  query?: never
  url: '/attachments/{id}'
}

export type AttachmentsPartialUpdateResponses = {
  200: AttachmentUpdate
}

export type AttachmentsPartialUpdateResponse =
  AttachmentsPartialUpdateResponses[keyof AttachmentsPartialUpdateResponses]

export type AttachmentsUpdateData = {
  body?: AttachmentUpdate
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
  }
  query?: never
  url: '/attachments/{id}'
}

export type AttachmentsUpdateResponses = {
  200: AttachmentUpdate
}

export type AttachmentsUpdateResponse =
  AttachmentsUpdateResponses[keyof AttachmentsUpdateResponses]

export type AttachmentsUpdateSignedUrlCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
  }
  query?: never
  url: '/attachments/{id}/update-signed-url'
}

export type AttachmentsUpdateSignedUrlCreateResponses = {
  200: AttachmentSignedUrl
}

export type AttachmentsUpdateSignedUrlCreateResponse =
  AttachmentsUpdateSignedUrlCreateResponses[keyof AttachmentsUpdateSignedUrlCreateResponses]

export type AttachmentsVersionDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
    version_id: string
  }
  query?: never
  url: '/attachments/{id}/version/{version_id}'
}

export type AttachmentsVersionDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type AttachmentsVersionDestroyResponse =
  AttachmentsVersionDestroyResponses[keyof AttachmentsVersionDestroyResponses]

export type AttachmentsVersionRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Atașament.
     */
    id: number
    version_id: string
  }
  query?: never
  url: '/attachments/{id}/version/{version_id}'
}

export type AttachmentsVersionRetrieveResponses = {
  200: AttachmentReadable
}

export type AttachmentsVersionRetrieveResponse =
  AttachmentsVersionRetrieveResponses[keyof AttachmentsVersionRetrieveResponses]

export type AttachmentsCreateSignedUrlCreateData = {
  body: CreateUploadUrl
  path?: never
  query?: never
  url: '/attachments/create-signed-url'
}

export type AttachmentsCreateSignedUrlCreateResponses = {
  201: AttachmentSignedUrl
}

export type AttachmentsCreateSignedUrlCreateResponse =
  AttachmentsCreateSignedUrlCreateResponses[keyof AttachmentsCreateSignedUrlCreateResponses]

export type BranchesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/branches/list'
}

export type BranchesListListResponses = {
  200: PaginatedDropdownList
}

export type BranchesListListResponse =
  BranchesListListResponses[keyof BranchesListListResponses]

export type CallsListData = {
  body?: never
  path?: never
  query?: {
    agent?: string
    created_at_end?: string
    created_at_start?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * * `incoming` - Incoming
     * * `outgoing` - Outgoing
     * * `missed` - Missed
     */
    type?: 'incoming' | 'missed' | 'outgoing'
  }
  url: '/calls'
}

export type CallsListResponses = {
  200: PaginatedCallListReadable
}

export type CallsListResponse = CallsListResponses[keyof CallsListResponses]

export type CallsCreateData = {
  body: CallWritable
  path?: never
  query?: never
  url: '/calls'
}

export type CallsCreateResponses = {
  201: CallReadable
}

export type CallsCreateResponse =
  CallsCreateResponses[keyof CallsCreateResponses]

export type CallsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this call.
     */
    id: number
  }
  query?: never
  url: '/calls/{id}'
}

export type CallsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type CallsDestroyResponse =
  CallsDestroyResponses[keyof CallsDestroyResponses]

export type CallsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this call.
     */
    id: number
  }
  query?: never
  url: '/calls/{id}'
}

export type CallsRetrieveResponses = {
  200: CallReadable
}

export type CallsRetrieveResponse =
  CallsRetrieveResponses[keyof CallsRetrieveResponses]

export type CallsPartialUpdateData = {
  body?: PatchedCallWritable
  path: {
    /**
     * A unique integer value identifying this call.
     */
    id: number
  }
  query?: never
  url: '/calls/{id}'
}

export type CallsPartialUpdateResponses = {
  200: CallReadable
}

export type CallsPartialUpdateResponse =
  CallsPartialUpdateResponses[keyof CallsPartialUpdateResponses]

export type CallsUpdateData = {
  body: CallWritable
  path: {
    /**
     * A unique integer value identifying this call.
     */
    id: number
  }
  query?: never
  url: '/calls/{id}'
}

export type CallsUpdateResponses = {
  200: CallReadable
}

export type CallsUpdateResponse =
  CallsUpdateResponses[keyof CallsUpdateResponses]

export type CallsSubscriptionNotificationCreateData = {
  body: CallWritable
  path?: never
  query?: never
  url: '/calls/subscription-notification'
}

export type CallsSubscriptionNotificationCreateResponses = {
  200: ReturnSuccess
}

export type CallsSubscriptionNotificationCreateResponse =
  CallsSubscriptionNotificationCreateResponses[keyof CallsSubscriptionNotificationCreateResponses]

export type CallsTriggerSubscribeCreateData = {
  body: CallWritable
  path?: never
  query?: never
  url: '/calls/trigger-subscribe'
}

export type CallsTriggerSubscribeCreateResponses = {
  200: CallReadable
}

export type CallsTriggerSubscribeCreateResponse =
  CallsTriggerSubscribeCreateResponses[keyof CallsTriggerSubscribeCreateResponses]

export type CitiesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/cities'
}

export type CitiesListResponses = {
  200: PaginatedCityListReadable
}

export type CitiesListResponse = CitiesListResponses[keyof CitiesListResponses]

export type CitiesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this city.
     */
    id: number
  }
  query?: never
  url: '/cities/{id}'
}

export type CitiesRetrieveResponses = {
  200: CityReadable
}

export type CitiesRetrieveResponse =
  CitiesRetrieveResponses[keyof CitiesRetrieveResponses]

export type CitiesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/cities/list'
}

export type CitiesListListResponses = {
  200: PaginatedDropdownList
}

export type CitiesListListResponse =
  CitiesListListResponses[keyof CitiesListListResponses]

export type ClientStatusesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/client-statuses'
}

export type ClientStatusesListResponses = {
  200: PaginatedClientStatusListReadable
}

export type ClientStatusesListResponse =
  ClientStatusesListResponses[keyof ClientStatusesListResponses]

export type ClientStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this client status.
     */
    id: number
  }
  query?: never
  url: '/client-statuses/{id}'
}

export type ClientStatusesRetrieveResponses = {
  200: ClientStatusReadable
}

export type ClientStatusesRetrieveResponse =
  ClientStatusesRetrieveResponses[keyof ClientStatusesRetrieveResponses]

export type ClientStatusesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/client-statuses/list'
}

export type ClientStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type ClientStatusesListListResponse =
  ClientStatusesListListResponses[keyof ClientStatusesListListResponses]

export type ClientsListData = {
  body?: never
  path?: never
  query?: {
    created_at_from?: string
    created_at_to?: string
    created_by?: Array<string>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * * `legal_person` - Legal Person
     * * `physical_person` - Physical Person
     */
    person_type?: Array<'legal_person' | 'physical_person'>
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    status?: Array<number>
  }
  url: '/clients'
}

export type ClientsListResponses = {
  200: PaginatedClientListReadable
}

export type ClientsListResponse =
  ClientsListResponses[keyof ClientsListResponses]

export type ClientsContactsListData = {
  body?: never
  path: {
    client_id: string
  }
  query?: {
    created_by?: string
    custom_field_values?: string
    email_valid?: boolean
    job_position?: number
    lead_client?: Array<number>
    leads?: Array<number>
    leads__owner?: string
    opportunities?: Array<number>
    opportunities__owner?: string
    opportunity_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    phone_number_valid?: boolean
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    senior_position?: number
  }
  url: '/clients/{client_id}/contacts'
}

export type ClientsContactsListResponses = {
  200: PaginatedContactListReadable
}

export type ClientsContactsListResponse =
  ClientsContactsListResponses[keyof ClientsContactsListResponses]

export type ClientsContactsRetrieveData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/contacts/{id}'
}

export type ClientsContactsRetrieveResponses = {
  200: ContactReadable
}

export type ClientsContactsRetrieveResponse =
  ClientsContactsRetrieveResponses[keyof ClientsContactsRetrieveResponses]

export type ClientsContractsListData = {
  body?: never
  path: {
    client_id: string
  }
  query?: {
    client?: Array<number>
    deadline_from?: string
    deadline_to?: string
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * Filter contracts by product
     */
    product?: string
    /**
     * A search term.
     */
    search?: string
    signed_from?: string
    signed_to?: string
    /**
     * Stare
     * * `signed` - Semnat
     * * `closed` - Închis
     */
    status?: 'closed' | 'signed'
  }
  url: '/clients/{client_id}/contracts'
}

export type ClientsContractsListResponses = {
  200: PaginatedReturnContractListReadable
}

export type ClientsContractsListResponse =
  ClientsContractsListResponses[keyof ClientsContractsListResponses]

export type ClientsContractsRetrieveData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Contract.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/contracts/{id}'
}

export type ClientsContractsRetrieveResponses = {
  200: ReturnContractReadable
}

export type ClientsContractsRetrieveResponse =
  ClientsContractsRetrieveResponses[keyof ClientsContractsRetrieveResponses]

export type ClientsLeadsListData = {
  body?: never
  path: {
    client_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/clients/{client_id}/leads'
}

export type ClientsLeadsListResponses = {
  200: PaginatedReturnLeadListReadable
}

export type ClientsLeadsListResponse =
  ClientsLeadsListResponses[keyof ClientsLeadsListResponses]

export type ClientsLeadsRetrieveData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/leads/{id}'
}

export type ClientsLeadsRetrieveResponses = {
  200: ReturnLeadReadable
}

export type ClientsLeadsRetrieveResponse =
  ClientsLeadsRetrieveResponses[keyof ClientsLeadsRetrieveResponses]

export type ClientsLogsListData = {
  body?: never
  path: {
    client_id: string
  }
  query?: {
    contact?: number
    created_at_from?: string
    created_at_to?: string
    created_by?: string
    lead_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * * `task` - Task
     * * `task_change` - Task Change
     * * `opportunity_change` - Opportunity Change
     * * `document_change` - Document Change
     * * `lead_change` - Lead Change
     * * `lead_status_changed` - Lead Status Changed
     * * `lead_reactivated` - Lead Reactivated
     * * `lead_deleted` - Lead Deleted
     * * `contact_change` - Contact Change
     * * `contract_change` - Contract Change
     * * `si_asig_sync` - Si Asig Sync
     * * `lead` - Lead
     * * `opportunity` - Opportunity
     * * `contract` - Contract
     * * `client` - Client
     * * `chat` - Chat
     * * `call` - Call
     * * `email` - Email
     * * `meeting` - Meeting
     * * `note` - Note
     * * `lead_sequence_change` - Lead Sequence Change
     * * `error` - Error
     * * `form` - Form
     * * `lead_generation` - Lead Generation
     */
    type?: Array<
      | 'call'
      | 'chat'
      | 'client'
      | 'contact_change'
      | 'contract'
      | 'contract_change'
      | 'document_change'
      | 'email'
      | 'error'
      | 'form'
      | 'lead'
      | 'lead_change'
      | 'lead_deleted'
      | 'lead_generation'
      | 'lead_reactivated'
      | 'lead_sequence_change'
      | 'lead_status_changed'
      | 'meeting'
      | 'note'
      | 'opportunity'
      | 'opportunity_change'
      | 'si_asig_sync'
      | 'task'
      | 'task_change'
    >
  }
  url: '/clients/{client_id}/logs'
}

export type ClientsLogsListResponses = {
  200: PaginatedReturnLogsListReadable
}

export type ClientsLogsListResponse =
  ClientsLogsListResponses[keyof ClientsLogsListResponses]

export type ClientsLogsRetrieveData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this logs.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/logs/{id}'
}

export type ClientsLogsRetrieveResponses = {
  200: ReturnLogsReadable
}

export type ClientsLogsRetrieveResponse =
  ClientsLogsRetrieveResponses[keyof ClientsLogsRetrieveResponses]

export type ClientsOpportunitiesListData = {
  body?: never
  path: {
    client_id: string
  }
  query?: {
    client?: Array<number>
    /**
     * Filter opportunity by created_at gte than specified date
     */
    created_at_gte?: string
    /**
     * Filter opportunity by opportunity created_at lte than specified date
     */
    created_at_lte?: string
    custom_field_values?: string
    /**
     * Filter by multiple Opportunity IDs
     */
    id?: Array<number>
    lead?: Array<number>
    name?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: Array<number>
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    product?: Array<number>
    products?: Array<number>
    /**
     * A search term.
     */
    search?: string
    status?: Array<number>
    tags?: Array<number>
    value?: number
    value_over?: number
    value_under?: number
  }
  url: '/clients/{client_id}/opportunities'
}

export type ClientsOpportunitiesListResponses = {
  200: PaginatedReturnOpportunityListReadable
}

export type ClientsOpportunitiesListResponse =
  ClientsOpportunitiesListResponses[keyof ClientsOpportunitiesListResponses]

export type ClientsOpportunitiesCreateData = {
  body?: OpportunityWritable
  path: {
    client_id: string
  }
  query?: never
  url: '/clients/{client_id}/opportunities'
}

export type ClientsOpportunitiesCreateResponses = {
  201: ReturnOpportunityReadable
}

export type ClientsOpportunitiesCreateResponse =
  ClientsOpportunitiesCreateResponses[keyof ClientsOpportunitiesCreateResponses]

export type ClientsOpportunitiesDestroyData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/opportunities/{id}'
}

export type ClientsOpportunitiesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ClientsOpportunitiesDestroyResponse =
  ClientsOpportunitiesDestroyResponses[keyof ClientsOpportunitiesDestroyResponses]

export type ClientsOpportunitiesRetrieveData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/opportunities/{id}'
}

export type ClientsOpportunitiesRetrieveResponses = {
  200: ReturnOpportunityReadable
}

export type ClientsOpportunitiesRetrieveResponse =
  ClientsOpportunitiesRetrieveResponses[keyof ClientsOpportunitiesRetrieveResponses]

export type ClientsOpportunitiesPartialUpdateData = {
  body?: PatchedOpportunityWritable
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/opportunities/{id}'
}

export type ClientsOpportunitiesPartialUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type ClientsOpportunitiesPartialUpdateResponse =
  ClientsOpportunitiesPartialUpdateResponses[keyof ClientsOpportunitiesPartialUpdateResponses]

export type ClientsOpportunitiesUpdateData = {
  body?: OpportunityWritable
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/opportunities/{id}'
}

export type ClientsOpportunitiesUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type ClientsOpportunitiesUpdateResponse =
  ClientsOpportunitiesUpdateResponses[keyof ClientsOpportunitiesUpdateResponses]

export type ClientsTasksListData = {
  body?: never
  path: {
    client_id: string
  }
  query?: {
    client?: Array<number>
    /**
     * Filter tasks by type
     */
    completed?: boolean
    created_by?: string
    /**
     * Filter tasks by deadline
     */
    deadline_end?: string
    /**
     * Filter tasks by deadline
     */
    deadline_start?: string
    lead?: Array<number>
    lead_status?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    priority?: number
    /**
     * A search term.
     */
    search?: string
    status?: number
    /**
     * Filter tasks by status active
     */
    status_active?: boolean
    type?: number
  }
  url: '/clients/{client_id}/tasks'
}

export type ClientsTasksListResponses = {
  200: PaginatedReturnTaskListReadable
}

export type ClientsTasksListResponse =
  ClientsTasksListResponses[keyof ClientsTasksListResponses]

export type ClientsTasksCreateData = {
  body: TaskWritable
  path: {
    client_id: string
  }
  query?: never
  url: '/clients/{client_id}/tasks'
}

export type ClientsTasksCreateResponses = {
  201: ReturnTaskReadable
}

export type ClientsTasksCreateResponse =
  ClientsTasksCreateResponses[keyof ClientsTasksCreateResponses]

export type ClientsTasksDestroyData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/tasks/{id}'
}

export type ClientsTasksDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ClientsTasksDestroyResponse =
  ClientsTasksDestroyResponses[keyof ClientsTasksDestroyResponses]

export type ClientsTasksRetrieveData = {
  body?: never
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/tasks/{id}'
}

export type ClientsTasksRetrieveResponses = {
  200: ReturnTaskReadable
}

export type ClientsTasksRetrieveResponse =
  ClientsTasksRetrieveResponses[keyof ClientsTasksRetrieveResponses]

export type ClientsTasksPartialUpdateData = {
  body?: PatchedTaskWritable
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/tasks/{id}'
}

export type ClientsTasksPartialUpdateResponses = {
  200: ReturnTaskReadable
}

export type ClientsTasksPartialUpdateResponse =
  ClientsTasksPartialUpdateResponses[keyof ClientsTasksPartialUpdateResponses]

export type ClientsTasksUpdateData = {
  body: TaskWritable
  path: {
    client_id: string
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/clients/{client_id}/tasks/{id}'
}

export type ClientsTasksUpdateResponses = {
  200: ReturnTaskReadable
}

export type ClientsTasksUpdateResponse =
  ClientsTasksUpdateResponses[keyof ClientsTasksUpdateResponses]

export type ClientsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Client.
     */
    id: number
  }
  query?: never
  url: '/clients/{id}'
}

export type ClientsRetrieveResponses = {
  200: ClientReadable
}

export type ClientsRetrieveResponse =
  ClientsRetrieveResponses[keyof ClientsRetrieveResponses]

export type ClientsImportContractCreateData = {
  body: FetchSiAsigContract
  path: {
    /**
     * A unique integer value identifying this Client.
     */
    id: number
  }
  query?: never
  url: '/clients/{id}/import-contract'
}

export type ClientsImportContractCreateResponses = {
  200: ReturnSuccess
}

export type ClientsImportContractCreateResponse =
  ClientsImportContractCreateResponses[keyof ClientsImportContractCreateResponses]

export type CompanySizesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/company-sizes'
}

export type CompanySizesListResponses = {
  200: PaginatedCompanySizeListReadable
}

export type CompanySizesListResponse =
  CompanySizesListResponses[keyof CompanySizesListResponses]

export type CompanySizesCreateData = {
  body: CompanySizeWritable
  path?: never
  query?: never
  url: '/company-sizes'
}

export type CompanySizesCreateResponses = {
  201: CompanySizeReadable
}

export type CompanySizesCreateResponse =
  CompanySizesCreateResponses[keyof CompanySizesCreateResponses]

export type CompanySizesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/company-sizes/{id}'
}

export type CompanySizesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type CompanySizesDestroyResponse =
  CompanySizesDestroyResponses[keyof CompanySizesDestroyResponses]

export type CompanySizesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/company-sizes/{id}'
}

export type CompanySizesRetrieveResponses = {
  200: CompanySizeReadable
}

export type CompanySizesRetrieveResponse =
  CompanySizesRetrieveResponses[keyof CompanySizesRetrieveResponses]

export type CompanySizesPartialUpdateData = {
  body?: PatchedCompanySizeWritable
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/company-sizes/{id}'
}

export type CompanySizesPartialUpdateResponses = {
  200: CompanySizeReadable
}

export type CompanySizesPartialUpdateResponse =
  CompanySizesPartialUpdateResponses[keyof CompanySizesPartialUpdateResponses]

export type CompanySizesUpdateData = {
  body: CompanySizeWritable
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/company-sizes/{id}'
}

export type CompanySizesUpdateResponses = {
  200: CompanySizeReadable
}

export type CompanySizesUpdateResponse =
  CompanySizesUpdateResponses[keyof CompanySizesUpdateResponses]

export type CompanySizesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/company-sizes/list'
}

export type CompanySizesListListResponses = {
  200: PaginatedDropdownList
}

export type CompanySizesListListResponse =
  CompanySizesListListResponses[keyof CompanySizesListListResponses]

export type ConnectorsBulkAddContactsCreateData = {
  body: AddBulkContacts
  path?: never
  query?: never
  url: '/connectors/bulk-add-contacts'
}

export type ConnectorsBulkAddContactsCreateResponses = {
  201: ReturnSuccess
}

export type ConnectorsBulkAddContactsCreateResponse =
  ConnectorsBulkAddContactsCreateResponses[keyof ConnectorsBulkAddContactsCreateResponses]

export type ConnectorsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A search term.
     */
    search?: string
  }
  url: '/connectors/list'
}

export type ConnectorsListListResponses = {
  200: Array<string>
}

export type ConnectorsListListResponse =
  ConnectorsListListResponses[keyof ConnectorsListListResponses]

export type ConnectorsOptionsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/connectors/options'
}

export type ConnectorsOptionsRetrieveResponses = {
  200: OptionsListReturn
}

export type ConnectorsOptionsRetrieveResponse =
  ConnectorsOptionsRetrieveResponses[keyof ConnectorsOptionsRetrieveResponses]

export type ContactsListData = {
  body?: never
  path?: never
  query?: {
    created_by?: string
    custom_field_values?: string
    email_valid?: boolean
    job_position?: number
    lead_client?: Array<number>
    leads?: Array<number>
    leads__owner?: string
    opportunities?: Array<number>
    opportunities__owner?: string
    opportunity_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    phone_number_valid?: boolean
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    senior_position?: number
  }
  url: '/contacts'
}

export type ContactsListResponses = {
  200: PaginatedReturnContactListReadable
}

export type ContactsListResponse =
  ContactsListResponses[keyof ContactsListResponses]

export type ContactsCreateData = {
  body?: ExtendedContactWritable
  path?: never
  query?: never
  url: '/contacts'
}

export type ContactsCreateResponses = {
  201: ExtendedContactReadable
}

export type ContactsCreateResponse =
  ContactsCreateResponses[keyof ContactsCreateResponses]

export type ContactsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/contacts/{id}'
}

export type ContactsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ContactsDestroyResponse =
  ContactsDestroyResponses[keyof ContactsDestroyResponses]

export type ContactsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/contacts/{id}'
}

export type ContactsRetrieveResponses = {
  200: ReturnContactReadable
}

export type ContactsRetrieveResponse =
  ContactsRetrieveResponses[keyof ContactsRetrieveResponses]

export type ContactsPartialUpdateData = {
  body?: PatchedExtendedContactWritable
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/contacts/{id}'
}

export type ContactsPartialUpdateResponses = {
  200: ExtendedContactReadable
}

export type ContactsPartialUpdateResponse =
  ContactsPartialUpdateResponses[keyof ContactsPartialUpdateResponses]

export type ContactsUpdateData = {
  body?: ExtendedContactWritable
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/contacts/{id}'
}

export type ContactsUpdateResponses = {
  200: ExtendedContactReadable
}

export type ContactsUpdateResponse =
  ContactsUpdateResponses[keyof ContactsUpdateResponses]

export type ContactsConnectionsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/contacts/{id}/connections'
}

export type ContactsConnectionsRetrieveResponses = {
  /**
   * List of graph nodes
   */
  200: ContactConnectionNodes
}

export type ContactsConnectionsRetrieveResponse =
  ContactsConnectionsRetrieveResponses[keyof ContactsConnectionsRetrieveResponses]

export type ContactsInitCallCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/contacts/{id}/init-call'
}

export type ContactsInitCallCreateResponses = {
  200: ReturnSuccess
}

export type ContactsInitCallCreateResponse =
  ContactsInitCallCreateResponses[keyof ContactsInitCallCreateResponses]

export type ContactsPhoneNumbersListData = {
  body?: never
  path?: never
  query?: {
    contact?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * A search term.
     */
    search?: string
  }
  url: '/contacts/phone-numbers'
}

export type ContactsPhoneNumbersListResponses = {
  200: PaginatedContactPhoneListReadable
}

export type ContactsPhoneNumbersListResponse =
  ContactsPhoneNumbersListResponses[keyof ContactsPhoneNumbersListResponses]

export type ContactsPhoneNumbersCreateData = {
  body: ContactPhoneWritable
  path?: never
  query?: never
  url: '/contacts/phone-numbers'
}

export type ContactsPhoneNumbersCreateResponses = {
  201: ContactPhoneReadable
}

export type ContactsPhoneNumbersCreateResponse =
  ContactsPhoneNumbersCreateResponses[keyof ContactsPhoneNumbersCreateResponses]

export type ContactsPhoneNumbersDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/contacts/phone-numbers/{id}'
}

export type ContactsPhoneNumbersDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ContactsPhoneNumbersDestroyResponse =
  ContactsPhoneNumbersDestroyResponses[keyof ContactsPhoneNumbersDestroyResponses]

export type ContactsPhoneNumbersRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/contacts/phone-numbers/{id}'
}

export type ContactsPhoneNumbersRetrieveResponses = {
  200: ContactPhoneReadable
}

export type ContactsPhoneNumbersRetrieveResponse =
  ContactsPhoneNumbersRetrieveResponses[keyof ContactsPhoneNumbersRetrieveResponses]

export type ContactsPhoneNumbersPartialUpdateData = {
  body?: PatchedContactPhoneWritable
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/contacts/phone-numbers/{id}'
}

export type ContactsPhoneNumbersPartialUpdateResponses = {
  200: ContactPhoneReadable
}

export type ContactsPhoneNumbersPartialUpdateResponse =
  ContactsPhoneNumbersPartialUpdateResponses[keyof ContactsPhoneNumbersPartialUpdateResponses]

export type ContactsPhoneNumbersUpdateData = {
  body: ContactPhoneWritable
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/contacts/phone-numbers/{id}'
}

export type ContactsPhoneNumbersUpdateResponses = {
  200: ContactPhoneReadable
}

export type ContactsPhoneNumbersUpdateResponse =
  ContactsPhoneNumbersUpdateResponses[keyof ContactsPhoneNumbersUpdateResponses]

export type ContractsListData = {
  body?: never
  path?: never
  query?: {
    client?: Array<number>
    deadline_from?: string
    deadline_to?: string
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * Filter contracts by product
     */
    product?: string
    /**
     * A search term.
     */
    search?: string
    signed_from?: string
    signed_to?: string
    /**
     * Stare
     * * `signed` - Semnat
     * * `closed` - Închis
     */
    status?: 'closed' | 'signed'
  }
  url: '/contracts'
}

export type ContractsListResponses = {
  200: PaginatedReturnContractListReadable
}

export type ContractsListResponse =
  ContractsListResponses[keyof ContractsListResponses]

export type ContractsCreateData = {
  body: ReturnContractWritable
  path?: never
  query?: never
  url: '/contracts'
}

export type ContractsCreateResponses = {
  201: ReturnContractReadable
}

export type ContractsCreateResponse =
  ContractsCreateResponses[keyof ContractsCreateResponses]

export type ContractsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contract.
     */
    id: number
  }
  query?: never
  url: '/contracts/{id}'
}

export type ContractsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ContractsDestroyResponse =
  ContractsDestroyResponses[keyof ContractsDestroyResponses]

export type ContractsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contract.
     */
    id: number
  }
  query?: never
  url: '/contracts/{id}'
}

export type ContractsRetrieveResponses = {
  200: ReturnContractReadable
}

export type ContractsRetrieveResponse =
  ContractsRetrieveResponses[keyof ContractsRetrieveResponses]

export type ContractsPartialUpdateData = {
  body?: PatchedReturnContractWritable
  path: {
    /**
     * A unique integer value identifying this Contract.
     */
    id: number
  }
  query?: never
  url: '/contracts/{id}'
}

export type ContractsPartialUpdateResponses = {
  200: ReturnContractReadable
}

export type ContractsPartialUpdateResponse =
  ContractsPartialUpdateResponses[keyof ContractsPartialUpdateResponses]

export type ContractsUpdateData = {
  body: ReturnContractWritable
  path: {
    /**
     * A unique integer value identifying this Contract.
     */
    id: number
  }
  query?: never
  url: '/contracts/{id}'
}

export type ContractsUpdateResponses = {
  200: ReturnContractReadable
}

export type ContractsUpdateResponse =
  ContractsUpdateResponses[keyof ContractsUpdateResponses]

export type ContractsFetchSiAsigCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contract.
     */
    id: number
  }
  query?: never
  url: '/contracts/{id}/fetch-si-asig'
}

export type ContractsFetchSiAsigCreateResponses = {
  200: ReturnContractReadable
}

export type ContractsFetchSiAsigCreateResponse =
  ContractsFetchSiAsigCreateResponses[keyof ContractsFetchSiAsigCreateResponses]

export type CountriesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/countries'
}

export type CountriesListResponses = {
  200: PaginatedCountryListReadable
}

export type CountriesListResponse =
  CountriesListResponses[keyof CountriesListResponses]

export type CountriesCreateData = {
  body: CountryWritable
  path?: never
  query?: never
  url: '/countries'
}

export type CountriesCreateResponses = {
  201: CountryReadable
}

export type CountriesCreateResponse =
  CountriesCreateResponses[keyof CountriesCreateResponses]

export type CountriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/countries/{id}'
}

export type CountriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type CountriesDestroyResponse =
  CountriesDestroyResponses[keyof CountriesDestroyResponses]

export type CountriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/countries/{id}'
}

export type CountriesRetrieveResponses = {
  200: CountryReadable
}

export type CountriesRetrieveResponse =
  CountriesRetrieveResponses[keyof CountriesRetrieveResponses]

export type CountriesPartialUpdateData = {
  body?: PatchedCountryWritable
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/countries/{id}'
}

export type CountriesPartialUpdateResponses = {
  200: CountryReadable
}

export type CountriesPartialUpdateResponse =
  CountriesPartialUpdateResponses[keyof CountriesPartialUpdateResponses]

export type CountriesUpdateData = {
  body: CountryWritable
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/countries/{id}'
}

export type CountriesUpdateResponses = {
  200: CountryReadable
}

export type CountriesUpdateResponse =
  CountriesUpdateResponses[keyof CountriesUpdateResponses]

export type CountriesContinentsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/countries/continents'
}

export type CountriesContinentsListResponses = {
  200: PaginatedContinentListReadable
}

export type CountriesContinentsListResponse =
  CountriesContinentsListResponses[keyof CountriesContinentsListResponses]

export type CountriesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/countries/list'
}

export type CountriesListListResponses = {
  200: PaginatedDropdownList
}

export type CountriesListListResponse =
  CountriesListListResponses[keyof CountriesListListResponses]

export type CurrenciesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/currencies'
}

export type CurrenciesListResponses = {
  200: PaginatedCurrencyListReadable
}

export type CurrenciesListResponse =
  CurrenciesListResponses[keyof CurrenciesListResponses]

export type CurrenciesCreateData = {
  body: CurrencyWritable
  path?: never
  query?: never
  url: '/currencies'
}

export type CurrenciesCreateResponses = {
  201: CurrencyReadable
}

export type CurrenciesCreateResponse =
  CurrenciesCreateResponses[keyof CurrenciesCreateResponses]

export type CurrenciesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/currencies/{id}'
}

export type CurrenciesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type CurrenciesDestroyResponse =
  CurrenciesDestroyResponses[keyof CurrenciesDestroyResponses]

export type CurrenciesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/currencies/{id}'
}

export type CurrenciesRetrieveResponses = {
  200: CurrencyReadable
}

export type CurrenciesRetrieveResponse =
  CurrenciesRetrieveResponses[keyof CurrenciesRetrieveResponses]

export type CurrenciesPartialUpdateData = {
  body?: PatchedCurrencyWritable
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/currencies/{id}'
}

export type CurrenciesPartialUpdateResponses = {
  200: CurrencyReadable
}

export type CurrenciesPartialUpdateResponse =
  CurrenciesPartialUpdateResponses[keyof CurrenciesPartialUpdateResponses]

export type CurrenciesUpdateData = {
  body: CurrencyWritable
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/currencies/{id}'
}

export type CurrenciesUpdateResponses = {
  200: CurrencyReadable
}

export type CurrenciesUpdateResponse =
  CurrenciesUpdateResponses[keyof CurrenciesUpdateResponses]

export type CurrenciesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/currencies/list'
}

export type CurrenciesListListResponses = {
  200: PaginatedDropdownList
}

export type CurrenciesListListResponse =
  CurrenciesListListResponses[keyof CurrenciesListListResponses]

export type CustomFieldsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Entity this field applies to
     *
     * * `lead` - Lead
     * * `opportunity` - Oportunitate
     * * `contact` - Contact
     */
    entity_type?: Array<'contact' | 'lead' | 'opportunity'>
    is_deleted?: boolean
    is_required?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * A search term.
     */
    search?: string
  }
  url: '/custom-fields/'
}

export type CustomFieldsListResponses = {
  200: PaginatedCustomFieldRetrieveListReadable
}

export type CustomFieldsListResponse =
  CustomFieldsListResponses[keyof CustomFieldsListResponses]

export type CustomFieldsCreateData = {
  body?: CustomFieldCreateWritable
  path?: never
  query?: never
  url: '/custom-fields/'
}

export type CustomFieldsCreateResponses = {
  201: CustomFieldCreateReadable
}

export type CustomFieldsCreateResponse =
  CustomFieldsCreateResponses[keyof CustomFieldsCreateResponses]

export type CustomFieldsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this custom field.
     */
    id: number
  }
  query?: never
  url: '/custom-fields/{id}/'
}

export type CustomFieldsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type CustomFieldsDestroyResponse =
  CustomFieldsDestroyResponses[keyof CustomFieldsDestroyResponses]

export type CustomFieldsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this custom field.
     */
    id: number
  }
  query?: never
  url: '/custom-fields/{id}/'
}

export type CustomFieldsRetrieveResponses = {
  200: CustomFieldRetrieveReadable
}

export type CustomFieldsRetrieveResponse =
  CustomFieldsRetrieveResponses[keyof CustomFieldsRetrieveResponses]

export type CustomFieldsPartialUpdateData = {
  body?: PatchedCustomFieldUpdateWritable
  path: {
    /**
     * A unique integer value identifying this custom field.
     */
    id: number
  }
  query?: never
  url: '/custom-fields/{id}/'
}

export type CustomFieldsPartialUpdateResponses = {
  200: CustomFieldUpdateReadable
}

export type CustomFieldsPartialUpdateResponse =
  CustomFieldsPartialUpdateResponses[keyof CustomFieldsPartialUpdateResponses]

export type CustomFieldsUpdateData = {
  body?: CustomFieldUpdateWritable
  path: {
    /**
     * A unique integer value identifying this custom field.
     */
    id: number
  }
  query?: never
  url: '/custom-fields/{id}/'
}

export type CustomFieldsUpdateResponses = {
  200: CustomFieldUpdateReadable
}

export type CustomFieldsUpdateResponse =
  CustomFieldsUpdateResponses[keyof CustomFieldsUpdateResponses]

export type CustomFieldsUndeletePartialUpdateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this custom field.
     */
    id: number
  }
  query?: never
  url: '/custom-fields/{id}/undelete/'
}

export type CustomFieldsUndeletePartialUpdateResponses = {
  200: CustomFieldRetrieveReadable
}

export type CustomFieldsUndeletePartialUpdateResponse =
  CustomFieldsUndeletePartialUpdateResponses[keyof CustomFieldsUndeletePartialUpdateResponses]

export type DashboardLeadsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branch
     */
    branch?: number
    date_from?: string
    date_to?: string
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * User
     */
    user?: string
  }
  url: '/dashboard/leads'
}

export type DashboardLeadsListResponses = {
  200: Array<DashboardLeadReadable>
}

export type DashboardLeadsListResponse =
  DashboardLeadsListResponses[keyof DashboardLeadsListResponses]

export type DashboardReportsChartListData = {
  body?: never
  path?: never
  query: {
    branch?: number
    /**
     * * `sales` - sales
     * * `demo` - demo
     * * `completed` - completed
     * * `assigned` - assigned
     */
    chart_type: 'sales' | 'demo' | 'completed' | 'assigned'
    date_from?: string
    date_to?: string
    user?: string
  }
  url: '/dashboard/reports-chart'
}

export type DashboardReportsChartListResponses = {
  200: Array<DashboardReports>
}

export type DashboardReportsChartListResponse =
  DashboardReportsChartListResponses[keyof DashboardReportsChartListResponses]

export type DashboardSalesReportListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branch
     */
    branch?: number
    date_from?: string
    date_to?: string
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * User
     */
    user?: string
  }
  url: '/dashboard/sales-report'
}

export type DashboardSalesReportListResponses = {
  200: Array<ReturnSalesReport>
}

export type DashboardSalesReportListResponse =
  DashboardSalesReportListResponses[keyof DashboardSalesReportListResponses]

export type DashboardTasksRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/dashboard/tasks'
}

export type DashboardTasksRetrieveResponses = {
  200: DashboardTasksReturnReadable
}

export type DashboardTasksRetrieveResponse =
  DashboardTasksRetrieveResponses[keyof DashboardTasksRetrieveResponses]

export type DashboardTopExpertsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branches
     */
    branch?: string
    date_from?: string
    date_to?: string
    /**
     * * `sales` - Sales
     * * `demo` - Demo
     * * `completed` - Completed
     * * `assigned` - Assigned
     */
    expert_type?: 'assigned' | 'completed' | 'demo' | 'sales'
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
  }
  url: '/dashboard/top-experts'
}

export type DashboardTopExpertsListResponses = {
  200: Array<TopUserReadable>
}

export type DashboardTopExpertsListResponse =
  DashboardTopExpertsListResponses[keyof DashboardTopExpertsListResponses]

export type DocumentCategoriesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/document-categories'
}

export type DocumentCategoriesListResponses = {
  200: PaginatedDocumentCategoryListReadable
}

export type DocumentCategoriesListResponse =
  DocumentCategoriesListResponses[keyof DocumentCategoriesListResponses]

export type DocumentCategoriesCreateData = {
  body: DocumentCategoryWritable
  path?: never
  query?: never
  url: '/document-categories'
}

export type DocumentCategoriesCreateResponses = {
  201: DocumentCategoryReadable
}

export type DocumentCategoriesCreateResponse =
  DocumentCategoriesCreateResponses[keyof DocumentCategoriesCreateResponses]

export type DocumentCategoriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this document category.
     */
    id: number
  }
  query?: never
  url: '/document-categories/{id}'
}

export type DocumentCategoriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DocumentCategoriesDestroyResponse =
  DocumentCategoriesDestroyResponses[keyof DocumentCategoriesDestroyResponses]

export type DocumentCategoriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this document category.
     */
    id: number
  }
  query?: never
  url: '/document-categories/{id}'
}

export type DocumentCategoriesRetrieveResponses = {
  200: DocumentCategoryReadable
}

export type DocumentCategoriesRetrieveResponse =
  DocumentCategoriesRetrieveResponses[keyof DocumentCategoriesRetrieveResponses]

export type DocumentCategoriesPartialUpdateData = {
  body?: PatchedDocumentCategoryWritable
  path: {
    /**
     * A unique integer value identifying this document category.
     */
    id: number
  }
  query?: never
  url: '/document-categories/{id}'
}

export type DocumentCategoriesPartialUpdateResponses = {
  200: DocumentCategoryReadable
}

export type DocumentCategoriesPartialUpdateResponse =
  DocumentCategoriesPartialUpdateResponses[keyof DocumentCategoriesPartialUpdateResponses]

export type DocumentCategoriesUpdateData = {
  body: DocumentCategoryWritable
  path: {
    /**
     * A unique integer value identifying this document category.
     */
    id: number
  }
  query?: never
  url: '/document-categories/{id}'
}

export type DocumentCategoriesUpdateResponses = {
  200: DocumentCategoryReadable
}

export type DocumentCategoriesUpdateResponse =
  DocumentCategoriesUpdateResponses[keyof DocumentCategoriesUpdateResponses]

export type DocumentCategoriesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/document-categories/list'
}

export type DocumentCategoriesListListResponses = {
  200: PaginatedDropdownList
}

export type DocumentCategoriesListListResponse =
  DocumentCategoriesListListResponses[keyof DocumentCategoriesListListResponses]

export type DocumentsListData = {
  body?: never
  path?: never
  query?: {
    category?: number
    is_public?: boolean
    lead?: Array<number>
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/documents'
}

export type DocumentsListResponses = {
  200: PaginatedReturnDocumentListReadable
}

export type DocumentsListResponse =
  DocumentsListResponses[keyof DocumentsListResponses]

export type DocumentsCreateData = {
  body?: DocumentWritable
  path?: never
  query?: never
  url: '/documents'
}

export type DocumentsCreateResponses = {
  201: ReturnDocumentReadable
}

export type DocumentsCreateResponse =
  DocumentsCreateResponses[keyof DocumentsCreateResponses]

export type DocumentsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Document.
     */
    id: number
  }
  query?: never
  url: '/documents/{id}'
}

export type DocumentsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DocumentsDestroyResponse =
  DocumentsDestroyResponses[keyof DocumentsDestroyResponses]

export type DocumentsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Document.
     */
    id: number
  }
  query?: never
  url: '/documents/{id}'
}

export type DocumentsRetrieveResponses = {
  200: ReturnDocumentReadable
}

export type DocumentsRetrieveResponse =
  DocumentsRetrieveResponses[keyof DocumentsRetrieveResponses]

export type DocumentsPartialUpdateData = {
  body?: PatchedReturnDocumentWritable
  path: {
    /**
     * A unique integer value identifying this Document.
     */
    id: number
  }
  query?: never
  url: '/documents/{id}'
}

export type DocumentsPartialUpdateResponses = {
  200: ReturnDocumentReadable
}

export type DocumentsPartialUpdateResponse =
  DocumentsPartialUpdateResponses[keyof DocumentsPartialUpdateResponses]

export type DocumentsUpdateData = {
  body: ReturnDocumentWritable
  path: {
    /**
     * A unique integer value identifying this Document.
     */
    id: number
  }
  query?: never
  url: '/documents/{id}'
}

export type DocumentsUpdateResponses = {
  200: ReturnDocumentReadable
}

export type DocumentsUpdateResponse =
  DocumentsUpdateResponses[keyof DocumentsUpdateResponses]

export type DocumentsBulkCreateCreateData = {
  body?: ReturnSuccess
  path?: never
  query?: never
  url: '/documents/bulk-create'
}

export type DocumentsBulkCreateCreateResponses = {
  200: ReturnSuccess
}

export type DocumentsBulkCreateCreateResponse =
  DocumentsBulkCreateCreateResponses[keyof DocumentsBulkCreateCreateResponses]

export type DocumentsListListData = {
  body?: never
  path?: never
  query?: {
    category?: number
    is_public?: boolean
    lead?: Array<number>
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/documents/list'
}

export type DocumentsListListResponses = {
  200: PaginatedDropdownList
}

export type DocumentsListListResponse =
  DocumentsListListResponses[keyof DocumentsListListResponses]

export type ExpensesListData = {
  body?: never
  path?: never
  query?: never
  url: '/expenses'
}

export type ExpensesListResponses = {
  200: Array<ExpensesReturnReadable>
}

export type ExpensesListResponse =
  ExpensesListResponses[keyof ExpensesListResponses]

export type ExpensesCreateData = {
  body: MonthlyExpensesWritable
  path?: never
  query?: never
  url: '/expenses'
}

export type ExpensesCreateResponses = {
  201: MonthlyExpensesReadable
}

export type ExpensesCreateResponse =
  ExpensesCreateResponses[keyof ExpensesCreateResponses]

export type HealthRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/health/'
}

export type HealthRetrieveResponses = {
  200: HealthCheck
}

export type HealthRetrieveResponse =
  HealthRetrieveResponses[keyof HealthRetrieveResponses]

export type IndustriesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/industries'
}

export type IndustriesListResponses = {
  200: PaginatedIndustryListReadable
}

export type IndustriesListResponse =
  IndustriesListResponses[keyof IndustriesListResponses]

export type IndustriesCreateData = {
  body: IndustryWritable
  path?: never
  query?: never
  url: '/industries'
}

export type IndustriesCreateResponses = {
  201: IndustryReadable
}

export type IndustriesCreateResponse =
  IndustriesCreateResponses[keyof IndustriesCreateResponses]

export type IndustriesSubIndustriesListData = {
  body?: never
  path: {
    industry_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/industries/{industry_id}/sub-industries'
}

export type IndustriesSubIndustriesListResponses = {
  200: PaginatedReturnSubIndustryListReadable
}

export type IndustriesSubIndustriesListResponse =
  IndustriesSubIndustriesListResponses[keyof IndustriesSubIndustriesListResponses]

export type IndustriesSubIndustriesCreateData = {
  body: ReturnSubIndustryWritable
  path: {
    industry_id: string
  }
  query?: never
  url: '/industries/{industry_id}/sub-industries'
}

export type IndustriesSubIndustriesCreateResponses = {
  201: ReturnSubIndustryReadable
}

export type IndustriesSubIndustriesCreateResponse =
  IndustriesSubIndustriesCreateResponses[keyof IndustriesSubIndustriesCreateResponses]

export type IndustriesSubIndustriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/industries/{industry_id}/sub-industries/{id}'
}

export type IndustriesSubIndustriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type IndustriesSubIndustriesDestroyResponse =
  IndustriesSubIndustriesDestroyResponses[keyof IndustriesSubIndustriesDestroyResponses]

export type IndustriesSubIndustriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/industries/{industry_id}/sub-industries/{id}'
}

export type IndustriesSubIndustriesRetrieveResponses = {
  200: ReturnSubIndustryReadable
}

export type IndustriesSubIndustriesRetrieveResponse =
  IndustriesSubIndustriesRetrieveResponses[keyof IndustriesSubIndustriesRetrieveResponses]

export type IndustriesSubIndustriesPartialUpdateData = {
  body?: PatchedReturnSubIndustryWritable
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/industries/{industry_id}/sub-industries/{id}'
}

export type IndustriesSubIndustriesPartialUpdateResponses = {
  200: ReturnSubIndustryReadable
}

export type IndustriesSubIndustriesPartialUpdateResponse =
  IndustriesSubIndustriesPartialUpdateResponses[keyof IndustriesSubIndustriesPartialUpdateResponses]

export type IndustriesSubIndustriesUpdateData = {
  body: ReturnSubIndustryWritable
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/industries/{industry_id}/sub-industries/{id}'
}

export type IndustriesSubIndustriesUpdateResponses = {
  200: ReturnSubIndustryReadable
}

export type IndustriesSubIndustriesUpdateResponse =
  IndustriesSubIndustriesUpdateResponses[keyof IndustriesSubIndustriesUpdateResponses]

export type IndustriesSubIndustriesListListData = {
  body?: never
  path: {
    industry_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/industries/{industry_id}/sub-industries/list'
}

export type IndustriesSubIndustriesListListResponses = {
  200: PaginatedDropdownList
}

export type IndustriesSubIndustriesListListResponse =
  IndustriesSubIndustriesListListResponses[keyof IndustriesSubIndustriesListListResponses]

export type IndustriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/industries/{id}'
}

export type IndustriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type IndustriesDestroyResponse =
  IndustriesDestroyResponses[keyof IndustriesDestroyResponses]

export type IndustriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/industries/{id}'
}

export type IndustriesRetrieveResponses = {
  200: IndustryReadable
}

export type IndustriesRetrieveResponse =
  IndustriesRetrieveResponses[keyof IndustriesRetrieveResponses]

export type IndustriesPartialUpdateData = {
  body?: PatchedIndustryWritable
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/industries/{id}'
}

export type IndustriesPartialUpdateResponses = {
  200: IndustryReadable
}

export type IndustriesPartialUpdateResponse =
  IndustriesPartialUpdateResponses[keyof IndustriesPartialUpdateResponses]

export type IndustriesUpdateData = {
  body: IndustryWritable
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/industries/{id}'
}

export type IndustriesUpdateResponses = {
  200: IndustryReadable
}

export type IndustriesUpdateResponse =
  IndustriesUpdateResponses[keyof IndustriesUpdateResponses]

export type IndustriesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/industries/list'
}

export type IndustriesListListResponses = {
  200: PaginatedDropdownList
}

export type IndustriesListListResponse =
  IndustriesListListResponses[keyof IndustriesListListResponses]

export type InformationListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Multiple values may be separated by commas.
     */
    title?: Array<string>
  }
  url: '/information'
}

export type InformationListResponses = {
  200: PaginatedInformationListReadable
}

export type InformationListResponse =
  InformationListResponses[keyof InformationListResponses]

export type InformationCreateData = {
  body: InformationWritable
  path?: never
  query?: never
  url: '/information'
}

export type InformationCreateResponses = {
  201: InformationReadable
}

export type InformationCreateResponse =
  InformationCreateResponses[keyof InformationCreateResponses]

export type InformationDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this information.
     */
    id: number
  }
  query?: never
  url: '/information/{id}'
}

export type InformationDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InformationDestroyResponse =
  InformationDestroyResponses[keyof InformationDestroyResponses]

export type InformationRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this information.
     */
    id: number
  }
  query?: never
  url: '/information/{id}'
}

export type InformationRetrieveResponses = {
  200: InformationReadable
}

export type InformationRetrieveResponse =
  InformationRetrieveResponses[keyof InformationRetrieveResponses]

export type InformationPartialUpdateData = {
  body?: PatchedInformationWritable
  path: {
    /**
     * A unique integer value identifying this information.
     */
    id: number
  }
  query?: never
  url: '/information/{id}'
}

export type InformationPartialUpdateResponses = {
  200: InformationReadable
}

export type InformationPartialUpdateResponse =
  InformationPartialUpdateResponses[keyof InformationPartialUpdateResponses]

export type InformationUpdateData = {
  body: InformationWritable
  path: {
    /**
     * A unique integer value identifying this information.
     */
    id: number
  }
  query?: never
  url: '/information/{id}'
}

export type InformationUpdateResponses = {
  200: InformationReadable
}

export type InformationUpdateResponse =
  InformationUpdateResponses[keyof InformationUpdateResponses]

export type InformationListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Multiple values may be separated by commas.
     */
    title?: Array<string>
  }
  url: '/information/list'
}

export type InformationListListResponses = {
  200: PaginatedDropdownList
}

export type InformationListListResponse =
  InformationListListResponses[keyof InformationListListResponses]

export type IntegrationsGmailListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/integrations/gmail'
}

export type IntegrationsGmailListResponses = {
  200: PaginatedGmailMailboxListReadable
}

export type IntegrationsGmailListResponse =
  IntegrationsGmailListResponses[keyof IntegrationsGmailListResponses]

export type IntegrationsGmailCreateData = {
  body: GmailMailboxWritable
  path?: never
  query?: never
  url: '/integrations/gmail'
}

export type IntegrationsGmailCreateResponses = {
  201: GmailMailboxReadable
}

export type IntegrationsGmailCreateResponse =
  IntegrationsGmailCreateResponses[keyof IntegrationsGmailCreateResponses]

export type IntegrationsGmailDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/gmail/{id}'
}

export type IntegrationsGmailDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type IntegrationsGmailDestroyResponse =
  IntegrationsGmailDestroyResponses[keyof IntegrationsGmailDestroyResponses]

export type IntegrationsGmailRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/gmail/{id}'
}

export type IntegrationsGmailRetrieveResponses = {
  200: GmailMailboxReadable
}

export type IntegrationsGmailRetrieveResponse =
  IntegrationsGmailRetrieveResponses[keyof IntegrationsGmailRetrieveResponses]

export type IntegrationsGmailPartialUpdateData = {
  body?: PatchedGmailMailboxWritable
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/gmail/{id}'
}

export type IntegrationsGmailPartialUpdateResponses = {
  200: GmailMailboxReadable
}

export type IntegrationsGmailPartialUpdateResponse =
  IntegrationsGmailPartialUpdateResponses[keyof IntegrationsGmailPartialUpdateResponses]

export type IntegrationsGmailUpdateData = {
  body: GmailMailboxWritable
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/gmail/{id}'
}

export type IntegrationsGmailUpdateResponses = {
  200: GmailMailboxReadable
}

export type IntegrationsGmailUpdateResponse =
  IntegrationsGmailUpdateResponses[keyof IntegrationsGmailUpdateResponses]

export type IntegrationsGmailCheckMailboxRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/gmail/{id}/check-mailbox'
}

export type IntegrationsGmailCheckMailboxRetrieveResponses = {
  200: ReturnSuccess
}

export type IntegrationsGmailCheckMailboxRetrieveResponse =
  IntegrationsGmailCheckMailboxRetrieveResponses[keyof IntegrationsGmailCheckMailboxRetrieveResponses]

export type IntegrationsGmailAuthCallbackCreateData = {
  body: GmailMailboxWritable
  path?: never
  query?: never
  url: '/integrations/gmail/auth-callback'
}

export type IntegrationsGmailAuthCallbackCreateResponses = {
  200: GmailMailboxReadable
}

export type IntegrationsGmailAuthCallbackCreateResponse =
  IntegrationsGmailAuthCallbackCreateResponses[keyof IntegrationsGmailAuthCallbackCreateResponses]

export type IntegrationsGmailAuthUrlRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/integrations/gmail/auth-url'
}

export type IntegrationsGmailAuthUrlRetrieveResponses = {
  200: ReturnEmailAuthUrl
}

export type IntegrationsGmailAuthUrlRetrieveResponse =
  IntegrationsGmailAuthUrlRetrieveResponses[keyof IntegrationsGmailAuthUrlRetrieveResponses]

export type IntegrationsGmailListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/integrations/gmail/list'
}

export type IntegrationsGmailListListResponses = {
  200: PaginatedDropdownList
}

export type IntegrationsGmailListListResponse =
  IntegrationsGmailListListResponses[keyof IntegrationsGmailListListResponses]

export type IntegrationsGmailLogoutMailboxCreateData = {
  body: GmailMailboxWritable
  path?: never
  query?: never
  url: '/integrations/gmail/logout_mailbox'
}

export type IntegrationsGmailLogoutMailboxCreateResponses = {
  200: ReturnSuccess
}

export type IntegrationsGmailLogoutMailboxCreateResponse =
  IntegrationsGmailLogoutMailboxCreateResponses[keyof IntegrationsGmailLogoutMailboxCreateResponses]

export type IntegrationsMessengerListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/integrations/messenger'
}

export type IntegrationsMessengerListResponses = {
  200: PaginatedMessengerMailboxListReadable
}

export type IntegrationsMessengerListResponse =
  IntegrationsMessengerListResponses[keyof IntegrationsMessengerListResponses]

export type IntegrationsMessengerCreateData = {
  body: MessengerMailboxWritable
  path?: never
  query?: never
  url: '/integrations/messenger'
}

export type IntegrationsMessengerCreateResponses = {
  201: MessengerMailboxReadable
}

export type IntegrationsMessengerCreateResponse =
  IntegrationsMessengerCreateResponses[keyof IntegrationsMessengerCreateResponses]

export type IntegrationsMessengerDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/messenger/{id}'
}

export type IntegrationsMessengerDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type IntegrationsMessengerDestroyResponse =
  IntegrationsMessengerDestroyResponses[keyof IntegrationsMessengerDestroyResponses]

export type IntegrationsMessengerRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/messenger/{id}'
}

export type IntegrationsMessengerRetrieveResponses = {
  200: MessengerMailboxReadable
}

export type IntegrationsMessengerRetrieveResponse =
  IntegrationsMessengerRetrieveResponses[keyof IntegrationsMessengerRetrieveResponses]

export type IntegrationsMessengerPartialUpdateData = {
  body?: PatchedMessengerMailboxWritable
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/messenger/{id}'
}

export type IntegrationsMessengerPartialUpdateResponses = {
  200: MessengerMailboxReadable
}

export type IntegrationsMessengerPartialUpdateResponse =
  IntegrationsMessengerPartialUpdateResponses[keyof IntegrationsMessengerPartialUpdateResponses]

export type IntegrationsMessengerUpdateData = {
  body: MessengerMailboxWritable
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/messenger/{id}'
}

export type IntegrationsMessengerUpdateResponses = {
  200: MessengerMailboxReadable
}

export type IntegrationsMessengerUpdateResponse =
  IntegrationsMessengerUpdateResponses[keyof IntegrationsMessengerUpdateResponses]

export type IntegrationsMessengerCheckMailboxRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/integrations/messenger/{id}/check-mailbox'
}

export type IntegrationsMessengerCheckMailboxRetrieveResponses = {
  200: ReturnSuccess
}

export type IntegrationsMessengerCheckMailboxRetrieveResponse =
  IntegrationsMessengerCheckMailboxRetrieveResponses[keyof IntegrationsMessengerCheckMailboxRetrieveResponses]

export type IntegrationsMessengerAuthCallbackCreateData = {
  body: MessengerMailboxWritable
  path?: never
  query?: never
  url: '/integrations/messenger/auth-callback'
}

export type IntegrationsMessengerAuthCallbackCreateResponses = {
  200: MessengerMailboxReadable
}

export type IntegrationsMessengerAuthCallbackCreateResponse =
  IntegrationsMessengerAuthCallbackCreateResponses[keyof IntegrationsMessengerAuthCallbackCreateResponses]

export type IntegrationsMessengerAuthUrlRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/integrations/messenger/auth-url'
}

export type IntegrationsMessengerAuthUrlRetrieveResponses = {
  200: ReturnEmailAuthUrl
}

export type IntegrationsMessengerAuthUrlRetrieveResponse =
  IntegrationsMessengerAuthUrlRetrieveResponses[keyof IntegrationsMessengerAuthUrlRetrieveResponses]

export type IntegrationsMessengerListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/integrations/messenger/list'
}

export type IntegrationsMessengerListListResponses = {
  200: PaginatedDropdownList
}

export type IntegrationsMessengerListListResponse =
  IntegrationsMessengerListListResponses[keyof IntegrationsMessengerListListResponses]

export type IntegrationsMessengerLogoutMailboxCreateData = {
  body: MessengerMailboxWritable
  path?: never
  query?: never
  url: '/integrations/messenger/logout-mailbox'
}

export type IntegrationsMessengerLogoutMailboxCreateResponses = {
  200: ReturnSuccess
}

export type IntegrationsMessengerLogoutMailboxCreateResponse =
  IntegrationsMessengerLogoutMailboxCreateResponses[keyof IntegrationsMessengerLogoutMailboxCreateResponses]

export type IntegrationsWhatsappConfigListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/integrations/whatsapp/config'
}

export type IntegrationsWhatsappConfigListResponses = {
  200: PaginatedReturnWhatsAppConfigListReadable
}

export type IntegrationsWhatsappConfigListResponse =
  IntegrationsWhatsappConfigListResponses[keyof IntegrationsWhatsappConfigListResponses]

export type IntegrationsWhatsappConfigCreateData = {
  body: WhatsAppConfigCreateWritable
  path?: never
  query?: never
  url: '/integrations/whatsapp/config'
}

export type IntegrationsWhatsappConfigCreateResponses = {
  201: ReturnWhatsAppConfig
}

export type IntegrationsWhatsappConfigCreateResponse =
  IntegrationsWhatsappConfigCreateResponses[keyof IntegrationsWhatsappConfigCreateResponses]

export type IntegrationsWhatsappConfigDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Configurare Integrare WhatsApp.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/config/{id}'
}

export type IntegrationsWhatsappConfigDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type IntegrationsWhatsappConfigDestroyResponse =
  IntegrationsWhatsappConfigDestroyResponses[keyof IntegrationsWhatsappConfigDestroyResponses]

export type IntegrationsWhatsappConfigRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Configurare Integrare WhatsApp.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/config/{id}'
}

export type IntegrationsWhatsappConfigRetrieveResponses = {
  200: ReturnWhatsAppConfig
}

export type IntegrationsWhatsappConfigRetrieveResponse =
  IntegrationsWhatsappConfigRetrieveResponses[keyof IntegrationsWhatsappConfigRetrieveResponses]

export type IntegrationsWhatsappConfigPartialUpdateData = {
  body?: PatchedWhatsAppConfigUpdateWritable
  path: {
    /**
     * A unique integer value identifying this Configurare Integrare WhatsApp.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/config/{id}'
}

export type IntegrationsWhatsappConfigPartialUpdateResponses = {
  200: ReturnWhatsAppConfig
}

export type IntegrationsWhatsappConfigPartialUpdateResponse =
  IntegrationsWhatsappConfigPartialUpdateResponses[keyof IntegrationsWhatsappConfigPartialUpdateResponses]

export type IntegrationsWhatsappConfigUpdateData = {
  body: WhatsAppConfigUpdateWritable
  path: {
    /**
     * A unique integer value identifying this Configurare Integrare WhatsApp.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/config/{id}'
}

export type IntegrationsWhatsappConfigUpdateResponses = {
  200: ReturnWhatsAppConfig
}

export type IntegrationsWhatsappConfigUpdateResponse =
  IntegrationsWhatsappConfigUpdateResponses[keyof IntegrationsWhatsappConfigUpdateResponses]

export type IntegrationsWhatsappConfigTestCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Configurare Integrare WhatsApp.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/config/{id}/test'
}

export type IntegrationsWhatsappConfigTestCreateResponses = {
  200: ReturnWhatsAppConfig
}

export type IntegrationsWhatsappConfigTestCreateResponse =
  IntegrationsWhatsappConfigTestCreateResponses[keyof IntegrationsWhatsappConfigTestCreateResponses]

export type IntegrationsWhatsappMessageTemplatesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * * `MARKETING` - MARKETING
     * * `UTILITY` - UTILITY
     * * `AUTHENTICATION` - AUTHENTICATION
     */
    category?: Array<'AUTHENTICATION' | 'MARKETING' | 'UTILITY'>
    created_at_from?: string
    created_at_to?: string
    integration?: Array<number>
    language?: string
    meta_template_id?: string
    name?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * * `POSITIONAL` - POSITIONAL
     * * `NAMED` - NAMED
     */
    parameter_format?: Array<'NAMED' | 'POSITIONAL'>
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * * `APPROVED` - APPROVED
     * * `PENDING` - PENDING
     * * `REJECTED` - REJECTED
     * * `PAUSED` - PAUSED
     * * `DISABLED` - DISABLED
     */
    status?: Array<'APPROVED' | 'DISABLED' | 'PAUSED' | 'PENDING' | 'REJECTED'>
  }
  url: '/integrations/whatsapp/message-templates'
}

export type IntegrationsWhatsappMessageTemplatesListResponses = {
  200: PaginatedReturnWhatsAppMessageTemplateListReadable
}

export type IntegrationsWhatsappMessageTemplatesListResponse =
  IntegrationsWhatsappMessageTemplatesListResponses[keyof IntegrationsWhatsappMessageTemplatesListResponses]

export type IntegrationsWhatsappMessageTemplatesSyncCreateData = {
  body?: never
  path?: never
  query?: never
  url: '/integrations/whatsapp/message-templates/sync'
}

export type IntegrationsWhatsappMessageTemplatesSyncCreateResponses = {
  200: ReturnWhatsAppMessageTemplateReadable
}

export type IntegrationsWhatsappMessageTemplatesSyncCreateResponse =
  IntegrationsWhatsappMessageTemplatesSyncCreateResponses[keyof IntegrationsWhatsappMessageTemplatesSyncCreateResponses]

export type IntegrationsWhatsappMessagesListData = {
  body?: never
  path?: never
  query?: {
    created_at_from?: string
    created_at_to?: string
    /**
     * * `OUTBOUND` - Ieșire
     * * `INBOUND` - Intrare
     */
    direction?: Array<'INBOUND' | 'OUTBOUND'>
    integration?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    recipient?: Array<number>
    recipient_number?: number
    /**
     * * `individual` - individual
     * * `group` - Grup
     */
    recipient_type?: Array<'group' | 'individual'>
    /**
     * A search term.
     */
    search?: string
    sent_at_from?: string
    sent_at_to?: string
    /**
     * * `sent` - Trimis
     * * `delivered` - Livrat
     * * `read` - Citit
     * * `failed` - Eșuat
     * * `queued` - În așteptare
     */
    status?: Array<'delivered' | 'failed' | 'queued' | 'read' | 'sent'>
    /**
     * * `text` - Text
     * * `image` - Imagine
     * * `video` - Video
     * * `audio` - Audio
     * * `document` - Document
     * * `template` - Șablon
     */
    type?: Array<'audio' | 'document' | 'image' | 'template' | 'text' | 'video'>
    wa_message_id?: string
  }
  url: '/integrations/whatsapp/messages'
}

export type IntegrationsWhatsappMessagesListResponses = {
  200: PaginatedReturnWhatsAppMessageListReadable
}

export type IntegrationsWhatsappMessagesListResponse =
  IntegrationsWhatsappMessagesListResponses[keyof IntegrationsWhatsappMessagesListResponses]

export type IntegrationsWhatsappMessagesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this whats app message.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/messages/{id}'
}

export type IntegrationsWhatsappMessagesRetrieveResponses = {
  200: ReturnWhatsAppMessageReadable
}

export type IntegrationsWhatsappMessagesRetrieveResponse =
  IntegrationsWhatsappMessagesRetrieveResponses[keyof IntegrationsWhatsappMessagesRetrieveResponses]

export type IntegrationsWhatsappMessagesRetryCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this whats app message.
     */
    id: number
  }
  query?: never
  url: '/integrations/whatsapp/messages/{id}/retry'
}

export type IntegrationsWhatsappMessagesRetryCreateResponses = {
  200: ReturnWhatsAppMessageReadable
}

export type IntegrationsWhatsappMessagesRetryCreateResponse =
  IntegrationsWhatsappMessagesRetryCreateResponses[keyof IntegrationsWhatsappMessagesRetryCreateResponses]

export type IntegrationsWhatsappMessagesSendCreateData = {
  body: WhatsAppMessageSend
  path?: never
  query?: never
  url: '/integrations/whatsapp/messages/send'
}

export type IntegrationsWhatsappMessagesSendCreateResponses = {
  200: ReturnWhatsAppMessageReadable
}

export type IntegrationsWhatsappMessagesSendCreateResponse =
  IntegrationsWhatsappMessagesSendCreateResponses[keyof IntegrationsWhatsappMessagesSendCreateResponses]

export type InternalCitiesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/cities'
}

export type InternalCitiesListResponses = {
  200: PaginatedCityListReadable
}

export type InternalCitiesListResponse =
  InternalCitiesListResponses[keyof InternalCitiesListResponses]

export type InternalCitiesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this city.
     */
    id: number
  }
  query?: never
  url: '/internal/cities/{id}'
}

export type InternalCitiesRetrieveResponses = {
  200: CityReadable
}

export type InternalCitiesRetrieveResponse =
  InternalCitiesRetrieveResponses[keyof InternalCitiesRetrieveResponses]

export type InternalCitiesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/cities/list'
}

export type InternalCitiesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalCitiesListListResponse =
  InternalCitiesListListResponses[keyof InternalCitiesListListResponses]

export type InternalCompanySizesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/company-sizes'
}

export type InternalCompanySizesListResponses = {
  200: PaginatedCompanySizeListReadable
}

export type InternalCompanySizesListResponse =
  InternalCompanySizesListResponses[keyof InternalCompanySizesListResponses]

export type InternalCompanySizesCreateData = {
  body: CompanySizeWritable
  path?: never
  query?: never
  url: '/internal/company-sizes'
}

export type InternalCompanySizesCreateResponses = {
  201: CompanySizeReadable
}

export type InternalCompanySizesCreateResponse =
  InternalCompanySizesCreateResponses[keyof InternalCompanySizesCreateResponses]

export type InternalCompanySizesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/internal/company-sizes/{id}'
}

export type InternalCompanySizesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalCompanySizesDestroyResponse =
  InternalCompanySizesDestroyResponses[keyof InternalCompanySizesDestroyResponses]

export type InternalCompanySizesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/internal/company-sizes/{id}'
}

export type InternalCompanySizesRetrieveResponses = {
  200: CompanySizeReadable
}

export type InternalCompanySizesRetrieveResponse =
  InternalCompanySizesRetrieveResponses[keyof InternalCompanySizesRetrieveResponses]

export type InternalCompanySizesPartialUpdateData = {
  body?: PatchedCompanySizeWritable
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/internal/company-sizes/{id}'
}

export type InternalCompanySizesPartialUpdateResponses = {
  200: CompanySizeReadable
}

export type InternalCompanySizesPartialUpdateResponse =
  InternalCompanySizesPartialUpdateResponses[keyof InternalCompanySizesPartialUpdateResponses]

export type InternalCompanySizesUpdateData = {
  body: CompanySizeWritable
  path: {
    /**
     * A unique integer value identifying this company size.
     */
    id: number
  }
  query?: never
  url: '/internal/company-sizes/{id}'
}

export type InternalCompanySizesUpdateResponses = {
  200: CompanySizeReadable
}

export type InternalCompanySizesUpdateResponse =
  InternalCompanySizesUpdateResponses[keyof InternalCompanySizesUpdateResponses]

export type InternalCompanySizesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/company-sizes/list'
}

export type InternalCompanySizesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalCompanySizesListListResponse =
  InternalCompanySizesListListResponses[keyof InternalCompanySizesListListResponses]

export type InternalContactsListData = {
  body?: never
  path?: never
  query?: {
    email?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/contacts'
}

export type InternalContactsListResponses = {
  200: PaginatedReturnContactListReadable
}

export type InternalContactsListResponse =
  InternalContactsListResponses[keyof InternalContactsListResponses]

export type InternalContactsCreateData = {
  body?: ExtendedContactWritable
  path?: never
  query?: never
  url: '/internal/contacts'
}

export type InternalContactsCreateResponses = {
  201: ExtendedContactReadable
}

export type InternalContactsCreateResponse =
  InternalContactsCreateResponses[keyof InternalContactsCreateResponses]

export type InternalContactsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/{id}'
}

export type InternalContactsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalContactsDestroyResponse =
  InternalContactsDestroyResponses[keyof InternalContactsDestroyResponses]

export type InternalContactsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/{id}'
}

export type InternalContactsRetrieveResponses = {
  200: ReturnContactReadable
}

export type InternalContactsRetrieveResponse =
  InternalContactsRetrieveResponses[keyof InternalContactsRetrieveResponses]

export type InternalContactsPartialUpdateData = {
  body?: PatchedExtendedContactWritable
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/{id}'
}

export type InternalContactsPartialUpdateResponses = {
  200: ExtendedContactReadable
}

export type InternalContactsPartialUpdateResponse =
  InternalContactsPartialUpdateResponses[keyof InternalContactsPartialUpdateResponses]

export type InternalContactsUpdateData = {
  body?: ExtendedContactWritable
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/{id}'
}

export type InternalContactsUpdateResponses = {
  200: ExtendedContactReadable
}

export type InternalContactsUpdateResponse =
  InternalContactsUpdateResponses[keyof InternalContactsUpdateResponses]

export type InternalContactsConnectionsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/{id}/connections'
}

export type InternalContactsConnectionsRetrieveResponses = {
  /**
   * List of graph nodes
   */
  200: ContactConnectionNodes
}

export type InternalContactsConnectionsRetrieveResponse =
  InternalContactsConnectionsRetrieveResponses[keyof InternalContactsConnectionsRetrieveResponses]

export type InternalContactsInitCallCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Contact.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/{id}/init-call'
}

export type InternalContactsInitCallCreateResponses = {
  200: ReturnSuccess
}

export type InternalContactsInitCallCreateResponse =
  InternalContactsInitCallCreateResponses[keyof InternalContactsInitCallCreateResponses]

export type InternalContactsPhoneNumbersListData = {
  body?: never
  path?: never
  query?: {
    contact?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/contacts/phone-numbers'
}

export type InternalContactsPhoneNumbersListResponses = {
  200: PaginatedContactPhoneListReadable
}

export type InternalContactsPhoneNumbersListResponse =
  InternalContactsPhoneNumbersListResponses[keyof InternalContactsPhoneNumbersListResponses]

export type InternalContactsPhoneNumbersCreateData = {
  body: ContactPhoneWritable
  path?: never
  query?: never
  url: '/internal/contacts/phone-numbers'
}

export type InternalContactsPhoneNumbersCreateResponses = {
  201: ContactPhoneReadable
}

export type InternalContactsPhoneNumbersCreateResponse =
  InternalContactsPhoneNumbersCreateResponses[keyof InternalContactsPhoneNumbersCreateResponses]

export type InternalContactsPhoneNumbersDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/phone-numbers/{id}'
}

export type InternalContactsPhoneNumbersDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalContactsPhoneNumbersDestroyResponse =
  InternalContactsPhoneNumbersDestroyResponses[keyof InternalContactsPhoneNumbersDestroyResponses]

export type InternalContactsPhoneNumbersRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/phone-numbers/{id}'
}

export type InternalContactsPhoneNumbersRetrieveResponses = {
  200: ContactPhoneReadable
}

export type InternalContactsPhoneNumbersRetrieveResponse =
  InternalContactsPhoneNumbersRetrieveResponses[keyof InternalContactsPhoneNumbersRetrieveResponses]

export type InternalContactsPhoneNumbersPartialUpdateData = {
  body?: PatchedContactPhoneWritable
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/phone-numbers/{id}'
}

export type InternalContactsPhoneNumbersPartialUpdateResponses = {
  200: ContactPhoneReadable
}

export type InternalContactsPhoneNumbersPartialUpdateResponse =
  InternalContactsPhoneNumbersPartialUpdateResponses[keyof InternalContactsPhoneNumbersPartialUpdateResponses]

export type InternalContactsPhoneNumbersUpdateData = {
  body: ContactPhoneWritable
  path: {
    /**
     * A unique integer value identifying this contact phone number.
     */
    id: number
  }
  query?: never
  url: '/internal/contacts/phone-numbers/{id}'
}

export type InternalContactsPhoneNumbersUpdateResponses = {
  200: ContactPhoneReadable
}

export type InternalContactsPhoneNumbersUpdateResponse =
  InternalContactsPhoneNumbersUpdateResponses[keyof InternalContactsPhoneNumbersUpdateResponses]

export type InternalCountriesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/countries'
}

export type InternalCountriesListResponses = {
  200: PaginatedCountryListReadable
}

export type InternalCountriesListResponse =
  InternalCountriesListResponses[keyof InternalCountriesListResponses]

export type InternalCountriesCreateData = {
  body: CountryWritable
  path?: never
  query?: never
  url: '/internal/countries'
}

export type InternalCountriesCreateResponses = {
  201: CountryReadable
}

export type InternalCountriesCreateResponse =
  InternalCountriesCreateResponses[keyof InternalCountriesCreateResponses]

export type InternalCountriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/internal/countries/{id}'
}

export type InternalCountriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalCountriesDestroyResponse =
  InternalCountriesDestroyResponses[keyof InternalCountriesDestroyResponses]

export type InternalCountriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/internal/countries/{id}'
}

export type InternalCountriesRetrieveResponses = {
  200: CountryReadable
}

export type InternalCountriesRetrieveResponse =
  InternalCountriesRetrieveResponses[keyof InternalCountriesRetrieveResponses]

export type InternalCountriesPartialUpdateData = {
  body?: PatchedCountryWritable
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/internal/countries/{id}'
}

export type InternalCountriesPartialUpdateResponses = {
  200: CountryReadable
}

export type InternalCountriesPartialUpdateResponse =
  InternalCountriesPartialUpdateResponses[keyof InternalCountriesPartialUpdateResponses]

export type InternalCountriesUpdateData = {
  body: CountryWritable
  path: {
    /**
     * A unique integer value identifying this country.
     */
    id: number
  }
  query?: never
  url: '/internal/countries/{id}'
}

export type InternalCountriesUpdateResponses = {
  200: CountryReadable
}

export type InternalCountriesUpdateResponse =
  InternalCountriesUpdateResponses[keyof InternalCountriesUpdateResponses]

export type InternalCountriesContinentsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/countries/continents'
}

export type InternalCountriesContinentsListResponses = {
  200: PaginatedContinentListReadable
}

export type InternalCountriesContinentsListResponse =
  InternalCountriesContinentsListResponses[keyof InternalCountriesContinentsListResponses]

export type InternalCountriesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/countries/list'
}

export type InternalCountriesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalCountriesListListResponse =
  InternalCountriesListListResponses[keyof InternalCountriesListListResponses]

export type InternalCurrenciesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    symbol?: string
  }
  url: '/internal/currencies'
}

export type InternalCurrenciesListResponses = {
  200: PaginatedInternalCurrencyListReadable
}

export type InternalCurrenciesListResponse =
  InternalCurrenciesListResponses[keyof InternalCurrenciesListResponses]

export type InternalCurrenciesCreateData = {
  body: InternalCurrencyWritable
  path?: never
  query?: never
  url: '/internal/currencies'
}

export type InternalCurrenciesCreateResponses = {
  201: InternalCurrencyReadable
}

export type InternalCurrenciesCreateResponse =
  InternalCurrenciesCreateResponses[keyof InternalCurrenciesCreateResponses]

export type InternalCurrenciesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/internal/currencies/{id}'
}

export type InternalCurrenciesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalCurrenciesDestroyResponse =
  InternalCurrenciesDestroyResponses[keyof InternalCurrenciesDestroyResponses]

export type InternalCurrenciesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/internal/currencies/{id}'
}

export type InternalCurrenciesRetrieveResponses = {
  200: InternalCurrencyReadable
}

export type InternalCurrenciesRetrieveResponse =
  InternalCurrenciesRetrieveResponses[keyof InternalCurrenciesRetrieveResponses]

export type InternalCurrenciesPartialUpdateData = {
  body?: PatchedInternalCurrencyWritable
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/internal/currencies/{id}'
}

export type InternalCurrenciesPartialUpdateResponses = {
  200: InternalCurrencyReadable
}

export type InternalCurrenciesPartialUpdateResponse =
  InternalCurrenciesPartialUpdateResponses[keyof InternalCurrenciesPartialUpdateResponses]

export type InternalCurrenciesUpdateData = {
  body: InternalCurrencyWritable
  path: {
    /**
     * A unique integer value identifying this currency.
     */
    id: number
  }
  query?: never
  url: '/internal/currencies/{id}'
}

export type InternalCurrenciesUpdateResponses = {
  200: InternalCurrencyReadable
}

export type InternalCurrenciesUpdateResponse =
  InternalCurrenciesUpdateResponses[keyof InternalCurrenciesUpdateResponses]

export type InternalCurrenciesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    symbol?: string
  }
  url: '/internal/currencies/list'
}

export type InternalCurrenciesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalCurrenciesListListResponse =
  InternalCurrenciesListListResponses[keyof InternalCurrenciesListListResponses]

export type InternalIndustriesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/industries'
}

export type InternalIndustriesListResponses = {
  200: PaginatedIndustryListReadable
}

export type InternalIndustriesListResponse =
  InternalIndustriesListResponses[keyof InternalIndustriesListResponses]

export type InternalIndustriesCreateData = {
  body: IndustryWritable
  path?: never
  query?: never
  url: '/internal/industries'
}

export type InternalIndustriesCreateResponses = {
  201: IndustryReadable
}

export type InternalIndustriesCreateResponse =
  InternalIndustriesCreateResponses[keyof InternalIndustriesCreateResponses]

export type InternalIndustriesSubIndustriesListData = {
  body?: never
  path: {
    industry_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/industries/{industry_id}/sub-industries'
}

export type InternalIndustriesSubIndustriesListResponses = {
  200: PaginatedReturnSubIndustryListReadable
}

export type InternalIndustriesSubIndustriesListResponse =
  InternalIndustriesSubIndustriesListResponses[keyof InternalIndustriesSubIndustriesListResponses]

export type InternalIndustriesSubIndustriesCreateData = {
  body: ReturnSubIndustryWritable
  path: {
    industry_id: string
  }
  query?: never
  url: '/internal/industries/{industry_id}/sub-industries'
}

export type InternalIndustriesSubIndustriesCreateResponses = {
  201: ReturnSubIndustryReadable
}

export type InternalIndustriesSubIndustriesCreateResponse =
  InternalIndustriesSubIndustriesCreateResponses[keyof InternalIndustriesSubIndustriesCreateResponses]

export type InternalIndustriesSubIndustriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/internal/industries/{industry_id}/sub-industries/{id}'
}

export type InternalIndustriesSubIndustriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalIndustriesSubIndustriesDestroyResponse =
  InternalIndustriesSubIndustriesDestroyResponses[keyof InternalIndustriesSubIndustriesDestroyResponses]

export type InternalIndustriesSubIndustriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/internal/industries/{industry_id}/sub-industries/{id}'
}

export type InternalIndustriesSubIndustriesRetrieveResponses = {
  200: ReturnSubIndustryReadable
}

export type InternalIndustriesSubIndustriesRetrieveResponse =
  InternalIndustriesSubIndustriesRetrieveResponses[keyof InternalIndustriesSubIndustriesRetrieveResponses]

export type InternalIndustriesSubIndustriesPartialUpdateData = {
  body?: PatchedReturnSubIndustryWritable
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/internal/industries/{industry_id}/sub-industries/{id}'
}

export type InternalIndustriesSubIndustriesPartialUpdateResponses = {
  200: ReturnSubIndustryReadable
}

export type InternalIndustriesSubIndustriesPartialUpdateResponse =
  InternalIndustriesSubIndustriesPartialUpdateResponses[keyof InternalIndustriesSubIndustriesPartialUpdateResponses]

export type InternalIndustriesSubIndustriesUpdateData = {
  body: ReturnSubIndustryWritable
  path: {
    /**
     * A unique integer value identifying this sub industry.
     */
    id: number
    industry_id: string
  }
  query?: never
  url: '/internal/industries/{industry_id}/sub-industries/{id}'
}

export type InternalIndustriesSubIndustriesUpdateResponses = {
  200: ReturnSubIndustryReadable
}

export type InternalIndustriesSubIndustriesUpdateResponse =
  InternalIndustriesSubIndustriesUpdateResponses[keyof InternalIndustriesSubIndustriesUpdateResponses]

export type InternalIndustriesSubIndustriesListListData = {
  body?: never
  path: {
    industry_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/industries/{industry_id}/sub-industries/list'
}

export type InternalIndustriesSubIndustriesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalIndustriesSubIndustriesListListResponse =
  InternalIndustriesSubIndustriesListListResponses[keyof InternalIndustriesSubIndustriesListListResponses]

export type InternalIndustriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/internal/industries/{id}'
}

export type InternalIndustriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalIndustriesDestroyResponse =
  InternalIndustriesDestroyResponses[keyof InternalIndustriesDestroyResponses]

export type InternalIndustriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/internal/industries/{id}'
}

export type InternalIndustriesRetrieveResponses = {
  200: IndustryReadable
}

export type InternalIndustriesRetrieveResponse =
  InternalIndustriesRetrieveResponses[keyof InternalIndustriesRetrieveResponses]

export type InternalIndustriesPartialUpdateData = {
  body?: PatchedIndustryWritable
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/internal/industries/{id}'
}

export type InternalIndustriesPartialUpdateResponses = {
  200: IndustryReadable
}

export type InternalIndustriesPartialUpdateResponse =
  InternalIndustriesPartialUpdateResponses[keyof InternalIndustriesPartialUpdateResponses]

export type InternalIndustriesUpdateData = {
  body: IndustryWritable
  path: {
    /**
     * A unique integer value identifying this industry.
     */
    id: number
  }
  query?: never
  url: '/internal/industries/{id}'
}

export type InternalIndustriesUpdateResponses = {
  200: IndustryReadable
}

export type InternalIndustriesUpdateResponse =
  InternalIndustriesUpdateResponses[keyof InternalIndustriesUpdateResponses]

export type InternalIndustriesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/industries/list'
}

export type InternalIndustriesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalIndustriesListListResponse =
  InternalIndustriesListListResponses[keyof InternalIndustriesListListResponses]

export type InternalLeadsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/internal/leads'
}

export type InternalLeadsListResponses = {
  200: PaginatedReturnLeadListReadable
}

export type InternalLeadsListResponse =
  InternalLeadsListResponses[keyof InternalLeadsListResponses]

export type InternalLeadsCreateData = {
  body: ReturnLeadWritable
  path?: never
  query?: never
  url: '/internal/leads'
}

export type InternalLeadsCreateResponses = {
  201: ReturnLeadReadable
}

export type InternalLeadsCreateResponse =
  InternalLeadsCreateResponses[keyof InternalLeadsCreateResponses]

export type InternalLeadsStatusesListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    lead_type?: Array<number>
    lead_type_isnull?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/leads-statuses'
}

export type InternalLeadsStatusesListResponses = {
  200: PaginatedReturnLeadStatusListReadable
}

export type InternalLeadsStatusesListResponse =
  InternalLeadsStatusesListResponses[keyof InternalLeadsStatusesListResponses]

export type InternalLeadsStatusesCreateData = {
  body: ReturnLeadStatusWritable
  path?: never
  query?: never
  url: '/internal/leads-statuses'
}

export type InternalLeadsStatusesCreateResponses = {
  201: ReturnLeadStatusReadable
}

export type InternalLeadsStatusesCreateResponse =
  InternalLeadsStatusesCreateResponses[keyof InternalLeadsStatusesCreateResponses]

export type InternalLeadsStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-statuses/{id}'
}

export type InternalLeadsStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalLeadsStatusesDestroyResponse =
  InternalLeadsStatusesDestroyResponses[keyof InternalLeadsStatusesDestroyResponses]

export type InternalLeadsStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-statuses/{id}'
}

export type InternalLeadsStatusesRetrieveResponses = {
  200: ReturnLeadStatusReadable
}

export type InternalLeadsStatusesRetrieveResponse =
  InternalLeadsStatusesRetrieveResponses[keyof InternalLeadsStatusesRetrieveResponses]

export type InternalLeadsStatusesPartialUpdateData = {
  body?: PatchedReturnLeadStatusWritable
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-statuses/{id}'
}

export type InternalLeadsStatusesPartialUpdateResponses = {
  200: ReturnLeadStatusReadable
}

export type InternalLeadsStatusesPartialUpdateResponse =
  InternalLeadsStatusesPartialUpdateResponses[keyof InternalLeadsStatusesPartialUpdateResponses]

export type InternalLeadsStatusesUpdateData = {
  body: ReturnLeadStatusWritable
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-statuses/{id}'
}

export type InternalLeadsStatusesUpdateResponses = {
  200: ReturnLeadStatusReadable
}

export type InternalLeadsStatusesUpdateResponse =
  InternalLeadsStatusesUpdateResponses[keyof InternalLeadsStatusesUpdateResponses]

export type InternalLeadsStatusesListListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    lead_type?: Array<number>
    lead_type_isnull?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/leads-statuses/list'
}

export type InternalLeadsStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalLeadsStatusesListListResponse =
  InternalLeadsStatusesListListResponses[keyof InternalLeadsStatusesListListResponses]

export type InternalLeadsTypesListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/leads-types'
}

export type InternalLeadsTypesListResponses = {
  200: PaginatedReturnLeadTypeListReadable
}

export type InternalLeadsTypesListResponse =
  InternalLeadsTypesListResponses[keyof InternalLeadsTypesListResponses]

export type InternalLeadsTypesCreateData = {
  body: LeadTypeWritable
  path?: never
  query?: never
  url: '/internal/leads-types'
}

export type InternalLeadsTypesCreateResponses = {
  201: ReturnLeadTypeReadable
}

export type InternalLeadsTypesCreateResponse =
  InternalLeadsTypesCreateResponses[keyof InternalLeadsTypesCreateResponses]

export type InternalLeadsTypesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-types/{id}'
}

export type InternalLeadsTypesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalLeadsTypesDestroyResponse =
  InternalLeadsTypesDestroyResponses[keyof InternalLeadsTypesDestroyResponses]

export type InternalLeadsTypesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-types/{id}'
}

export type InternalLeadsTypesRetrieveResponses = {
  200: ReturnLeadTypeReadable
}

export type InternalLeadsTypesRetrieveResponse =
  InternalLeadsTypesRetrieveResponses[keyof InternalLeadsTypesRetrieveResponses]

export type InternalLeadsTypesPartialUpdateData = {
  body?: PatchedLeadTypeWritable
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-types/{id}'
}

export type InternalLeadsTypesPartialUpdateResponses = {
  200: ReturnLeadTypeReadable
}

export type InternalLeadsTypesPartialUpdateResponse =
  InternalLeadsTypesPartialUpdateResponses[keyof InternalLeadsTypesPartialUpdateResponses]

export type InternalLeadsTypesUpdateData = {
  body: LeadTypeWritable
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/internal/leads-types/{id}'
}

export type InternalLeadsTypesUpdateResponses = {
  200: ReturnLeadTypeReadable
}

export type InternalLeadsTypesUpdateResponse =
  InternalLeadsTypesUpdateResponses[keyof InternalLeadsTypesUpdateResponses]

export type InternalLeadsTypesListListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/leads-types/list'
}

export type InternalLeadsTypesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalLeadsTypesListListResponse =
  InternalLeadsTypesListListResponses[keyof InternalLeadsTypesListListResponses]

export type InternalLeadsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/internal/leads/{id}'
}

export type InternalLeadsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalLeadsDestroyResponse =
  InternalLeadsDestroyResponses[keyof InternalLeadsDestroyResponses]

export type InternalLeadsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/internal/leads/{id}'
}

export type InternalLeadsRetrieveResponses = {
  200: ReturnLeadReadable
}

export type InternalLeadsRetrieveResponse =
  InternalLeadsRetrieveResponses[keyof InternalLeadsRetrieveResponses]

export type InternalLeadsPartialUpdateData = {
  body?: PatchedReturnLeadWritable
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/internal/leads/{id}'
}

export type InternalLeadsPartialUpdateResponses = {
  200: ReturnLeadReadable
}

export type InternalLeadsPartialUpdateResponse =
  InternalLeadsPartialUpdateResponses[keyof InternalLeadsPartialUpdateResponses]

export type InternalLeadsUpdateData = {
  body: ReturnLeadWritable
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/internal/leads/{id}'
}

export type InternalLeadsUpdateResponses = {
  200: ReturnLeadReadable
}

export type InternalLeadsUpdateResponse =
  InternalLeadsUpdateResponses[keyof InternalLeadsUpdateResponses]

export type InternalLeadsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/internal/leads/list'
}

export type InternalLeadsListListResponses = {
  200: PaginatedDropdownList
}

export type InternalLeadsListListResponse =
  InternalLeadsListListResponses[keyof InternalLeadsListListResponses]

export type InternalLogsListData = {
  body?: never
  path?: never
  query?: {
    lead_id?: number | null
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
  }
  url: '/internal/logs'
}

export type InternalLogsListResponses = {
  200: PaginatedReturnLogsListReadable
}

export type InternalLogsListResponse =
  InternalLogsListResponses[keyof InternalLogsListResponses]

export type InternalLogsCreateData = {
  body: ReturnLogsWritable
  path?: never
  query?: never
  url: '/internal/logs'
}

export type InternalLogsCreateResponses = {
  201: ReturnLogsReadable
}

export type InternalLogsCreateResponse =
  InternalLogsCreateResponses[keyof InternalLogsCreateResponses]

export type InternalLogsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this logs.
     */
    id: number
  }
  query?: never
  url: '/internal/logs/{id}'
}

export type InternalLogsRetrieveResponses = {
  200: ReturnLogsReadable
}

export type InternalLogsRetrieveResponse =
  InternalLogsRetrieveResponses[keyof InternalLogsRetrieveResponses]

export type InternalOpportunitiesCreateData = {
  body: ReturnOpportunityWritable
  path?: never
  query?: never
  url: '/internal/opportunities'
}

export type InternalOpportunitiesCreateResponses = {
  201: ReturnOpportunityReadable
}

export type InternalOpportunitiesCreateResponse =
  InternalOpportunitiesCreateResponses[keyof InternalOpportunitiesCreateResponses]

export type InternalOpportunitiesStatusesListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/opportunities-statuses'
}

export type InternalOpportunitiesStatusesListResponses = {
  200: PaginatedReturnOpportunityStatusListReadable
}

export type InternalOpportunitiesStatusesListResponse =
  InternalOpportunitiesStatusesListResponses[keyof InternalOpportunitiesStatusesListResponses]

export type InternalOpportunitiesStatusesCreateData = {
  body: ReturnOpportunityStatusWritable
  path?: never
  query?: never
  url: '/internal/opportunities-statuses'
}

export type InternalOpportunitiesStatusesCreateResponses = {
  201: ReturnOpportunityStatusReadable
}

export type InternalOpportunitiesStatusesCreateResponse =
  InternalOpportunitiesStatusesCreateResponses[keyof InternalOpportunitiesStatusesCreateResponses]

export type InternalOpportunitiesStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities-statuses/{id}'
}

export type InternalOpportunitiesStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalOpportunitiesStatusesDestroyResponse =
  InternalOpportunitiesStatusesDestroyResponses[keyof InternalOpportunitiesStatusesDestroyResponses]

export type InternalOpportunitiesStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities-statuses/{id}'
}

export type InternalOpportunitiesStatusesRetrieveResponses = {
  200: ReturnOpportunityStatusReadable
}

export type InternalOpportunitiesStatusesRetrieveResponse =
  InternalOpportunitiesStatusesRetrieveResponses[keyof InternalOpportunitiesStatusesRetrieveResponses]

export type InternalOpportunitiesStatusesPartialUpdateData = {
  body?: PatchedReturnOpportunityStatusWritable
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities-statuses/{id}'
}

export type InternalOpportunitiesStatusesPartialUpdateResponses = {
  200: ReturnOpportunityStatusReadable
}

export type InternalOpportunitiesStatusesPartialUpdateResponse =
  InternalOpportunitiesStatusesPartialUpdateResponses[keyof InternalOpportunitiesStatusesPartialUpdateResponses]

export type InternalOpportunitiesStatusesUpdateData = {
  body: ReturnOpportunityStatusWritable
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities-statuses/{id}'
}

export type InternalOpportunitiesStatusesUpdateResponses = {
  200: ReturnOpportunityStatusReadable
}

export type InternalOpportunitiesStatusesUpdateResponse =
  InternalOpportunitiesStatusesUpdateResponses[keyof InternalOpportunitiesStatusesUpdateResponses]

export type InternalOpportunitiesStatusesListListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/opportunities-statuses/list'
}

export type InternalOpportunitiesStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalOpportunitiesStatusesListListResponse =
  InternalOpportunitiesStatusesListListResponses[keyof InternalOpportunitiesStatusesListListResponses]

export type InternalOpportunitiesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities/{id}'
}

export type InternalOpportunitiesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalOpportunitiesDestroyResponse =
  InternalOpportunitiesDestroyResponses[keyof InternalOpportunitiesDestroyResponses]

export type InternalOpportunitiesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities/{id}'
}

export type InternalOpportunitiesRetrieveResponses = {
  200: ReturnOpportunityReadable
}

export type InternalOpportunitiesRetrieveResponse =
  InternalOpportunitiesRetrieveResponses[keyof InternalOpportunitiesRetrieveResponses]

export type InternalOpportunitiesPartialUpdateData = {
  body?: PatchedReturnOpportunityWritable
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities/{id}'
}

export type InternalOpportunitiesPartialUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type InternalOpportunitiesPartialUpdateResponse =
  InternalOpportunitiesPartialUpdateResponses[keyof InternalOpportunitiesPartialUpdateResponses]

export type InternalOpportunitiesUpdateData = {
  body: ReturnOpportunityWritable
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/internal/opportunities/{id}'
}

export type InternalOpportunitiesUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type InternalOpportunitiesUpdateResponse =
  InternalOpportunitiesUpdateResponses[keyof InternalOpportunitiesUpdateResponses]

export type InternalProductsListData = {
  body?: never
  path?: never
  query?: {
    category?: number
    currency?: number
    is_active?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/products'
}

export type InternalProductsListResponses = {
  200: PaginatedReturnProductListReadable
}

export type InternalProductsListResponse =
  InternalProductsListResponses[keyof InternalProductsListResponses]

export type InternalProductsCreateData = {
  body: ProductWritable
  path?: never
  query?: never
  url: '/internal/products'
}

export type InternalProductsCreateResponses = {
  201: ReturnProductReadable
}

export type InternalProductsCreateResponse =
  InternalProductsCreateResponses[keyof InternalProductsCreateResponses]

export type InternalProductsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/internal/products/{id}'
}

export type InternalProductsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalProductsDestroyResponse =
  InternalProductsDestroyResponses[keyof InternalProductsDestroyResponses]

export type InternalProductsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/internal/products/{id}'
}

export type InternalProductsRetrieveResponses = {
  200: ReturnProductReadable
}

export type InternalProductsRetrieveResponse =
  InternalProductsRetrieveResponses[keyof InternalProductsRetrieveResponses]

export type InternalProductsPartialUpdateData = {
  body?: PatchedProductWritable
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/internal/products/{id}'
}

export type InternalProductsPartialUpdateResponses = {
  200: ReturnProductReadable
}

export type InternalProductsPartialUpdateResponse =
  InternalProductsPartialUpdateResponses[keyof InternalProductsPartialUpdateResponses]

export type InternalProductsUpdateData = {
  body: ProductWritable
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/internal/products/{id}'
}

export type InternalProductsUpdateResponses = {
  200: ReturnProductReadable
}

export type InternalProductsUpdateResponse =
  InternalProductsUpdateResponses[keyof InternalProductsUpdateResponses]

export type InternalProductsListListData = {
  body?: never
  path?: never
  query?: {
    category?: number
    currency?: number
    is_active?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/products/list'
}

export type InternalProductsListListResponses = {
  200: PaginatedDropdownList
}

export type InternalProductsListListResponse =
  InternalProductsListListResponses[keyof InternalProductsListListResponses]

export type InternalReasonsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/reasons'
}

export type InternalReasonsListResponses = {
  200: PaginatedReasonListReadable
}

export type InternalReasonsListResponse =
  InternalReasonsListResponses[keyof InternalReasonsListResponses]

export type InternalReasonsCreateData = {
  body: ReasonWritable
  path?: never
  query?: never
  url: '/internal/reasons'
}

export type InternalReasonsCreateResponses = {
  201: ReasonReadable
}

export type InternalReasonsCreateResponse =
  InternalReasonsCreateResponses[keyof InternalReasonsCreateResponses]

export type InternalReasonsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/internal/reasons/{id}'
}

export type InternalReasonsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalReasonsDestroyResponse =
  InternalReasonsDestroyResponses[keyof InternalReasonsDestroyResponses]

export type InternalReasonsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/internal/reasons/{id}'
}

export type InternalReasonsRetrieveResponses = {
  200: ReasonReadable
}

export type InternalReasonsRetrieveResponse =
  InternalReasonsRetrieveResponses[keyof InternalReasonsRetrieveResponses]

export type InternalReasonsPartialUpdateData = {
  body?: PatchedReasonWritable
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/internal/reasons/{id}'
}

export type InternalReasonsPartialUpdateResponses = {
  200: ReasonReadable
}

export type InternalReasonsPartialUpdateResponse =
  InternalReasonsPartialUpdateResponses[keyof InternalReasonsPartialUpdateResponses]

export type InternalReasonsUpdateData = {
  body: ReasonWritable
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/internal/reasons/{id}'
}

export type InternalReasonsUpdateResponses = {
  200: ReasonReadable
}

export type InternalReasonsUpdateResponse =
  InternalReasonsUpdateResponses[keyof InternalReasonsUpdateResponses]

export type InternalReasonsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/reasons/list'
}

export type InternalReasonsListListResponses = {
  200: PaginatedDropdownList
}

export type InternalReasonsListListResponse =
  InternalReasonsListListResponses[keyof InternalReasonsListListResponses]

export type InternalRegionsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/regions'
}

export type InternalRegionsListResponses = {
  200: PaginatedRegionListReadable
}

export type InternalRegionsListResponse =
  InternalRegionsListResponses[keyof InternalRegionsListResponses]

export type InternalRegionsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this region.
     */
    id: number
  }
  query?: never
  url: '/internal/regions/{id}'
}

export type InternalRegionsRetrieveResponses = {
  200: RegionReadable
}

export type InternalRegionsRetrieveResponse =
  InternalRegionsRetrieveResponses[keyof InternalRegionsRetrieveResponses]

export type InternalRegionsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/regions/list'
}

export type InternalRegionsListListResponses = {
  200: PaginatedDropdownList
}

export type InternalRegionsListListResponse =
  InternalRegionsListListResponses[keyof InternalRegionsListListResponses]

export type InternalSequencesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/sequences'
}

export type InternalSequencesListResponses = {
  200: PaginatedSequenceListReadable
}

export type InternalSequencesListResponse =
  InternalSequencesListResponses[keyof InternalSequencesListResponses]

export type InternalSequencesCreateData = {
  body?: SequenceWritable
  path?: never
  query?: never
  url: '/internal/sequences'
}

export type InternalSequencesCreateResponses = {
  201: SequenceReadable
}

export type InternalSequencesCreateResponse =
  InternalSequencesCreateResponses[keyof InternalSequencesCreateResponses]

export type InternalSequencesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/internal/sequences/{id}'
}

export type InternalSequencesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalSequencesDestroyResponse =
  InternalSequencesDestroyResponses[keyof InternalSequencesDestroyResponses]

export type InternalSequencesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/internal/sequences/{id}'
}

export type InternalSequencesRetrieveResponses = {
  200: SequenceReadable
}

export type InternalSequencesRetrieveResponse =
  InternalSequencesRetrieveResponses[keyof InternalSequencesRetrieveResponses]

export type InternalSequencesPartialUpdateData = {
  body?: PatchedSequenceWritable
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/internal/sequences/{id}'
}

export type InternalSequencesPartialUpdateResponses = {
  200: SequenceReadable
}

export type InternalSequencesPartialUpdateResponse =
  InternalSequencesPartialUpdateResponses[keyof InternalSequencesPartialUpdateResponses]

export type InternalSequencesUpdateData = {
  body?: SequenceWritable
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/internal/sequences/{id}'
}

export type InternalSequencesUpdateResponses = {
  200: SequenceReadable
}

export type InternalSequencesUpdateResponse =
  InternalSequencesUpdateResponses[keyof InternalSequencesUpdateResponses]

export type InternalSequencesAddLeadsCreateData = {
  body: SequenceLead
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/internal/sequences/{id}/add-leads'
}

export type InternalSequencesAddLeadsCreateResponses = {
  201: ReturnSuccess
}

export type InternalSequencesAddLeadsCreateResponse =
  InternalSequencesAddLeadsCreateResponses[keyof InternalSequencesAddLeadsCreateResponses]

export type InternalSequencesDuplicateRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/internal/sequences/{id}/duplicate'
}

export type InternalSequencesDuplicateRetrieveResponses = {
  200: ReturnSuccess
}

export type InternalSequencesDuplicateRetrieveResponse =
  InternalSequencesDuplicateRetrieveResponses[keyof InternalSequencesDuplicateRetrieveResponses]

export type InternalSequencesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/sequences/list'
}

export type InternalSequencesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalSequencesListListResponse =
  InternalSequencesListListResponses[keyof InternalSequencesListListResponses]

export type InternalSourcesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/sources'
}

export type InternalSourcesListResponses = {
  200: PaginatedSourceListReadable
}

export type InternalSourcesListResponse =
  InternalSourcesListResponses[keyof InternalSourcesListResponses]

export type InternalSourcesCreateData = {
  body: SourceWritable
  path?: never
  query?: never
  url: '/internal/sources'
}

export type InternalSourcesCreateResponses = {
  201: SourceReadable
}

export type InternalSourcesCreateResponse =
  InternalSourcesCreateResponses[keyof InternalSourcesCreateResponses]

export type InternalSourcesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/internal/sources/{id}'
}

export type InternalSourcesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalSourcesDestroyResponse =
  InternalSourcesDestroyResponses[keyof InternalSourcesDestroyResponses]

export type InternalSourcesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/internal/sources/{id}'
}

export type InternalSourcesRetrieveResponses = {
  200: SourceReadable
}

export type InternalSourcesRetrieveResponse =
  InternalSourcesRetrieveResponses[keyof InternalSourcesRetrieveResponses]

export type InternalSourcesPartialUpdateData = {
  body?: PatchedSourceWritable
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/internal/sources/{id}'
}

export type InternalSourcesPartialUpdateResponses = {
  200: SourceReadable
}

export type InternalSourcesPartialUpdateResponse =
  InternalSourcesPartialUpdateResponses[keyof InternalSourcesPartialUpdateResponses]

export type InternalSourcesUpdateData = {
  body: SourceWritable
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/internal/sources/{id}'
}

export type InternalSourcesUpdateResponses = {
  200: SourceReadable
}

export type InternalSourcesUpdateResponse =
  InternalSourcesUpdateResponses[keyof InternalSourcesUpdateResponses]

export type InternalSourcesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/sources/list'
}

export type InternalSourcesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalSourcesListListResponse =
  InternalSourcesListListResponses[keyof InternalSourcesListListResponses]

export type InternalTagsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/tags'
}

export type InternalTagsListResponses = {
  200: PaginatedTagListReadable
}

export type InternalTagsListResponse =
  InternalTagsListResponses[keyof InternalTagsListResponses]

export type InternalTagsCreateData = {
  body: TagWritable
  path?: never
  query?: never
  url: '/internal/tags'
}

export type InternalTagsCreateResponses = {
  201: TagReadable
}

export type InternalTagsCreateResponse =
  InternalTagsCreateResponses[keyof InternalTagsCreateResponses]

export type InternalTagsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/internal/tags/{id}'
}

export type InternalTagsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalTagsDestroyResponse =
  InternalTagsDestroyResponses[keyof InternalTagsDestroyResponses]

export type InternalTagsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/internal/tags/{id}'
}

export type InternalTagsRetrieveResponses = {
  200: TagReadable
}

export type InternalTagsRetrieveResponse =
  InternalTagsRetrieveResponses[keyof InternalTagsRetrieveResponses]

export type InternalTagsPartialUpdateData = {
  body?: PatchedTagWritable
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/internal/tags/{id}'
}

export type InternalTagsPartialUpdateResponses = {
  200: TagReadable
}

export type InternalTagsPartialUpdateResponse =
  InternalTagsPartialUpdateResponses[keyof InternalTagsPartialUpdateResponses]

export type InternalTagsUpdateData = {
  body: TagWritable
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/internal/tags/{id}'
}

export type InternalTagsUpdateResponses = {
  200: TagReadable
}

export type InternalTagsUpdateResponse =
  InternalTagsUpdateResponses[keyof InternalTagsUpdateResponses]

export type InternalTagsColorsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/internal/tags/colors'
}

export type InternalTagsColorsRetrieveResponses = {
  /**
   * Tag colors
   */
  200: Array<string>
}

export type InternalTagsColorsRetrieveResponse =
  InternalTagsColorsRetrieveResponses[keyof InternalTagsColorsRetrieveResponses]

export type InternalTagsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/tags/list'
}

export type InternalTagsListListResponses = {
  200: PaginatedDropdownList
}

export type InternalTagsListListResponse =
  InternalTagsListListResponses[keyof InternalTagsListListResponses]

export type InternalTaskTypesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/task-types'
}

export type InternalTaskTypesListResponses = {
  200: PaginatedTaskTypeListReadable
}

export type InternalTaskTypesListResponse =
  InternalTaskTypesListResponses[keyof InternalTaskTypesListResponses]

export type InternalTaskTypesCreateData = {
  body: TaskTypeWritable
  path?: never
  query?: never
  url: '/internal/task-types'
}

export type InternalTaskTypesCreateResponses = {
  201: TaskTypeReadable
}

export type InternalTaskTypesCreateResponse =
  InternalTaskTypesCreateResponses[keyof InternalTaskTypesCreateResponses]

export type InternalTaskTypesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/internal/task-types/{id}'
}

export type InternalTaskTypesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InternalTaskTypesDestroyResponse =
  InternalTaskTypesDestroyResponses[keyof InternalTaskTypesDestroyResponses]

export type InternalTaskTypesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/internal/task-types/{id}'
}

export type InternalTaskTypesRetrieveResponses = {
  200: TaskTypeReadable
}

export type InternalTaskTypesRetrieveResponse =
  InternalTaskTypesRetrieveResponses[keyof InternalTaskTypesRetrieveResponses]

export type InternalTaskTypesPartialUpdateData = {
  body?: PatchedTaskTypeWritable
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/internal/task-types/{id}'
}

export type InternalTaskTypesPartialUpdateResponses = {
  200: TaskTypeReadable
}

export type InternalTaskTypesPartialUpdateResponse =
  InternalTaskTypesPartialUpdateResponses[keyof InternalTaskTypesPartialUpdateResponses]

export type InternalTaskTypesUpdateData = {
  body: TaskTypeWritable
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/internal/task-types/{id}'
}

export type InternalTaskTypesUpdateResponses = {
  200: TaskTypeReadable
}

export type InternalTaskTypesUpdateResponse =
  InternalTaskTypesUpdateResponses[keyof InternalTaskTypesUpdateResponses]

export type InternalTaskTypesAllRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/internal/task-types/all'
}

export type InternalTaskTypesAllRetrieveResponses = {
  200: Dropdown
}

export type InternalTaskTypesAllRetrieveResponse =
  InternalTaskTypesAllRetrieveResponses[keyof InternalTaskTypesAllRetrieveResponses]

export type InternalTaskTypesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/internal/task-types/list'
}

export type InternalTaskTypesListListResponses = {
  200: PaginatedDropdownList
}

export type InternalTaskTypesListListResponse =
  InternalTaskTypesListListResponses[keyof InternalTaskTypesListListResponses]

export type InvoicesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter invoices by invoice created_at
     */
    created_at_from?: string
    /**
     * Filter invoices by invoice created_at
     */
    created_at_to?: string
    /**
     * Filter invoices by invoice due_date
     */
    due_date_from?: string
    /**
     * Filter invoices by invoice due_date
     */
    due_date_to?: string
    lead?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Filter invoices by invoice pay_date
     */
    pay_date_from?: string
    /**
     * Filter invoices by invoice pay_date
     */
    pay_date_to?: string
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    product?: number
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter invoices by invoice status
     *
     * * `paid` - Paid
     * * `unpaid` - Unpaid
     * * `draft` - Draft
     * * `canceled` - Canceled
     */
    status?: Array<'canceled' | 'draft' | 'paid' | 'unpaid'>
  }
  url: '/invoices'
}

export type InvoicesListResponses = {
  200: PaginatedInvoiceListReadable
}

export type InvoicesListResponse =
  InvoicesListResponses[keyof InvoicesListResponses]

export type InvoicesCreateData = {
  body: InvoiceWritable
  path?: never
  query?: never
  url: '/invoices'
}

export type InvoicesCreateResponses = {
  201: InvoiceReadable
}

export type InvoicesCreateResponse =
  InvoicesCreateResponses[keyof InvoicesCreateResponses]

export type InvoicesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}'
}

export type InvoicesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type InvoicesDestroyResponse =
  InvoicesDestroyResponses[keyof InvoicesDestroyResponses]

export type InvoicesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}'
}

export type InvoicesRetrieveResponses = {
  200: InvoiceReadable
}

export type InvoicesRetrieveResponse =
  InvoicesRetrieveResponses[keyof InvoicesRetrieveResponses]

export type InvoicesPartialUpdateData = {
  body?: PatchedInvoiceUpdateWritable
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}'
}

export type InvoicesPartialUpdateResponses = {
  200: InvoiceUpdateReadable
}

export type InvoicesPartialUpdateResponse =
  InvoicesPartialUpdateResponses[keyof InvoicesPartialUpdateResponses]

export type InvoicesUpdateData = {
  body: InvoiceUpdateWritable
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}'
}

export type InvoicesUpdateResponses = {
  200: InvoiceUpdateReadable
}

export type InvoicesUpdateResponse =
  InvoicesUpdateResponses[keyof InvoicesUpdateResponses]

export type InvoicesChangeStatusPartialUpdateData = {
  body?: PatchedInvoiceWritable
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}/change-status'
}

export type InvoicesChangeStatusPartialUpdateResponses = {
  200: ReturnSuccess
}

export type InvoicesChangeStatusPartialUpdateResponse =
  InvoicesChangeStatusPartialUpdateResponses[keyof InvoicesChangeStatusPartialUpdateResponses]

export type InvoicesDownloadRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}/download'
}

export type InvoicesDownloadRetrieveResponses = {
  /**
   * PDF File
   */
  200: Blob | File
}

export type InvoicesDownloadRetrieveResponse =
  InvoicesDownloadRetrieveResponses[keyof InvoicesDownloadRetrieveResponses]

export type InvoicesEmailRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}/email'
}

export type InvoicesEmailRetrieveResponses = {
  200: RenderedInitialEmail
}

export type InvoicesEmailRetrieveResponse =
  InvoicesEmailRetrieveResponses[keyof InvoicesEmailRetrieveResponses]

export type InvoicesResendEmailRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this invoice.
     */
    id: number
  }
  query?: never
  url: '/invoices/{id}/resend-email'
}

export type InvoicesResendEmailRetrieveResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type InvoicesContractorsCreateData = {
  body: ReturnShortLeadWritable
  path?: never
  query?: never
  url: '/invoices/contractors'
}

export type InvoicesContractorsCreateResponses = {
  200: ReturnShortLeadReadable
}

export type InvoicesContractorsCreateResponse =
  InvoicesContractorsCreateResponses[keyof InvoicesContractorsCreateResponses]

export type InvoicesReportsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/invoices/reports'
}

export type InvoicesReportsRetrieveResponses = {
  200: ReportStats
}

export type InvoicesReportsRetrieveResponse =
  InvoicesReportsRetrieveResponses[keyof InvoicesReportsRetrieveResponses]

export type InvoicesReportsExportCreateData = {
  body: ReportInvoiceExport
  path?: never
  query?: never
  url: '/invoices/reports-export'
}

export type InvoicesReportsExportCreateResponses = {
  /**
   * Excel file in binary format containing invoice reports
   */
  200: Blob | File
}

export type InvoicesReportsExportCreateResponse =
  InvoicesReportsExportCreateResponses[keyof InvoicesReportsExportCreateResponses]

export type InvoicesSettingsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/invoices/settings'
}

export type InvoicesSettingsRetrieveResponses = {
  200: CompanyReadable
}

export type InvoicesSettingsRetrieveResponse =
  InvoicesSettingsRetrieveResponses[keyof InvoicesSettingsRetrieveResponses]

export type InvoicesSettingsCreateData = {
  body: CompanyCreateWritable
  path?: never
  query?: never
  url: '/invoices/settings'
}

export type InvoicesSettingsCreateResponses = {
  200: CompanyReadable
}

export type InvoicesSettingsCreateResponse =
  InvoicesSettingsCreateResponses[keyof InvoicesSettingsCreateResponses]

export type LeadGenerationCampaignsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/lead-generation/campaigns'
}

export type LeadGenerationCampaignsListResponses = {
  200: PaginatedCascoCampaignList
}

export type LeadGenerationCampaignsListResponse =
  LeadGenerationCampaignsListResponses[keyof LeadGenerationCampaignsListResponses]

export type LeadGenerationCampaignsRetrieveData = {
  body?: never
  path: {
    /**
     * * `casco_cross_sell` - CASCO cross-sell
     */
    generator_key: 'casco_cross_sell'
  }
  query?: never
  url: '/lead-generation/campaigns/{generator_key}'
}

export type LeadGenerationCampaignsRetrieveResponses = {
  200: CascoCampaign
}

export type LeadGenerationCampaignsRetrieveResponse =
  LeadGenerationCampaignsRetrieveResponses[keyof LeadGenerationCampaignsRetrieveResponses]

export type LeadGenerationCampaignsPartialUpdateData = {
  body?: PatchedCascoCampaign
  path: {
    /**
     * * `casco_cross_sell` - CASCO cross-sell
     */
    generator_key: 'casco_cross_sell'
  }
  query?: never
  url: '/lead-generation/campaigns/{generator_key}'
}

export type LeadGenerationCampaignsPartialUpdateResponses = {
  200: CascoCampaign
}

export type LeadGenerationCampaignsPartialUpdateResponse =
  LeadGenerationCampaignsPartialUpdateResponses[keyof LeadGenerationCampaignsPartialUpdateResponses]

export type LeadGenerationCampaignsRunsListData = {
  body?: never
  path: {
    /**
     * * `casco_cross_sell` - CASCO cross-sell
     */
    generator_key: 'casco_cross_sell'
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/lead-generation/campaigns/{generator_key}/runs'
}

export type LeadGenerationCampaignsRunsListResponses = {
  200: PaginatedLeadGenerationRunListReadable
}

export type LeadGenerationCampaignsRunsListResponse =
  LeadGenerationCampaignsRunsListResponses[keyof LeadGenerationCampaignsRunsListResponses]

export type LeadGenerationCampaignsTriggerCreateData = {
  body?: never
  path: {
    /**
     * * `casco_cross_sell` - CASCO cross-sell
     */
    generator_key: 'casco_cross_sell'
  }
  query?: never
  url: '/lead-generation/campaigns/{generator_key}/trigger'
}

export type LeadGenerationCampaignsTriggerCreateResponses = {
  200: LeadGenerationRunReadable
}

export type LeadGenerationCampaignsTriggerCreateResponse =
  LeadGenerationCampaignsTriggerCreateResponses[keyof LeadGenerationCampaignsTriggerCreateResponses]

export type LeadGenerationRunsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead generation run.
     */
    id: number
  }
  query?: never
  url: '/lead-generation/runs/{id}'
}

export type LeadGenerationRunsRetrieveResponses = {
  200: LeadGenerationRunReadable
}

export type LeadGenerationRunsRetrieveResponse =
  LeadGenerationRunsRetrieveResponses[keyof LeadGenerationRunsRetrieveResponses]

export type LeadScoreListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/lead-score'
}

export type LeadScoreListResponses = {
  200: PaginatedLeadScoreRatingListReadable
}

export type LeadScoreListResponse =
  LeadScoreListResponses[keyof LeadScoreListResponses]

export type LeadScoreCreateData = {
  body: LeadScoreRatingWritable
  path?: never
  query?: never
  url: '/lead-score'
}

export type LeadScoreCreateResponses = {
  201: LeadScoreRatingReadable
}

export type LeadScoreCreateResponse =
  LeadScoreCreateResponses[keyof LeadScoreCreateResponses]

export type LeadScoreDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead score rating.
     */
    id: number
  }
  query?: never
  url: '/lead-score/{id}'
}

export type LeadScoreDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadScoreDestroyResponse =
  LeadScoreDestroyResponses[keyof LeadScoreDestroyResponses]

export type LeadScoreRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead score rating.
     */
    id: number
  }
  query?: never
  url: '/lead-score/{id}'
}

export type LeadScoreRetrieveResponses = {
  200: LeadScoreRatingReadable
}

export type LeadScoreRetrieveResponse =
  LeadScoreRetrieveResponses[keyof LeadScoreRetrieveResponses]

export type LeadScorePartialUpdateData = {
  body?: PatchedLeadScoreRatingWritable
  path: {
    /**
     * A unique integer value identifying this lead score rating.
     */
    id: number
  }
  query?: never
  url: '/lead-score/{id}'
}

export type LeadScorePartialUpdateResponses = {
  200: LeadScoreRatingReadable
}

export type LeadScorePartialUpdateResponse =
  LeadScorePartialUpdateResponses[keyof LeadScorePartialUpdateResponses]

export type LeadScoreUpdateData = {
  body: LeadScoreRatingWritable
  path: {
    /**
     * A unique integer value identifying this lead score rating.
     */
    id: number
  }
  query?: never
  url: '/lead-score/{id}'
}

export type LeadScoreUpdateResponses = {
  200: LeadScoreRatingReadable
}

export type LeadScoreUpdateResponse =
  LeadScoreUpdateResponses[keyof LeadScoreUpdateResponses]

export type LeadScoreFieldsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/lead-score/fields'
}

export type LeadScoreFieldsRetrieveResponses = {
  200: ReturnFields
}

export type LeadScoreFieldsRetrieveResponse =
  LeadScoreFieldsRetrieveResponses[keyof LeadScoreFieldsRetrieveResponses]

export type LeadScoreListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/lead-score/list'
}

export type LeadScoreListListResponses = {
  200: PaginatedDropdownList
}

export type LeadScoreListListResponse =
  LeadScoreListListResponses[keyof LeadScoreListListResponses]

export type LeadsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/leads'
}

export type LeadsListResponses = {
  200: PaginatedReturnLeadListReadable
}

export type LeadsListResponse = LeadsListResponses[keyof LeadsListResponses]

export type LeadsCreateData = {
  body?: ExtendedLeadWritable
  path?: never
  query?: never
  url: '/leads'
}

export type LeadsCreateResponses = {
  201: ReturnLeadReadable
}

export type LeadsCreateResponse =
  LeadsCreateResponses[keyof LeadsCreateResponses]

export type LeadsImportListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-import'
}

export type LeadsImportListResponses = {
  200: PaginatedReturnImportListReadable
}

export type LeadsImportListResponse =
  LeadsImportListResponses[keyof LeadsImportListResponses]

export type LeadsImportCreateData = {
  body?: ImportWritable
  path?: never
  query?: never
  url: '/leads-import'
}

export type LeadsImportCreateResponses = {
  201: ReturnImportReadable
}

export type LeadsImportCreateResponse =
  LeadsImportCreateResponses[keyof LeadsImportCreateResponses]

export type LeadsImportDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this import.
     */
    id: number
  }
  query?: never
  url: '/leads-import/{id}'
}

export type LeadsImportDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadsImportDestroyResponse =
  LeadsImportDestroyResponses[keyof LeadsImportDestroyResponses]

export type LeadsImportRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this import.
     */
    id: number
  }
  query?: never
  url: '/leads-import/{id}'
}

export type LeadsImportRetrieveResponses = {
  200: ReturnImportReadable
}

export type LeadsImportRetrieveResponse =
  LeadsImportRetrieveResponses[keyof LeadsImportRetrieveResponses]

export type LeadsImportPartialUpdateData = {
  body?: PatchedImportWritable
  path: {
    /**
     * A unique integer value identifying this import.
     */
    id: number
  }
  query?: never
  url: '/leads-import/{id}'
}

export type LeadsImportPartialUpdateResponses = {
  200: ReturnImportReadable
}

export type LeadsImportPartialUpdateResponse =
  LeadsImportPartialUpdateResponses[keyof LeadsImportPartialUpdateResponses]

export type LeadsImportUpdateData = {
  body?: ImportWritable
  path: {
    /**
     * A unique integer value identifying this import.
     */
    id: number
  }
  query?: never
  url: '/leads-import/{id}'
}

export type LeadsImportUpdateResponses = {
  200: ReturnImportReadable
}

export type LeadsImportUpdateResponse =
  LeadsImportUpdateResponses[keyof LeadsImportUpdateResponses]

export type LeadsImportColumnUniqueValuesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this import.
     */
    id: number
  }
  query: {
    column: number
  }
  url: '/leads-import/{id}/column-unique-values'
}

export type LeadsImportColumnUniqueValuesRetrieveResponses = {
  /**
   * Unique values from the selected column
   */
  200: Array<string>
}

export type LeadsImportColumnUniqueValuesRetrieveResponse =
  LeadsImportColumnUniqueValuesRetrieveResponses[keyof LeadsImportColumnUniqueValuesRetrieveResponses]

export type LeadsImportPreviewRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this import.
     */
    id: number
  }
  query?: never
  url: '/leads-import/{id}/preview'
}

export type LeadsImportPreviewRetrieveResponses = {
  200: ReturnImportPreview
}

export type LeadsImportPreviewRetrieveResponse =
  LeadsImportPreviewRetrieveResponses[keyof LeadsImportPreviewRetrieveResponses]

export type LeadsImportHeadersRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/leads-import/headers'
}

export type LeadsImportHeadersRetrieveResponses = {
  200: HeadersResponse
}

export type LeadsImportHeadersRetrieveResponse =
  LeadsImportHeadersRetrieveResponses[keyof LeadsImportHeadersRetrieveResponses]

export type LeadsImportUniqueFieldsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/leads-import/unique-fields'
}

export type LeadsImportUniqueFieldsRetrieveResponses = {
  200: UniqueFieldsResponse
}

export type LeadsImportUniqueFieldsRetrieveResponse =
  LeadsImportUniqueFieldsRetrieveResponses[keyof LeadsImportUniqueFieldsRetrieveResponses]

export type LeadsStatusesListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    lead_type?: Array<number>
    lead_type_isnull?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-statuses'
}

export type LeadsStatusesListResponses = {
  200: PaginatedReturnLeadStatusListReadable
}

export type LeadsStatusesListResponse =
  LeadsStatusesListResponses[keyof LeadsStatusesListResponses]

export type LeadsStatusesCreateData = {
  body: ReturnLeadStatusWritable
  path?: never
  query?: never
  url: '/leads-statuses'
}

export type LeadsStatusesCreateResponses = {
  201: ReturnLeadStatusReadable
}

export type LeadsStatusesCreateResponse =
  LeadsStatusesCreateResponses[keyof LeadsStatusesCreateResponses]

export type LeadsStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/leads-statuses/{id}'
}

export type LeadsStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadsStatusesDestroyResponse =
  LeadsStatusesDestroyResponses[keyof LeadsStatusesDestroyResponses]

export type LeadsStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/leads-statuses/{id}'
}

export type LeadsStatusesRetrieveResponses = {
  200: ReturnLeadStatusReadable
}

export type LeadsStatusesRetrieveResponse =
  LeadsStatusesRetrieveResponses[keyof LeadsStatusesRetrieveResponses]

export type LeadsStatusesPartialUpdateData = {
  body?: PatchedReturnLeadStatusWritable
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/leads-statuses/{id}'
}

export type LeadsStatusesPartialUpdateResponses = {
  200: ReturnLeadStatusReadable
}

export type LeadsStatusesPartialUpdateResponse =
  LeadsStatusesPartialUpdateResponses[keyof LeadsStatusesPartialUpdateResponses]

export type LeadsStatusesUpdateData = {
  body: ReturnLeadStatusWritable
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
  }
  query?: never
  url: '/leads-statuses/{id}'
}

export type LeadsStatusesUpdateResponses = {
  200: ReturnLeadStatusReadable
}

export type LeadsStatusesUpdateResponse =
  LeadsStatusesUpdateResponses[keyof LeadsStatusesUpdateResponses]

export type LeadsStatusesListListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    lead_type?: Array<number>
    lead_type_isnull?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-statuses/list'
}

export type LeadsStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type LeadsStatusesListListResponse =
  LeadsStatusesListListResponses[keyof LeadsStatusesListListResponses]

export type LeadsTypesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-types'
}

export type LeadsTypesListResponses = {
  200: PaginatedReturnLeadTypeListReadable
}

export type LeadsTypesListResponse =
  LeadsTypesListResponses[keyof LeadsTypesListResponses]

export type LeadsTypesCreateData = {
  body: LeadTypeWritable
  path?: never
  query?: never
  url: '/leads-types'
}

export type LeadsTypesCreateResponses = {
  201: ReturnLeadTypeReadable
}

export type LeadsTypesCreateResponse =
  LeadsTypesCreateResponses[keyof LeadsTypesCreateResponses]

export type LeadsTypesLeadsStatusesListData = {
  body?: never
  path: {
    lead_type_id: string
  }
  query?: {
    code?: string
    lead_type?: Array<number>
    lead_type_isnull?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-types/{lead_type_id}/leads-statuses'
}

export type LeadsTypesLeadsStatusesListResponses = {
  200: PaginatedReturnLeadStatusListReadable
}

export type LeadsTypesLeadsStatusesListResponse =
  LeadsTypesLeadsStatusesListResponses[keyof LeadsTypesLeadsStatusesListResponses]

export type LeadsTypesLeadsStatusesCreateData = {
  body: ReturnLeadStatusWritable
  path: {
    lead_type_id: string
  }
  query?: never
  url: '/leads-types/{lead_type_id}/leads-statuses'
}

export type LeadsTypesLeadsStatusesCreateResponses = {
  201: ReturnLeadStatusReadable
}

export type LeadsTypesLeadsStatusesCreateResponse =
  LeadsTypesLeadsStatusesCreateResponses[keyof LeadsTypesLeadsStatusesCreateResponses]

export type LeadsTypesLeadsStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
    lead_type_id: string
  }
  query?: never
  url: '/leads-types/{lead_type_id}/leads-statuses/{id}'
}

export type LeadsTypesLeadsStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadsTypesLeadsStatusesDestroyResponse =
  LeadsTypesLeadsStatusesDestroyResponses[keyof LeadsTypesLeadsStatusesDestroyResponses]

export type LeadsTypesLeadsStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
    lead_type_id: string
  }
  query?: never
  url: '/leads-types/{lead_type_id}/leads-statuses/{id}'
}

export type LeadsTypesLeadsStatusesRetrieveResponses = {
  200: ReturnLeadStatusReadable
}

export type LeadsTypesLeadsStatusesRetrieveResponse =
  LeadsTypesLeadsStatusesRetrieveResponses[keyof LeadsTypesLeadsStatusesRetrieveResponses]

export type LeadsTypesLeadsStatusesPartialUpdateData = {
  body?: PatchedReturnLeadStatusWritable
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
    lead_type_id: string
  }
  query?: never
  url: '/leads-types/{lead_type_id}/leads-statuses/{id}'
}

export type LeadsTypesLeadsStatusesPartialUpdateResponses = {
  200: ReturnLeadStatusReadable
}

export type LeadsTypesLeadsStatusesPartialUpdateResponse =
  LeadsTypesLeadsStatusesPartialUpdateResponses[keyof LeadsTypesLeadsStatusesPartialUpdateResponses]

export type LeadsTypesLeadsStatusesUpdateData = {
  body: ReturnLeadStatusWritable
  path: {
    /**
     * A unique integer value identifying this lead status.
     */
    id: number
    lead_type_id: string
  }
  query?: never
  url: '/leads-types/{lead_type_id}/leads-statuses/{id}'
}

export type LeadsTypesLeadsStatusesUpdateResponses = {
  200: ReturnLeadStatusReadable
}

export type LeadsTypesLeadsStatusesUpdateResponse =
  LeadsTypesLeadsStatusesUpdateResponses[keyof LeadsTypesLeadsStatusesUpdateResponses]

export type LeadsTypesLeadsStatusesListListData = {
  body?: never
  path: {
    lead_type_id: string
  }
  query?: {
    code?: string
    lead_type?: Array<number>
    lead_type_isnull?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-types/{lead_type_id}/leads-statuses/list'
}

export type LeadsTypesLeadsStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type LeadsTypesLeadsStatusesListListResponse =
  LeadsTypesLeadsStatusesListListResponses[keyof LeadsTypesLeadsStatusesListListResponses]

export type LeadsTypesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/leads-types/{id}'
}

export type LeadsTypesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadsTypesDestroyResponse =
  LeadsTypesDestroyResponses[keyof LeadsTypesDestroyResponses]

export type LeadsTypesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/leads-types/{id}'
}

export type LeadsTypesRetrieveResponses = {
  200: ReturnLeadTypeReadable
}

export type LeadsTypesRetrieveResponse =
  LeadsTypesRetrieveResponses[keyof LeadsTypesRetrieveResponses]

export type LeadsTypesPartialUpdateData = {
  body?: PatchedLeadTypeWritable
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/leads-types/{id}'
}

export type LeadsTypesPartialUpdateResponses = {
  200: ReturnLeadTypeReadable
}

export type LeadsTypesPartialUpdateResponse =
  LeadsTypesPartialUpdateResponses[keyof LeadsTypesPartialUpdateResponses]

export type LeadsTypesUpdateData = {
  body: LeadTypeWritable
  path: {
    /**
     * A unique integer value identifying this lead type.
     */
    id: number
  }
  query?: never
  url: '/leads-types/{id}'
}

export type LeadsTypesUpdateResponses = {
  200: ReturnLeadTypeReadable
}

export type LeadsTypesUpdateResponse =
  LeadsTypesUpdateResponses[keyof LeadsTypesUpdateResponses]

export type LeadsTypesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads-types/list'
}

export type LeadsTypesListListResponses = {
  200: PaginatedDropdownList
}

export type LeadsTypesListListResponse =
  LeadsTypesListListResponses[keyof LeadsTypesListListResponses]

export type LeadsContactsListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    created_by?: string
    custom_field_values?: string
    email_valid?: boolean
    job_position?: number
    lead_client?: Array<number>
    leads?: Array<number>
    leads__owner?: string
    opportunities?: Array<number>
    opportunities__owner?: string
    opportunity_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    phone_number_valid?: boolean
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    senior_position?: number
  }
  url: '/leads/{lead_id}/contacts'
}

export type LeadsContactsListResponses = {
  200: PaginatedReturnContactListReadable
}

export type LeadsContactsListResponse =
  LeadsContactsListResponses[keyof LeadsContactsListResponses]

export type LeadsContractsListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    client?: Array<number>
    deadline_from?: string
    deadline_to?: string
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * Filter contracts by product
     */
    product?: string
    /**
     * A search term.
     */
    search?: string
    signed_from?: string
    signed_to?: string
    /**
     * Stare
     * * `signed` - Semnat
     * * `closed` - Închis
     */
    status?: 'closed' | 'signed'
  }
  url: '/leads/{lead_id}/contracts'
}

export type LeadsContractsListResponses = {
  200: PaginatedReturnContractListReadable
}

export type LeadsContractsListResponse =
  LeadsContractsListResponses[keyof LeadsContractsListResponses]

export type LeadsDocumentsListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    category?: number
    is_public?: boolean
    lead?: Array<number>
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads/{lead_id}/documents'
}

export type LeadsDocumentsListResponses = {
  200: PaginatedReturnDocumentListReadable
}

export type LeadsDocumentsListResponse =
  LeadsDocumentsListResponses[keyof LeadsDocumentsListResponses]

export type LeadsLogsListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    contact?: number
    created_at_from?: string
    created_at_to?: string
    created_by?: string
    lead_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * * `task` - Task
     * * `task_change` - Task Change
     * * `opportunity_change` - Opportunity Change
     * * `document_change` - Document Change
     * * `lead_change` - Lead Change
     * * `lead_status_changed` - Lead Status Changed
     * * `lead_reactivated` - Lead Reactivated
     * * `lead_deleted` - Lead Deleted
     * * `contact_change` - Contact Change
     * * `contract_change` - Contract Change
     * * `si_asig_sync` - Si Asig Sync
     * * `lead` - Lead
     * * `opportunity` - Opportunity
     * * `contract` - Contract
     * * `client` - Client
     * * `chat` - Chat
     * * `call` - Call
     * * `email` - Email
     * * `meeting` - Meeting
     * * `note` - Note
     * * `lead_sequence_change` - Lead Sequence Change
     * * `error` - Error
     * * `form` - Form
     * * `lead_generation` - Lead Generation
     */
    type?: Array<
      | 'call'
      | 'chat'
      | 'client'
      | 'contact_change'
      | 'contract'
      | 'contract_change'
      | 'document_change'
      | 'email'
      | 'error'
      | 'form'
      | 'lead'
      | 'lead_change'
      | 'lead_deleted'
      | 'lead_generation'
      | 'lead_reactivated'
      | 'lead_sequence_change'
      | 'lead_status_changed'
      | 'meeting'
      | 'note'
      | 'opportunity'
      | 'opportunity_change'
      | 'si_asig_sync'
      | 'task'
      | 'task_change'
    >
  }
  url: '/leads/{lead_id}/logs'
}

export type LeadsLogsListResponses = {
  200: PaginatedReturnLogsListReadable
}

export type LeadsLogsListResponse =
  LeadsLogsListResponses[keyof LeadsLogsListResponses]

export type LeadsOpportunitiesListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    client?: Array<number>
    /**
     * Filter opportunity by created_at gte than specified date
     */
    created_at_gte?: string
    /**
     * Filter opportunity by opportunity created_at lte than specified date
     */
    created_at_lte?: string
    custom_field_values?: string
    /**
     * Filter by multiple Opportunity IDs
     */
    id?: Array<number>
    lead?: Array<number>
    name?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: Array<number>
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    product?: Array<number>
    products?: Array<number>
    /**
     * A search term.
     */
    search?: string
    status?: Array<number>
    tags?: Array<number>
    value?: number
    value_over?: number
    value_under?: number
  }
  url: '/leads/{lead_id}/opportunities'
}

export type LeadsOpportunitiesListResponses = {
  200: PaginatedReturnOpportunityListReadable
}

export type LeadsOpportunitiesListResponse =
  LeadsOpportunitiesListResponses[keyof LeadsOpportunitiesListResponses]

export type LeadsSequencesListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads/{lead_id}/sequences'
}

export type LeadsSequencesListResponses = {
  200: PaginatedLeadSequenceReturnListReadable
}

export type LeadsSequencesListResponse =
  LeadsSequencesListResponses[keyof LeadsSequencesListResponses]

export type LeadsSequencesCreateData = {
  body?: LeadSequenceUpdate
  path: {
    lead_id: string
  }
  query?: never
  url: '/leads/{lead_id}/sequences'
}

export type LeadsSequencesCreateResponses = {
  201: LeadSequenceUpdate
}

export type LeadsSequencesCreateResponse =
  LeadsSequencesCreateResponses[keyof LeadsSequencesCreateResponses]

export type LeadsSequencesDestroyData = {
  body?: never
  path: {
    lead_id: string
    /**
     * Campanie
     */
    sequence: number
  }
  query?: never
  url: '/leads/{lead_id}/sequences/{sequence}'
}

export type LeadsSequencesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadsSequencesDestroyResponse =
  LeadsSequencesDestroyResponses[keyof LeadsSequencesDestroyResponses]

export type LeadsSequencesRetrieveData = {
  body?: never
  path: {
    lead_id: string
    /**
     * Campanie
     */
    sequence: number
  }
  query?: never
  url: '/leads/{lead_id}/sequences/{sequence}'
}

export type LeadsSequencesRetrieveResponses = {
  200: LeadSequenceReturnReadable
}

export type LeadsSequencesRetrieveResponse =
  LeadsSequencesRetrieveResponses[keyof LeadsSequencesRetrieveResponses]

export type LeadsSequencesPartialUpdateData = {
  body?: PatchedLeadSequenceUpdate
  path: {
    lead_id: string
    /**
     * Campanie
     */
    sequence: number
  }
  query?: never
  url: '/leads/{lead_id}/sequences/{sequence}'
}

export type LeadsSequencesPartialUpdateResponses = {
  200: LeadSequenceUpdate
}

export type LeadsSequencesPartialUpdateResponse =
  LeadsSequencesPartialUpdateResponses[keyof LeadsSequencesPartialUpdateResponses]

export type LeadsSequencesUpdateData = {
  body?: LeadSequenceUpdate
  path: {
    lead_id: string
    /**
     * Campanie
     */
    sequence: number
  }
  query?: never
  url: '/leads/{lead_id}/sequences/{sequence}'
}

export type LeadsSequencesUpdateResponses = {
  200: LeadSequenceUpdate
}

export type LeadsSequencesUpdateResponse =
  LeadsSequencesUpdateResponses[keyof LeadsSequencesUpdateResponses]

export type LeadsTasksListData = {
  body?: never
  path: {
    lead_id: string
  }
  query?: {
    client?: Array<number>
    /**
     * Filter tasks by type
     */
    completed?: boolean
    created_by?: string
    /**
     * Filter tasks by deadline
     */
    deadline_end?: string
    /**
     * Filter tasks by deadline
     */
    deadline_start?: string
    lead?: Array<number>
    lead_status?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    priority?: number
    /**
     * A search term.
     */
    search?: string
    status?: number
    /**
     * Filter tasks by status active
     */
    status_active?: boolean
    type?: number
  }
  url: '/leads/{lead_id}/tasks'
}

export type LeadsTasksListResponses = {
  200: PaginatedReturnTaskListReadable
}

export type LeadsTasksListResponse =
  LeadsTasksListResponses[keyof LeadsTasksListResponses]

export type LeadsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}'
}

export type LeadsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type LeadsDestroyResponse =
  LeadsDestroyResponses[keyof LeadsDestroyResponses]

export type LeadsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}'
}

export type LeadsRetrieveResponses = {
  200: ReturnLeadReadable
}

export type LeadsRetrieveResponse =
  LeadsRetrieveResponses[keyof LeadsRetrieveResponses]

export type LeadsPartialUpdateData = {
  body?: PatchedExtendedLeadWritable
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}'
}

export type LeadsPartialUpdateResponses = {
  200: ReturnLeadReadable
}

export type LeadsPartialUpdateResponse =
  LeadsPartialUpdateResponses[keyof LeadsPartialUpdateResponses]

export type LeadsUpdateData = {
  body?: ExtendedLeadWritable
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}'
}

export type LeadsUpdateResponses = {
  200: ReturnLeadReadable
}

export type LeadsUpdateResponse =
  LeadsUpdateResponses[keyof LeadsUpdateResponses]

export type LeadsConvertToClientCreateData = {
  body: FetchSiAsigContract
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}/convert-to-client'
}

export type LeadsConvertToClientCreateResponses = {
  200: ReturnSuccess
}

export type LeadsConvertToClientCreateResponse =
  LeadsConvertToClientCreateResponses[keyof LeadsConvertToClientCreateResponses]

export type LeadsInvoiceContactsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}/invoice-contacts'
}

export type LeadsInvoiceContactsRetrieveResponses = {
  200: LeadInvoiceContactReadable
}

export type LeadsInvoiceContactsRetrieveResponse =
  LeadsInvoiceContactsRetrieveResponses[keyof LeadsInvoiceContactsRetrieveResponses]

export type LeadsInvoicesListData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/leads/{id}/invoices'
}

export type LeadsInvoicesListResponses = {
  200: PaginatedInvoiceListReadable
}

export type LeadsInvoicesListResponse =
  LeadsInvoicesListResponses[keyof LeadsInvoicesListResponses]

export type LeadsMergePartialUpdateData = {
  body?: PatchedMergeLeadWritable
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}/merge'
}

export type LeadsMergePartialUpdateResponses = {
  200: ReturnLeadReadable
}

export type LeadsMergePartialUpdateResponse =
  LeadsMergePartialUpdateResponses[keyof LeadsMergePartialUpdateResponses]

export type LeadsSimilarRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}/similar'
}

export type LeadsSimilarRetrieveResponses = {
  200: ReturnLeadReadable
}

export type LeadsSimilarRetrieveResponse =
  LeadsSimilarRetrieveResponses[keyof LeadsSimilarRetrieveResponses]

export type LeadsUndeletePartialUpdateData = {
  body?: PatchedReturnSuccess
  path: {
    /**
     * A unique integer value identifying this Lead.
     */
    id: number
  }
  query?: never
  url: '/leads/{id}/undelete'
}

export type LeadsUndeletePartialUpdateResponses = {
  200: ReturnSuccess
}

export type LeadsUndeletePartialUpdateResponse =
  LeadsUndeletePartialUpdateResponses[keyof LeadsUndeletePartialUpdateResponses]

export type LeadsBulkAssigneePartialUpdateData = {
  body?: PatchedBulkAsigneeLead
  path?: never
  query?: never
  url: '/leads/bulk-assignee'
}

export type LeadsBulkAssigneePartialUpdateResponses = {
  200: ReturnSuccess
}

export type LeadsBulkAssigneePartialUpdateResponse =
  LeadsBulkAssigneePartialUpdateResponses[keyof LeadsBulkAssigneePartialUpdateResponses]

export type LeadsBulkDeleteCreateData = {
  body: BulkDeleteLead
  path?: never
  query?: never
  url: '/leads/bulk-delete'
}

export type LeadsBulkDeleteCreateResponses = {
  200: ReturnSuccess
}

export type LeadsBulkDeleteCreateResponse =
  LeadsBulkDeleteCreateResponses[keyof LeadsBulkDeleteCreateResponses]

export type LeadsBulkSetBranchPartialUpdateData = {
  body?: PatchedBulkSetBranch
  path?: never
  query?: never
  url: '/leads/bulk-set-branch'
}

export type LeadsBulkSetBranchPartialUpdateResponses = {
  200: ReturnSuccess
}

export type LeadsBulkSetBranchPartialUpdateResponse =
  LeadsBulkSetBranchPartialUpdateResponses[keyof LeadsBulkSetBranchPartialUpdateResponses]

export type LeadsDeletedListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/leads/deleted'
}

export type LeadsDeletedListResponses = {
  200: PaginatedReturnLeadListReadable
}

export type LeadsDeletedListResponse =
  LeadsDeletedListResponses[keyof LeadsDeletedListResponses]

export type LeadsExportRetrieveData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * * `csv` - csv
     * * `excel` - excel
     */
    export_type?: 'csv' | 'excel' | null
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/leads/export'
}

export type LeadsExportRetrieveResponses = {
  200: Blob | File
}

export type LeadsExportRetrieveResponse =
  LeadsExportRetrieveResponses[keyof LeadsExportRetrieveResponses]

export type LeadsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/leads/list'
}

export type LeadsListListResponses = {
  200: PaginatedDropdownList
}

export type LeadsListListResponse =
  LeadsListListResponses[keyof LeadsListListResponses]

export type LeadsPipelineListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/leads/pipeline'
}

export type LeadsPipelineListResponses = {
  200: PaginatedSalesFunnelListReadable
}

export type LeadsPipelineListResponse =
  LeadsPipelineListResponses[keyof LeadsPipelineListResponses]

export type LeadsSetTagPartialUpdateData = {
  body?: PatchedBulkSetTag
  path?: never
  query?: never
  url: '/leads/set-tag'
}

export type LeadsSetTagPartialUpdateResponses = {
  200: ReturnSuccess
}

export type LeadsSetTagPartialUpdateResponse =
  LeadsSetTagPartialUpdateResponses[keyof LeadsSetTagPartialUpdateResponses]

export type LeadsViewedListData = {
  body?: never
  path?: never
  query?: {
    created_by?: string
    last_seen?: string
    lead?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/leads/viewed'
}

export type LeadsViewedListResponses = {
  200: PaginatedViewedLeadListReadable
}

export type LeadsViewedListResponse =
  LeadsViewedListResponses[keyof LeadsViewedListResponses]

export type ListViewsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/list-views'
}

export type ListViewsListResponses = {
  200: PaginatedListViewReturnListReadable
}

export type ListViewsListResponse =
  ListViewsListResponses[keyof ListViewsListResponses]

export type ListViewsCreateData = {
  body?: ListViewWritable
  path?: never
  query?: never
  url: '/list-views'
}

export type ListViewsCreateResponses = {
  201: ListViewReturnReadable
}

export type ListViewsCreateResponse =
  ListViewsCreateResponses[keyof ListViewsCreateResponses]

export type ListViewsResultListData = {
  body?: never
  path: {
    list_id: string
  }
  query?: {
    /**
     * Filter leads by domain
     */
    activity_domain?: string
    /**
     * Filter leads by branch
     */
    branch?: string
    city?: Array<number>
    client?: number
    /**
     * Filter leads by continent
     */
    continent?: string
    /**
     * Filter leads by country
     */
    country?: string
    /**
     * Filter leads by lead created at
     */
    created_at?: string
    /**
     * Filter leads by lead created at
     */
    created_at_from?: string
    /**
     * Filter leads by lead created at
     */
    created_at_to?: string
    custom_field_values?: string
    /**
     * Filter leads by email
     */
    email?: string
    /**
     * Filter by multiple Lead IDs
     */
    id?: Array<number>
    /**
     * Filter leads by industry
     */
    industry?: string
    lead_type?: Array<number>
    /**
     * Filter leads by name
     */
    name?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_from?: string
    /**
     * Filter leads by lead created at
     */
    opportunity__close_date_to?: string
    /**
     * Filter leads by opportunity product
     */
    opportunity_products?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    previous_owner?: string
    /**
     * Filter leads by product of interest
     *
     * * `casco` - CASCO
     */
    product_of_interest?: Array<'casco'>
    /**
     * Filter leads by reason
     */
    reason?: string
    region?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter leads by sequence
     */
    sequence?: Array<number>
    /**
     * Filter leads by size
     */
    size?: string
    source?: Array<number>
    /**
     * Filter leads by source name
     */
    source__name?: string
    status?: Array<number>
    /**
     * Filter leads by step
     */
    step?: Array<number>
    /**
     * Filter leads by sub-industry
     */
    sub_industry?: string
    tags?: Array<number>
  }
  url: '/list-views/{list_id}/result'
}

export type ListViewsResultListResponses = {
  200: PaginatedListViewListReadable
}

export type ListViewsResultListResponse =
  ListViewsResultListResponses[keyof ListViewsResultListResponses]

export type ListViewsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this list view.
     */
    id: number
  }
  query?: never
  url: '/list-views/{id}'
}

export type ListViewsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ListViewsDestroyResponse =
  ListViewsDestroyResponses[keyof ListViewsDestroyResponses]

export type ListViewsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this list view.
     */
    id: number
  }
  query?: never
  url: '/list-views/{id}'
}

export type ListViewsRetrieveResponses = {
  200: ListViewReturnReadable
}

export type ListViewsRetrieveResponse =
  ListViewsRetrieveResponses[keyof ListViewsRetrieveResponses]

export type ListViewsPartialUpdateData = {
  body?: PatchedListViewWritable
  path: {
    /**
     * A unique integer value identifying this list view.
     */
    id: number
  }
  query?: never
  url: '/list-views/{id}'
}

export type ListViewsPartialUpdateResponses = {
  200: ListViewReturnReadable
}

export type ListViewsPartialUpdateResponse =
  ListViewsPartialUpdateResponses[keyof ListViewsPartialUpdateResponses]

export type ListViewsUpdateData = {
  body?: ListViewWritable
  path: {
    /**
     * A unique integer value identifying this list view.
     */
    id: number
  }
  query?: never
  url: '/list-views/{id}'
}

export type ListViewsUpdateResponses = {
  200: ListViewReturnReadable
}

export type ListViewsUpdateResponse =
  ListViewsUpdateResponses[keyof ListViewsUpdateResponses]

export type ListViewsFieldsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/list-views/fields'
}

export type ListViewsFieldsRetrieveResponses = {
  200: ReturnFields
}

export type ListViewsFieldsRetrieveResponse =
  ListViewsFieldsRetrieveResponses[keyof ListViewsFieldsRetrieveResponses]

export type LogsListData = {
  body?: never
  path?: never
  query?: {
    contact?: number
    created_at_from?: string
    created_at_to?: string
    created_by?: string
    lead_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * * `task` - Task
     * * `task_change` - Task Change
     * * `opportunity_change` - Opportunity Change
     * * `document_change` - Document Change
     * * `lead_change` - Lead Change
     * * `lead_status_changed` - Lead Status Changed
     * * `lead_reactivated` - Lead Reactivated
     * * `lead_deleted` - Lead Deleted
     * * `contact_change` - Contact Change
     * * `contract_change` - Contract Change
     * * `si_asig_sync` - Si Asig Sync
     * * `lead` - Lead
     * * `opportunity` - Opportunity
     * * `contract` - Contract
     * * `client` - Client
     * * `chat` - Chat
     * * `call` - Call
     * * `email` - Email
     * * `meeting` - Meeting
     * * `note` - Note
     * * `lead_sequence_change` - Lead Sequence Change
     * * `error` - Error
     * * `form` - Form
     * * `lead_generation` - Lead Generation
     */
    type?: Array<
      | 'call'
      | 'chat'
      | 'client'
      | 'contact_change'
      | 'contract'
      | 'contract_change'
      | 'document_change'
      | 'email'
      | 'error'
      | 'form'
      | 'lead'
      | 'lead_change'
      | 'lead_deleted'
      | 'lead_generation'
      | 'lead_reactivated'
      | 'lead_sequence_change'
      | 'lead_status_changed'
      | 'meeting'
      | 'note'
      | 'opportunity'
      | 'opportunity_change'
      | 'si_asig_sync'
      | 'task'
      | 'task_change'
    >
  }
  url: '/logs'
}

export type LogsListResponses = {
  200: PaginatedReturnLogsListReadable
}

export type LogsListResponse = LogsListResponses[keyof LogsListResponses]

export type LogsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this logs.
     */
    id: number
  }
  query?: never
  url: '/logs/{id}'
}

export type LogsRetrieveResponses = {
  200: ReturnLogsReadable
}

export type LogsRetrieveResponse =
  LogsRetrieveResponses[keyof LogsRetrieveResponses]

export type LogsMeetingCreateData = {
  body: MeetingLogs
  path?: never
  query?: never
  url: '/logs/meeting'
}

export type LogsMeetingCreateResponses = {
  200: MeetingLogs
}

export type LogsMeetingCreateResponse =
  LogsMeetingCreateResponses[keyof LogsMeetingCreateResponses]

export type LogsNoteCreateData = {
  body: NoteLogs
  path?: never
  query?: never
  url: '/logs/note'
}

export type LogsNoteCreateResponses = {
  200: NoteLogs
}

export type LogsNoteCreateResponse =
  LogsNoteCreateResponses[keyof LogsNoteCreateResponses]

export type MailboxesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/mailboxes'
}

export type MailboxesListResponses = {
  200: PaginatedReturnOutlookMailboxListReadable
}

export type MailboxesListResponse =
  MailboxesListResponses[keyof MailboxesListResponses]

export type MailboxesCreateData = {
  body: ReturnOutlookMailboxWritable
  path?: never
  query?: never
  url: '/mailboxes'
}

export type MailboxesCreateResponses = {
  201: ReturnOutlookMailboxReadable
}

export type MailboxesCreateResponse =
  MailboxesCreateResponses[keyof MailboxesCreateResponses]

export type MailboxesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/{id}'
}

export type MailboxesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type MailboxesDestroyResponse =
  MailboxesDestroyResponses[keyof MailboxesDestroyResponses]

export type MailboxesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/{id}'
}

export type MailboxesRetrieveResponses = {
  200: ReturnOutlookMailboxReadable
}

export type MailboxesRetrieveResponse =
  MailboxesRetrieveResponses[keyof MailboxesRetrieveResponses]

export type MailboxesPartialUpdateData = {
  body?: PatchedReturnOutlookMailboxWritable
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/{id}'
}

export type MailboxesPartialUpdateResponses = {
  200: ReturnOutlookMailboxReadable
}

export type MailboxesPartialUpdateResponse =
  MailboxesPartialUpdateResponses[keyof MailboxesPartialUpdateResponses]

export type MailboxesUpdateData = {
  body: ReturnOutlookMailboxWritable
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/{id}'
}

export type MailboxesUpdateResponses = {
  200: ReturnOutlookMailboxReadable
}

export type MailboxesUpdateResponse =
  MailboxesUpdateResponses[keyof MailboxesUpdateResponses]

export type MailboxesCheckMailboxRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/{id}/check-mailbox'
}

export type MailboxesCheckMailboxRetrieveResponses = {
  200: ReturnOutlookMailboxReadable
}

export type MailboxesCheckMailboxRetrieveResponse =
  MailboxesCheckMailboxRetrieveResponses[keyof MailboxesCheckMailboxRetrieveResponses]

export type MailboxesLoginRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this mailbox.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/{id}/login'
}

export type MailboxesLoginRetrieveResponses = {
  200: ReturnLoginMailbox
}

export type MailboxesLoginRetrieveResponse =
  MailboxesLoginRetrieveResponses[keyof MailboxesLoginRetrieveResponses]

export type MailboxesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/mailboxes/list'
}

export type MailboxesListListResponses = {
  200: PaginatedDropdownList
}

export type MailboxesListListResponse =
  MailboxesListListResponses[keyof MailboxesListListResponses]

export type MailboxesOauthLogoutCreateData = {
  body?: never
  path?: never
  query?: never
  url: '/mailboxes/oauth/logout'
}

export type MailboxesOauthLogoutCreateResponses = {
  200: ReturnSuccess
}

export type MailboxesOauthLogoutCreateResponse =
  MailboxesOauthLogoutCreateResponses[keyof MailboxesOauthLogoutCreateResponses]

export type MailboxesOauthLogoutLinkRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/mailboxes/oauth/logout-link'
}

export type MailboxesOauthLogoutLinkRetrieveResponses = {
  200: ReturnLogoutMailbox
}

export type MailboxesOauthLogoutLinkRetrieveResponse =
  MailboxesOauthLogoutLinkRetrieveResponses[keyof MailboxesOauthLogoutLinkRetrieveResponses]

export type MailboxesOauthOutlookCreateData = {
  body: ReturnOutlookMailboxWritable
  path?: never
  query?: never
  url: '/mailboxes/oauth/outlook'
}

export type MailboxesOauthOutlookCreateResponses = {
  200: ReturnOutlookMailboxReadable
}

export type MailboxesOauthOutlookCreateResponse =
  MailboxesOauthOutlookCreateResponses[keyof MailboxesOauthOutlookCreateResponses]

export type MailboxesOutlookLinkRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/mailboxes/outlook-link'
}

export type MailboxesOutlookLinkRetrieveResponses = {
  200: ReturnOutlookMailboxReadable
}

export type MailboxesOutlookLinkRetrieveResponse =
  MailboxesOutlookLinkRetrieveResponses[keyof MailboxesOutlookLinkRetrieveResponses]

export type MailboxesSendEmailCreateData = {
  body: ReturnOutlookMailboxWritable
  path?: never
  query?: never
  url: '/mailboxes/send-email'
}

export type MailboxesSendEmailCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type MailboxesTemplatesListData = {
  body?: never
  path?: never
  query?: {
    created_by?: string
    is_public?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/mailboxes/templates'
}

export type MailboxesTemplatesListResponses = {
  200: PaginatedEmailTemplateListReadable
}

export type MailboxesTemplatesListResponse =
  MailboxesTemplatesListResponses[keyof MailboxesTemplatesListResponses]

export type MailboxesTemplatesCreateData = {
  body: EmailTemplateWritable
  path?: never
  query?: never
  url: '/mailboxes/templates'
}

export type MailboxesTemplatesCreateResponses = {
  201: EmailTemplateReadable
}

export type MailboxesTemplatesCreateResponse =
  MailboxesTemplatesCreateResponses[keyof MailboxesTemplatesCreateResponses]

export type MailboxesTemplatesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this email template.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/templates/{id}'
}

export type MailboxesTemplatesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type MailboxesTemplatesDestroyResponse =
  MailboxesTemplatesDestroyResponses[keyof MailboxesTemplatesDestroyResponses]

export type MailboxesTemplatesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this email template.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/templates/{id}'
}

export type MailboxesTemplatesRetrieveResponses = {
  200: EmailTemplateReadable
}

export type MailboxesTemplatesRetrieveResponse =
  MailboxesTemplatesRetrieveResponses[keyof MailboxesTemplatesRetrieveResponses]

export type MailboxesTemplatesPartialUpdateData = {
  body?: PatchedEmailTemplateWritable
  path: {
    /**
     * A unique integer value identifying this email template.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/templates/{id}'
}

export type MailboxesTemplatesPartialUpdateResponses = {
  200: EmailTemplateReadable
}

export type MailboxesTemplatesPartialUpdateResponse =
  MailboxesTemplatesPartialUpdateResponses[keyof MailboxesTemplatesPartialUpdateResponses]

export type MailboxesTemplatesUpdateData = {
  body: EmailTemplateWritable
  path: {
    /**
     * A unique integer value identifying this email template.
     */
    id: number
  }
  query?: never
  url: '/mailboxes/templates/{id}'
}

export type MailboxesTemplatesUpdateResponses = {
  200: EmailTemplateReadable
}

export type MailboxesTemplatesUpdateResponse =
  MailboxesTemplatesUpdateResponses[keyof MailboxesTemplatesUpdateResponses]

export type OpportunitiesListData = {
  body?: never
  path?: never
  query?: {
    client?: Array<number>
    /**
     * Filter opportunity by created_at gte than specified date
     */
    created_at_gte?: string
    /**
     * Filter opportunity by opportunity created_at lte than specified date
     */
    created_at_lte?: string
    custom_field_values?: string
    /**
     * Filter by multiple Opportunity IDs
     */
    id?: Array<number>
    lead?: Array<number>
    name?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: Array<number>
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    product?: Array<number>
    products?: Array<number>
    /**
     * A search term.
     */
    search?: string
    status?: Array<number>
    tags?: Array<number>
    value?: number
    value_over?: number
    value_under?: number
  }
  url: '/opportunities'
}

export type OpportunitiesListResponses = {
  200: PaginatedReturnOpportunityListReadable
}

export type OpportunitiesListResponse =
  OpportunitiesListResponses[keyof OpportunitiesListResponses]

export type OpportunitiesCreateData = {
  body?: OpportunityWritable
  path?: never
  query?: never
  url: '/opportunities'
}

export type OpportunitiesCreateResponses = {
  201: ReturnOpportunityReadable
}

export type OpportunitiesCreateResponse =
  OpportunitiesCreateResponses[keyof OpportunitiesCreateResponses]

export type OpportunitiesStatusesListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities-statuses'
}

export type OpportunitiesStatusesListResponses = {
  200: PaginatedReturnOpportunityStatusListReadable
}

export type OpportunitiesStatusesListResponse =
  OpportunitiesStatusesListResponses[keyof OpportunitiesStatusesListResponses]

export type OpportunitiesStatusesCreateData = {
  body: ReturnOpportunityStatusWritable
  path?: never
  query?: never
  url: '/opportunities-statuses'
}

export type OpportunitiesStatusesCreateResponses = {
  201: ReturnOpportunityStatusReadable
}

export type OpportunitiesStatusesCreateResponse =
  OpportunitiesStatusesCreateResponses[keyof OpportunitiesStatusesCreateResponses]

export type OpportunitiesStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/opportunities-statuses/{id}'
}

export type OpportunitiesStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type OpportunitiesStatusesDestroyResponse =
  OpportunitiesStatusesDestroyResponses[keyof OpportunitiesStatusesDestroyResponses]

export type OpportunitiesStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/opportunities-statuses/{id}'
}

export type OpportunitiesStatusesRetrieveResponses = {
  200: ReturnOpportunityStatusReadable
}

export type OpportunitiesStatusesRetrieveResponse =
  OpportunitiesStatusesRetrieveResponses[keyof OpportunitiesStatusesRetrieveResponses]

export type OpportunitiesStatusesPartialUpdateData = {
  body?: PatchedReturnOpportunityStatusWritable
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/opportunities-statuses/{id}'
}

export type OpportunitiesStatusesPartialUpdateResponses = {
  200: ReturnOpportunityStatusReadable
}

export type OpportunitiesStatusesPartialUpdateResponse =
  OpportunitiesStatusesPartialUpdateResponses[keyof OpportunitiesStatusesPartialUpdateResponses]

export type OpportunitiesStatusesUpdateData = {
  body: ReturnOpportunityStatusWritable
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
  }
  query?: never
  url: '/opportunities-statuses/{id}'
}

export type OpportunitiesStatusesUpdateResponses = {
  200: ReturnOpportunityStatusReadable
}

export type OpportunitiesStatusesUpdateResponse =
  OpportunitiesStatusesUpdateResponses[keyof OpportunitiesStatusesUpdateResponses]

export type OpportunitiesStatusesListListData = {
  body?: never
  path?: never
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities-statuses/list'
}

export type OpportunitiesStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type OpportunitiesStatusesListListResponse =
  OpportunitiesStatusesListListResponses[keyof OpportunitiesStatusesListListResponses]

export type OpportunitiesContactsListData = {
  body?: never
  path: {
    opportunity_id: string
  }
  query?: {
    created_by?: string
    custom_field_values?: string
    email_valid?: boolean
    job_position?: number
    lead_client?: Array<number>
    leads?: Array<number>
    leads__owner?: string
    opportunities?: Array<number>
    opportunities__owner?: string
    opportunity_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    phone_number_valid?: boolean
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    senior_position?: number
  }
  url: '/opportunities/{opportunity_id}/contacts'
}

export type OpportunitiesContactsListResponses = {
  200: PaginatedReturnContactListReadable
}

export type OpportunitiesContactsListResponse =
  OpportunitiesContactsListResponses[keyof OpportunitiesContactsListResponses]

export type OpportunitiesContractsListData = {
  body?: never
  path: {
    opportunity_id: string
  }
  query?: {
    client?: Array<number>
    deadline_from?: string
    deadline_to?: string
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * Filter contracts by product
     */
    product?: string
    /**
     * A search term.
     */
    search?: string
    signed_from?: string
    signed_to?: string
    /**
     * Stare
     * * `signed` - Semnat
     * * `closed` - Închis
     */
    status?: 'closed' | 'signed'
  }
  url: '/opportunities/{opportunity_id}/contracts'
}

export type OpportunitiesContractsListResponses = {
  200: PaginatedReturnContractListReadable
}

export type OpportunitiesContractsListResponse =
  OpportunitiesContractsListResponses[keyof OpportunitiesContractsListResponses]

export type OpportunitiesDocumentsListData = {
  body?: never
  path: {
    opportunity_id: string
  }
  query?: {
    category?: number
    is_public?: boolean
    lead?: Array<number>
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities/{opportunity_id}/documents'
}

export type OpportunitiesDocumentsListResponses = {
  200: PaginatedReturnDocumentListReadable
}

export type OpportunitiesDocumentsListResponse =
  OpportunitiesDocumentsListResponses[keyof OpportunitiesDocumentsListResponses]

export type OpportunitiesLogsListData = {
  body?: never
  path: {
    opportunity_id: string
  }
  query?: {
    contact?: number
    created_at_from?: string
    created_at_to?: string
    created_by?: string
    lead_client?: Array<number>
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * * `task` - Task
     * * `task_change` - Task Change
     * * `opportunity_change` - Opportunity Change
     * * `document_change` - Document Change
     * * `lead_change` - Lead Change
     * * `lead_status_changed` - Lead Status Changed
     * * `lead_reactivated` - Lead Reactivated
     * * `lead_deleted` - Lead Deleted
     * * `contact_change` - Contact Change
     * * `contract_change` - Contract Change
     * * `si_asig_sync` - Si Asig Sync
     * * `lead` - Lead
     * * `opportunity` - Opportunity
     * * `contract` - Contract
     * * `client` - Client
     * * `chat` - Chat
     * * `call` - Call
     * * `email` - Email
     * * `meeting` - Meeting
     * * `note` - Note
     * * `lead_sequence_change` - Lead Sequence Change
     * * `error` - Error
     * * `form` - Form
     * * `lead_generation` - Lead Generation
     */
    type?: Array<
      | 'call'
      | 'chat'
      | 'client'
      | 'contact_change'
      | 'contract'
      | 'contract_change'
      | 'document_change'
      | 'email'
      | 'error'
      | 'form'
      | 'lead'
      | 'lead_change'
      | 'lead_deleted'
      | 'lead_generation'
      | 'lead_reactivated'
      | 'lead_sequence_change'
      | 'lead_status_changed'
      | 'meeting'
      | 'note'
      | 'opportunity'
      | 'opportunity_change'
      | 'si_asig_sync'
      | 'task'
      | 'task_change'
    >
  }
  url: '/opportunities/{opportunity_id}/logs'
}

export type OpportunitiesLogsListResponses = {
  200: PaginatedReturnLogsListReadable
}

export type OpportunitiesLogsListResponse =
  OpportunitiesLogsListResponses[keyof OpportunitiesLogsListResponses]

export type OpportunitiesTasksListData = {
  body?: never
  path: {
    opportunity_id: string
  }
  query?: {
    client?: Array<number>
    /**
     * Filter tasks by type
     */
    completed?: boolean
    created_by?: string
    /**
     * Filter tasks by deadline
     */
    deadline_end?: string
    /**
     * Filter tasks by deadline
     */
    deadline_start?: string
    lead?: Array<number>
    lead_status?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    priority?: number
    /**
     * A search term.
     */
    search?: string
    status?: number
    /**
     * Filter tasks by status active
     */
    status_active?: boolean
    type?: number
  }
  url: '/opportunities/{opportunity_id}/tasks'
}

export type OpportunitiesTasksListResponses = {
  200: PaginatedReturnTaskListReadable
}

export type OpportunitiesTasksListResponse =
  OpportunitiesTasksListResponses[keyof OpportunitiesTasksListResponses]

export type OpportunitiesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}'
}

export type OpportunitiesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type OpportunitiesDestroyResponse =
  OpportunitiesDestroyResponses[keyof OpportunitiesDestroyResponses]

export type OpportunitiesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}'
}

export type OpportunitiesRetrieveResponses = {
  200: ReturnOpportunityReadable
}

export type OpportunitiesRetrieveResponse =
  OpportunitiesRetrieveResponses[keyof OpportunitiesRetrieveResponses]

export type OpportunitiesPartialUpdateData = {
  body?: PatchedOpportunityWritable
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}'
}

export type OpportunitiesPartialUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type OpportunitiesPartialUpdateResponse =
  OpportunitiesPartialUpdateResponses[keyof OpportunitiesPartialUpdateResponses]

export type OpportunitiesUpdateData = {
  body?: OpportunityWritable
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}'
}

export type OpportunitiesUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type OpportunitiesUpdateResponse =
  OpportunitiesUpdateResponses[keyof OpportunitiesUpdateResponses]

export type OpportunitiesConvertToClientCreateData = {
  body: FetchSiAsigContract
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}/convert-to-client'
}

export type OpportunitiesConvertToClientCreateResponses = {
  200: ReturnSuccess
}

export type OpportunitiesConvertToClientCreateResponse =
  OpportunitiesConvertToClientCreateResponses[keyof OpportunitiesConvertToClientCreateResponses]

export type OpportunitiesDuplicateCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}/duplicate'
}

export type OpportunitiesDuplicateCreateResponses = {
  200: ReturnOpportunityReadable
}

export type OpportunitiesDuplicateCreateResponse =
  OpportunitiesDuplicateCreateResponses[keyof OpportunitiesDuplicateCreateResponses]

export type OpportunitiesMergePartialUpdateData = {
  body?: PatchedMergeOpportunitiesWritable
  path: {
    /**
     * A unique integer value identifying this Oportunitate.
     */
    id: number
  }
  query?: never
  url: '/opportunities/{id}/merge'
}

export type OpportunitiesMergePartialUpdateResponses = {
  200: ReturnOpportunityReadable
}

export type OpportunitiesMergePartialUpdateResponse =
  OpportunitiesMergePartialUpdateResponses[keyof OpportunitiesMergePartialUpdateResponses]

export type OpportunitiesPipelineListData = {
  body?: never
  path?: never
  query?: {
    client?: Array<number>
    /**
     * Filter opportunity by created_at gte than specified date
     */
    created_at_gte?: string
    /**
     * Filter opportunity by opportunity created_at lte than specified date
     */
    created_at_lte?: string
    custom_field_values?: string
    /**
     * Filter by multiple Opportunity IDs
     */
    id?: Array<number>
    lead?: Array<number>
    name?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: Array<number>
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    product?: Array<number>
    products?: Array<number>
    /**
     * A search term.
     */
    search?: string
    status?: Array<number>
    tags?: Array<number>
    value?: number
    value_over?: number
    value_under?: number
  }
  url: '/opportunities/pipeline'
}

export type OpportunitiesPipelineListResponses = {
  200: PaginatedOpportunityPipelineListReadable
}

export type OpportunitiesPipelineListResponse =
  OpportunitiesPipelineListResponses[keyof OpportunitiesPipelineListResponses]

export type OpportunitiesPipelinesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities/pipelines'
}

export type OpportunitiesPipelinesListResponses = {
  200: PaginatedReturnOpportunityPipelineNomenclatorListReadable
}

export type OpportunitiesPipelinesListResponse =
  OpportunitiesPipelinesListResponses[keyof OpportunitiesPipelinesListResponses]

export type OpportunitiesPipelinesCreateData = {
  body: OpportunityPipelineNomenclatorWritable
  path?: never
  query?: never
  url: '/opportunities/pipelines'
}

export type OpportunitiesPipelinesCreateResponses = {
  201: ReturnOpportunityPipelineNomenclatorReadable
}

export type OpportunitiesPipelinesCreateResponse =
  OpportunitiesPipelinesCreateResponses[keyof OpportunitiesPipelinesCreateResponses]

export type OpportunitiesPipelinesStatusesListData = {
  body?: never
  path: {
    pipeline_id: number
  }
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities/pipelines/{pipeline_id}/statuses'
}

export type OpportunitiesPipelinesStatusesListResponses = {
  200: PaginatedReturnOpportunityStatusListReadable
}

export type OpportunitiesPipelinesStatusesListResponse =
  OpportunitiesPipelinesStatusesListResponses[keyof OpportunitiesPipelinesStatusesListResponses]

export type OpportunitiesPipelinesStatusesCreateData = {
  body: ReturnOpportunityStatusWritable
  path: {
    pipeline_id: number
  }
  query?: never
  url: '/opportunities/pipelines/{pipeline_id}/statuses'
}

export type OpportunitiesPipelinesStatusesCreateResponses = {
  201: ReturnOpportunityStatusReadable
}

export type OpportunitiesPipelinesStatusesCreateResponse =
  OpportunitiesPipelinesStatusesCreateResponses[keyof OpportunitiesPipelinesStatusesCreateResponses]

export type OpportunitiesPipelinesStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
    pipeline_id: number
  }
  query?: never
  url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}'
}

export type OpportunitiesPipelinesStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type OpportunitiesPipelinesStatusesDestroyResponse =
  OpportunitiesPipelinesStatusesDestroyResponses[keyof OpportunitiesPipelinesStatusesDestroyResponses]

export type OpportunitiesPipelinesStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
    pipeline_id: number
  }
  query?: never
  url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}'
}

export type OpportunitiesPipelinesStatusesRetrieveResponses = {
  200: ReturnOpportunityStatusReadable
}

export type OpportunitiesPipelinesStatusesRetrieveResponse =
  OpportunitiesPipelinesStatusesRetrieveResponses[keyof OpportunitiesPipelinesStatusesRetrieveResponses]

export type OpportunitiesPipelinesStatusesPartialUpdateData = {
  body?: PatchedReturnOpportunityStatusWritable
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
    pipeline_id: number
  }
  query?: never
  url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}'
}

export type OpportunitiesPipelinesStatusesPartialUpdateResponses = {
  200: ReturnOpportunityStatusReadable
}

export type OpportunitiesPipelinesStatusesPartialUpdateResponse =
  OpportunitiesPipelinesStatusesPartialUpdateResponses[keyof OpportunitiesPipelinesStatusesPartialUpdateResponses]

export type OpportunitiesPipelinesStatusesUpdateData = {
  body: ReturnOpportunityStatusWritable
  path: {
    /**
     * A unique integer value identifying this opportunity status.
     */
    id: number
    pipeline_id: number
  }
  query?: never
  url: '/opportunities/pipelines/{pipeline_id}/statuses/{id}'
}

export type OpportunitiesPipelinesStatusesUpdateResponses = {
  200: ReturnOpportunityStatusReadable
}

export type OpportunitiesPipelinesStatusesUpdateResponse =
  OpportunitiesPipelinesStatusesUpdateResponses[keyof OpportunitiesPipelinesStatusesUpdateResponses]

export type OpportunitiesPipelinesStatusesListListData = {
  body?: never
  path: {
    pipeline_id: number
  }
  query?: {
    code?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities/pipelines/{pipeline_id}/statuses/list'
}

export type OpportunitiesPipelinesStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type OpportunitiesPipelinesStatusesListListResponse =
  OpportunitiesPipelinesStatusesListListResponses[keyof OpportunitiesPipelinesStatusesListListResponses]

export type OpportunitiesPipelinesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity pipeline.
     */
    id: number
  }
  query?: never
  url: '/opportunities/pipelines/{id}'
}

export type OpportunitiesPipelinesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type OpportunitiesPipelinesDestroyResponse =
  OpportunitiesPipelinesDestroyResponses[keyof OpportunitiesPipelinesDestroyResponses]

export type OpportunitiesPipelinesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity pipeline.
     */
    id: number
  }
  query?: never
  url: '/opportunities/pipelines/{id}'
}

export type OpportunitiesPipelinesRetrieveResponses = {
  200: ReturnOpportunityPipelineNomenclatorReadable
}

export type OpportunitiesPipelinesRetrieveResponse =
  OpportunitiesPipelinesRetrieveResponses[keyof OpportunitiesPipelinesRetrieveResponses]

export type OpportunitiesPipelinesPartialUpdateData = {
  body?: PatchedOpportunityPipelineNomenclatorWritable
  path: {
    /**
     * A unique integer value identifying this opportunity pipeline.
     */
    id: number
  }
  query?: never
  url: '/opportunities/pipelines/{id}'
}

export type OpportunitiesPipelinesPartialUpdateResponses = {
  200: ReturnOpportunityPipelineNomenclatorReadable
}

export type OpportunitiesPipelinesPartialUpdateResponse =
  OpportunitiesPipelinesPartialUpdateResponses[keyof OpportunitiesPipelinesPartialUpdateResponses]

export type OpportunitiesPipelinesUpdateData = {
  body: OpportunityPipelineNomenclatorWritable
  path: {
    /**
     * A unique integer value identifying this opportunity pipeline.
     */
    id: number
  }
  query?: never
  url: '/opportunities/pipelines/{id}'
}

export type OpportunitiesPipelinesUpdateResponses = {
  200: ReturnOpportunityPipelineNomenclatorReadable
}

export type OpportunitiesPipelinesUpdateResponse =
  OpportunitiesPipelinesUpdateResponses[keyof OpportunitiesPipelinesUpdateResponses]

export type OpportunitiesPipelinesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities/pipelines/list'
}

export type OpportunitiesPipelinesListListResponses = {
  200: PaginatedDropdownList
}

export type OpportunitiesPipelinesListListResponse =
  OpportunitiesPipelinesListListResponses[keyof OpportunitiesPipelinesListListResponses]

export type OpportunitiesProductsListData = {
  body?: never
  path?: never
  query?: {
    opportunity?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    product?: number
    /**
     * A search term.
     */
    search?: string
  }
  url: '/opportunities/products'
}

export type OpportunitiesProductsListResponses = {
  200: PaginatedReturnOpportunityProductListReadable
}

export type OpportunitiesProductsListResponse =
  OpportunitiesProductsListResponses[keyof OpportunitiesProductsListResponses]

export type OpportunitiesProductsCreateData = {
  body: OpportunityProductWritable
  path?: never
  query?: never
  url: '/opportunities/products'
}

export type OpportunitiesProductsCreateResponses = {
  201: ReturnOpportunityProductReadable
}

export type OpportunitiesProductsCreateResponse =
  OpportunitiesProductsCreateResponses[keyof OpportunitiesProductsCreateResponses]

export type OpportunitiesProductsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity product.
     */
    id: number
  }
  query?: never
  url: '/opportunities/products/{id}'
}

export type OpportunitiesProductsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type OpportunitiesProductsDestroyResponse =
  OpportunitiesProductsDestroyResponses[keyof OpportunitiesProductsDestroyResponses]

export type OpportunitiesProductsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this opportunity product.
     */
    id: number
  }
  query?: never
  url: '/opportunities/products/{id}'
}

export type OpportunitiesProductsRetrieveResponses = {
  200: ReturnOpportunityProductReadable
}

export type OpportunitiesProductsRetrieveResponse =
  OpportunitiesProductsRetrieveResponses[keyof OpportunitiesProductsRetrieveResponses]

export type OpportunitiesProductsPartialUpdateData = {
  body?: PatchedOpportunityProductWritable
  path: {
    /**
     * A unique integer value identifying this opportunity product.
     */
    id: number
  }
  query?: never
  url: '/opportunities/products/{id}'
}

export type OpportunitiesProductsPartialUpdateResponses = {
  200: ReturnOpportunityProductReadable
}

export type OpportunitiesProductsPartialUpdateResponse =
  OpportunitiesProductsPartialUpdateResponses[keyof OpportunitiesProductsPartialUpdateResponses]

export type OpportunitiesProductsUpdateData = {
  body: OpportunityProductWritable
  path: {
    /**
     * A unique integer value identifying this opportunity product.
     */
    id: number
  }
  query?: never
  url: '/opportunities/products/{id}'
}

export type OpportunitiesProductsUpdateResponses = {
  200: ReturnOpportunityProductReadable
}

export type OpportunitiesProductsUpdateResponse =
  OpportunitiesProductsUpdateResponses[keyof OpportunitiesProductsUpdateResponses]

export type OpportunitiesProductsBulkCreateCreateData = {
  body: Array<OpportunityProductBulkCreateItemWritable>
  path?: never
  query?: never
  url: '/opportunities/products/bulk-create'
}

export type OpportunitiesProductsBulkCreateCreateResponses = {
  200: Array<ReturnOpportunityProductReadable>
}

export type OpportunitiesProductsBulkCreateCreateResponse =
  OpportunitiesProductsBulkCreateCreateResponses[keyof OpportunitiesProductsBulkCreateCreateResponses]

export type OpportunitiesProductsBulkUpdatePartialUpdateData = {
  body: Array<OpportunityProductBulkUpdateItem>
  path?: never
  query?: never
  url: '/opportunities/products/bulk-update'
}

export type OpportunitiesProductsBulkUpdatePartialUpdateResponses = {
  200: Array<ReturnOpportunityProductReadable>
}

export type OpportunitiesProductsBulkUpdatePartialUpdateResponse =
  OpportunitiesProductsBulkUpdatePartialUpdateResponses[keyof OpportunitiesProductsBulkUpdatePartialUpdateResponses]

export type PresetTasksListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/preset-tasks'
}

export type PresetTasksListResponses = {
  200: PaginatedPresetTaskListReadable
}

export type PresetTasksListResponse =
  PresetTasksListResponses[keyof PresetTasksListResponses]

export type PresetTasksCreateData = {
  body: PresetTaskWritable
  path?: never
  query?: never
  url: '/preset-tasks'
}

export type PresetTasksCreateResponses = {
  201: PresetTaskReadable
}

export type PresetTasksCreateResponse =
  PresetTasksCreateResponses[keyof PresetTasksCreateResponses]

export type PresetTasksDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this preset task.
     */
    id: number
  }
  query?: never
  url: '/preset-tasks/{id}'
}

export type PresetTasksDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type PresetTasksDestroyResponse =
  PresetTasksDestroyResponses[keyof PresetTasksDestroyResponses]

export type PresetTasksRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this preset task.
     */
    id: number
  }
  query?: never
  url: '/preset-tasks/{id}'
}

export type PresetTasksRetrieveResponses = {
  200: PresetTaskReadable
}

export type PresetTasksRetrieveResponse =
  PresetTasksRetrieveResponses[keyof PresetTasksRetrieveResponses]

export type PresetTasksPartialUpdateData = {
  body?: PatchedPresetTaskWritable
  path: {
    /**
     * A unique integer value identifying this preset task.
     */
    id: number
  }
  query?: never
  url: '/preset-tasks/{id}'
}

export type PresetTasksPartialUpdateResponses = {
  200: PresetTaskReadable
}

export type PresetTasksPartialUpdateResponse =
  PresetTasksPartialUpdateResponses[keyof PresetTasksPartialUpdateResponses]

export type PresetTasksUpdateData = {
  body: PresetTaskWritable
  path: {
    /**
     * A unique integer value identifying this preset task.
     */
    id: number
  }
  query?: never
  url: '/preset-tasks/{id}'
}

export type PresetTasksUpdateResponses = {
  200: PresetTaskReadable
}

export type PresetTasksUpdateResponse =
  PresetTasksUpdateResponses[keyof PresetTasksUpdateResponses]

export type ProductsListData = {
  body?: never
  path?: never
  query?: {
    category?: number
    currency?: number
    is_active?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/products'
}

export type ProductsListResponses = {
  200: PaginatedReturnProductListReadable
}

export type ProductsListResponse =
  ProductsListResponses[keyof ProductsListResponses]

export type ProductsCreateData = {
  body: ProductWritable
  path?: never
  query?: never
  url: '/products'
}

export type ProductsCreateResponses = {
  201: ReturnProductReadable
}

export type ProductsCreateResponse =
  ProductsCreateResponses[keyof ProductsCreateResponses]

export type ProductsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/products/{id}'
}

export type ProductsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProductsDestroyResponse =
  ProductsDestroyResponses[keyof ProductsDestroyResponses]

export type ProductsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/products/{id}'
}

export type ProductsRetrieveResponses = {
  200: ReturnProductReadable
}

export type ProductsRetrieveResponse =
  ProductsRetrieveResponses[keyof ProductsRetrieveResponses]

export type ProductsPartialUpdateData = {
  body?: PatchedProductWritable
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/products/{id}'
}

export type ProductsPartialUpdateResponses = {
  200: ReturnProductReadable
}

export type ProductsPartialUpdateResponse =
  ProductsPartialUpdateResponses[keyof ProductsPartialUpdateResponses]

export type ProductsUpdateData = {
  body: ProductWritable
  path: {
    /**
     * A unique integer value identifying this product.
     */
    id: number
  }
  query?: never
  url: '/products/{id}'
}

export type ProductsUpdateResponses = {
  200: ReturnProductReadable
}

export type ProductsUpdateResponse =
  ProductsUpdateResponses[keyof ProductsUpdateResponses]

export type ProductsCategoriesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/products/categories'
}

export type ProductsCategoriesListResponses = {
  200: PaginatedProductCategoryListReadable
}

export type ProductsCategoriesListResponse =
  ProductsCategoriesListResponses[keyof ProductsCategoriesListResponses]

export type ProductsCategoriesCreateData = {
  body: ProductCategoryWritable
  path?: never
  query?: never
  url: '/products/categories'
}

export type ProductsCategoriesCreateResponses = {
  201: ProductCategoryReadable
}

export type ProductsCategoriesCreateResponse =
  ProductsCategoriesCreateResponses[keyof ProductsCategoriesCreateResponses]

export type ProductsCategoriesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product category.
     */
    id: number
  }
  query?: never
  url: '/products/categories/{id}'
}

export type ProductsCategoriesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProductsCategoriesDestroyResponse =
  ProductsCategoriesDestroyResponses[keyof ProductsCategoriesDestroyResponses]

export type ProductsCategoriesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product category.
     */
    id: number
  }
  query?: never
  url: '/products/categories/{id}'
}

export type ProductsCategoriesRetrieveResponses = {
  200: ProductCategoryReadable
}

export type ProductsCategoriesRetrieveResponse =
  ProductsCategoriesRetrieveResponses[keyof ProductsCategoriesRetrieveResponses]

export type ProductsCategoriesPartialUpdateData = {
  body?: PatchedProductCategoryUpdateWritable
  path: {
    /**
     * A unique integer value identifying this product category.
     */
    id: number
  }
  query?: never
  url: '/products/categories/{id}'
}

export type ProductsCategoriesPartialUpdateResponses = {
  200: ProductCategoryUpdateReadable
}

export type ProductsCategoriesPartialUpdateResponse =
  ProductsCategoriesPartialUpdateResponses[keyof ProductsCategoriesPartialUpdateResponses]

export type ProductsCategoriesUpdateData = {
  body: ProductCategoryUpdateWritable
  path: {
    /**
     * A unique integer value identifying this product category.
     */
    id: number
  }
  query?: never
  url: '/products/categories/{id}'
}

export type ProductsCategoriesUpdateResponses = {
  200: ProductCategoryUpdateReadable
}

export type ProductsCategoriesUpdateResponse =
  ProductsCategoriesUpdateResponses[keyof ProductsCategoriesUpdateResponses]

export type ProductsCategoriesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/products/categories/list'
}

export type ProductsCategoriesListListResponses = {
  200: PaginatedDropdownList
}

export type ProductsCategoriesListListResponse =
  ProductsCategoriesListListResponses[keyof ProductsCategoriesListListResponses]

export type ProductsListListData = {
  body?: never
  path?: never
  query?: {
    category?: number
    currency?: number
    is_active?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/products/list'
}

export type ProductsListListResponses = {
  200: PaginatedDropdownList
}

export type ProductsListListResponse =
  ProductsListListResponses[keyof ProductsListListResponses]

export type ProductsUnitsOfMeasureListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/products/units-of-measure'
}

export type ProductsUnitsOfMeasureListResponses = {
  200: PaginatedProductUoMListReadable
}

export type ProductsUnitsOfMeasureListResponse =
  ProductsUnitsOfMeasureListResponses[keyof ProductsUnitsOfMeasureListResponses]

export type ProductsUnitsOfMeasureCreateData = {
  body: ProductUoMWritable
  path?: never
  query?: never
  url: '/products/units-of-measure'
}

export type ProductsUnitsOfMeasureCreateResponses = {
  201: ProductUoMReadable
}

export type ProductsUnitsOfMeasureCreateResponse =
  ProductsUnitsOfMeasureCreateResponses[keyof ProductsUnitsOfMeasureCreateResponses]

export type ProductsUnitsOfMeasureDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product uo m.
     */
    id: number
  }
  query?: never
  url: '/products/units-of-measure/{id}'
}

export type ProductsUnitsOfMeasureDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProductsUnitsOfMeasureDestroyResponse =
  ProductsUnitsOfMeasureDestroyResponses[keyof ProductsUnitsOfMeasureDestroyResponses]

export type ProductsUnitsOfMeasureRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this product uo m.
     */
    id: number
  }
  query?: never
  url: '/products/units-of-measure/{id}'
}

export type ProductsUnitsOfMeasureRetrieveResponses = {
  200: ProductUoMReadable
}

export type ProductsUnitsOfMeasureRetrieveResponse =
  ProductsUnitsOfMeasureRetrieveResponses[keyof ProductsUnitsOfMeasureRetrieveResponses]

export type ProductsUnitsOfMeasurePartialUpdateData = {
  body?: PatchedProductUoMUpdateWritable
  path: {
    /**
     * A unique integer value identifying this product uo m.
     */
    id: number
  }
  query?: never
  url: '/products/units-of-measure/{id}'
}

export type ProductsUnitsOfMeasurePartialUpdateResponses = {
  200: ProductUoMUpdateReadable
}

export type ProductsUnitsOfMeasurePartialUpdateResponse =
  ProductsUnitsOfMeasurePartialUpdateResponses[keyof ProductsUnitsOfMeasurePartialUpdateResponses]

export type ProductsUnitsOfMeasureUpdateData = {
  body: ProductUoMUpdateWritable
  path: {
    /**
     * A unique integer value identifying this product uo m.
     */
    id: number
  }
  query?: never
  url: '/products/units-of-measure/{id}'
}

export type ProductsUnitsOfMeasureUpdateResponses = {
  200: ProductUoMUpdateReadable
}

export type ProductsUnitsOfMeasureUpdateResponse =
  ProductsUnitsOfMeasureUpdateResponses[keyof ProductsUnitsOfMeasureUpdateResponses]

export type ProductsUnitsOfMeasureListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/products/units-of-measure/list'
}

export type ProductsUnitsOfMeasureListListResponses = {
  200: PaginatedDropdownList
}

export type ProductsUnitsOfMeasureListListResponse =
  ProductsUnitsOfMeasureListListResponses[keyof ProductsUnitsOfMeasureListListResponses]

export type ReasonsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/reasons'
}

export type ReasonsListResponses = {
  200: PaginatedReasonListReadable
}

export type ReasonsListResponse =
  ReasonsListResponses[keyof ReasonsListResponses]

export type ReasonsCreateData = {
  body: ReasonWritable
  path?: never
  query?: never
  url: '/reasons'
}

export type ReasonsCreateResponses = {
  201: ReasonReadable
}

export type ReasonsCreateResponse =
  ReasonsCreateResponses[keyof ReasonsCreateResponses]

export type ReasonsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/reasons/{id}'
}

export type ReasonsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ReasonsDestroyResponse =
  ReasonsDestroyResponses[keyof ReasonsDestroyResponses]

export type ReasonsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/reasons/{id}'
}

export type ReasonsRetrieveResponses = {
  200: ReasonReadable
}

export type ReasonsRetrieveResponse =
  ReasonsRetrieveResponses[keyof ReasonsRetrieveResponses]

export type ReasonsPartialUpdateData = {
  body?: PatchedReasonWritable
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/reasons/{id}'
}

export type ReasonsPartialUpdateResponses = {
  200: ReasonReadable
}

export type ReasonsPartialUpdateResponse =
  ReasonsPartialUpdateResponses[keyof ReasonsPartialUpdateResponses]

export type ReasonsUpdateData = {
  body: ReasonWritable
  path: {
    /**
     * A unique integer value identifying this reason.
     */
    id: number
  }
  query?: never
  url: '/reasons/{id}'
}

export type ReasonsUpdateResponses = {
  200: ReasonReadable
}

export type ReasonsUpdateResponse =
  ReasonsUpdateResponses[keyof ReasonsUpdateResponses]

export type ReasonsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/reasons/list'
}

export type ReasonsListListResponses = {
  200: PaginatedDropdownList
}

export type ReasonsListListResponse =
  ReasonsListListResponses[keyof ReasonsListListResponses]

export type RegionsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/regions'
}

export type RegionsListResponses = {
  200: PaginatedRegionListReadable
}

export type RegionsListResponse =
  RegionsListResponses[keyof RegionsListResponses]

export type RegionsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this region.
     */
    id: number
  }
  query?: never
  url: '/regions/{id}'
}

export type RegionsRetrieveResponses = {
  200: RegionReadable
}

export type RegionsRetrieveResponse =
  RegionsRetrieveResponses[keyof RegionsRetrieveResponses]

export type RegionsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/regions/list'
}

export type RegionsListListResponses = {
  200: PaginatedDropdownList
}

export type RegionsListListResponse =
  RegionsListListResponses[keyof RegionsListListResponses]

export type ReportsListData = {
  body?: never
  path?: never
  query?: never
  url: '/reports'
}

export type ReportsListResponses = {
  200: Array<ReportReturnReadable>
}

export type ReportsListResponse =
  ReportsListResponses[keyof ReportsListResponses]

export type ReportsCreateData = {
  body?: ReportWritable
  path?: never
  query?: never
  url: '/reports'
}

export type ReportsCreateResponses = {
  201: ReportReadable
}

export type ReportsCreateResponse =
  ReportsCreateResponses[keyof ReportsCreateResponses]

export type ReportsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}'
}

export type ReportsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ReportsDestroyResponse =
  ReportsDestroyResponses[keyof ReportsDestroyResponses]

export type ReportsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}'
}

export type ReportsRetrieveResponses = {
  200: ReportReturnReadable
}

export type ReportsRetrieveResponse =
  ReportsRetrieveResponses[keyof ReportsRetrieveResponses]

export type ReportsPartialUpdateData = {
  body?: PatchedReportWritable
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}'
}

export type ReportsPartialUpdateResponses = {
  200: ReportReadable
}

export type ReportsPartialUpdateResponse =
  ReportsPartialUpdateResponses[keyof ReportsPartialUpdateResponses]

export type ReportsUpdateData = {
  body?: ReportWritable
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}'
}

export type ReportsUpdateResponses = {
  200: ReportReadable
}

export type ReportsUpdateResponse =
  ReportsUpdateResponses[keyof ReportsUpdateResponses]

export type ReportsChartRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}/chart'
}

export type ReportsChartRetrieveResponses = {
  200: ChartData
}

export type ReportsChartRetrieveResponse =
  ReportsChartRetrieveResponses[keyof ReportsChartRetrieveResponses]

export type ReportsDuplicateCreateData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}/duplicate'
}

export type ReportsDuplicateCreateResponses = {
  200: ReportReturnReadable
}

export type ReportsDuplicateCreateResponse =
  ReportsDuplicateCreateResponses[keyof ReportsDuplicateCreateResponses]

export type ReportsModelFieldsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}/model-fields'
}

export type ReportsModelFieldsRetrieveResponses = {
  200: ReturnFields
}

export type ReportsModelFieldsRetrieveResponse =
  ReportsModelFieldsRetrieveResponses[keyof ReportsModelFieldsRetrieveResponses]

export type ReportsTableRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this report.
     */
    id: number
  }
  query?: never
  url: '/reports/{id}/table'
}

export type ReportsTableRetrieveResponses = {
  200: ReturnReportsTableReadable
}

export type ReportsTableRetrieveResponse =
  ReportsTableRetrieveResponses[keyof ReportsTableRetrieveResponses]

export type ReportsAggTypesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/agg-types'
}

export type ReportsAggTypesRetrieveResponses = {
  200: ReturnReportsTypes
}

export type ReportsAggTypesRetrieveResponse =
  ReportsAggTypesRetrieveResponses[keyof ReportsAggTypesRetrieveResponses]

export type ReportsCallsReportsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branches
     */
    branch?: Array<number>
    /**
     * Analytics after this date | Format: yyyy-mm-dd
     */
    date_from?: string
    /**
     * Analytics before this date | Format: yyyy-mm-dd
     */
    date_to?: string
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
  }
  url: '/reports/calls-reports'
}

export type ReportsCallsReportsListResponses = {
  200: Array<CallsReportReadable>
}

export type ReportsCallsReportsListResponse =
  ReportsCallsReportsListResponses[keyof ReportsCallsReportsListResponses]

export type ReportsCountryWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/country-weight-diagram'
}

export type ReportsCountryWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsCountryWeightDiagramRetrieveResponse =
  ReportsCountryWeightDiagramRetrieveResponses[keyof ReportsCountryWeightDiagramRetrieveResponses]

export type ReportsDemoChartListData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/demo-chart'
}

export type ReportsDemoChartListResponses = {
  200: Array<ReturnReportsChart>
}

export type ReportsDemoChartListResponse =
  ReportsDemoChartListResponses[keyof ReportsDemoChartListResponses]

export type ReportsExportsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
    /**
     * Filter by status
     */
    status?: string
    /**
     * Filter by type
     */
    type?: string
  }
  url: '/reports/exports'
}

export type ReportsExportsListResponses = {
  200: PaginatedExportListReadable
}

export type ReportsExportsListResponse =
  ReportsExportsListResponses[keyof ReportsExportsListResponses]

export type ReportsExportsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this export.
     */
    id: number
  }
  query?: never
  url: '/reports/exports/{id}'
}

export type ReportsExportsRetrieveResponses = {
  200: ExportReadable
}

export type ReportsExportsRetrieveResponse =
  ReportsExportsRetrieveResponses[keyof ReportsExportsRetrieveResponses]

export type ReportsLeadChartListData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/lead-chart'
}

export type ReportsLeadChartListResponses = {
  200: Array<ReturnReportsChart>
}

export type ReportsLeadChartListResponse =
  ReportsLeadChartListResponses[keyof ReportsLeadChartListResponses]

export type ReportsOfflineReportsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branches
     */
    branch?: Array<number>
    /**
     * Analytics after this date | Format: yyyy-mm-dd
     */
    date_from?: string
    /**
     * Analytics before this date | Format: yyyy-mm-dd
     */
    date_to?: string
    /**
     * Expert
     */
    owner?: string
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
  }
  url: '/reports/offline-reports'
}

export type ReportsOfflineReportsListResponses = {
  200: Array<OfflineReportReadable>
}

export type ReportsOfflineReportsListResponse =
  ReportsOfflineReportsListResponses[keyof ReportsOfflineReportsListResponses]

export type ReportsOnlineReportsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branches
     */
    branch?: Array<number>
    /**
     * Analytics after this date | Format: yyyy-mm-dd
     */
    date_from?: string
    /**
     * Analytics before this date | Format: yyyy-mm-dd
     */
    date_to?: string
    /**
     * Expert
     */
    owner?: string
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
  }
  url: '/reports/online-reports'
}

export type ReportsOnlineReportsListResponses = {
  200: Array<OnlineReportReadable>
}

export type ReportsOnlineReportsListResponse =
  ReportsOnlineReportsListResponses[keyof ReportsOnlineReportsListResponses]

export type ReportsPhoneCallsChartListData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/phone-calls-chart'
}

export type ReportsPhoneCallsChartListResponses = {
  200: Array<ReturnReportsChart>
}

export type ReportsPhoneCallsChartListResponse =
  ReportsPhoneCallsChartListResponses[keyof ReportsPhoneCallsChartListResponses]

export type ReportsPreviewChartCreateData = {
  body?: ReportReturnWritable
  path?: never
  query?: never
  url: '/reports/preview-chart'
}

export type ReportsPreviewChartCreateResponses = {
  200: ChartData
}

export type ReportsPreviewChartCreateResponse =
  ReportsPreviewChartCreateResponses[keyof ReportsPreviewChartCreateResponses]

export type ReportsPreviewTableCreateData = {
  body?: ReportWritable
  path?: never
  query?: never
  url: '/reports/preview-table'
}

export type ReportsPreviewTableCreateResponses = {
  200: ReportReadable
}

export type ReportsPreviewTableCreateResponse =
  ReportsPreviewTableCreateResponses[keyof ReportsPreviewTableCreateResponses]

export type ReportsReasonWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/reason-weight-diagram'
}

export type ReportsReasonWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsReasonWeightDiagramRetrieveResponse =
  ReportsReasonWeightDiagramRetrieveResponses[keyof ReportsReasonWeightDiagramRetrieveResponses]

export type ReportsSalesFunnelListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Branches
     */
    branch?: Array<number>
    /**
     * Lead source
     */
    lead_source?: Array<number>
    /**
     * Expert
     */
    owner?: string
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
  }
  url: '/reports/sales-funnel'
}

export type ReportsSalesFunnelListResponses = {
  200: Array<SalesFunnelReport>
}

export type ReportsSalesFunnelListResponse =
  ReportsSalesFunnelListResponses[keyof ReportsSalesFunnelListResponses]

export type ReportsScoreWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/score-weight-diagram'
}

export type ReportsScoreWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsScoreWeightDiagramRetrieveResponse =
  ReportsScoreWeightDiagramRetrieveResponses[keyof ReportsScoreWeightDiagramRetrieveResponses]

export type ReportsSourcePageWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/source-page-weight-diagram'
}

export type ReportsSourcePageWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsSourcePageWeightDiagramRetrieveResponse =
  ReportsSourcePageWeightDiagramRetrieveResponses[keyof ReportsSourcePageWeightDiagramRetrieveResponses]

export type ReportsSourceWebsiteWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/source-website-weight-diagram'
}

export type ReportsSourceWebsiteWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsSourceWebsiteWeightDiagramRetrieveResponse =
  ReportsSourceWebsiteWeightDiagramRetrieveResponses[keyof ReportsSourceWebsiteWeightDiagramRetrieveResponses]

export type ReportsSourceWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/source-weight-diagram'
}

export type ReportsSourceWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsSourceWeightDiagramRetrieveResponse =
  ReportsSourceWeightDiagramRetrieveResponses[keyof ReportsSourceWeightDiagramRetrieveResponses]

export type ReportsStatusWeightDiagramRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/status-weight-diagram'
}

export type ReportsStatusWeightDiagramRetrieveResponses = {
  200: ReturnReportsWeightDiagram
}

export type ReportsStatusWeightDiagramRetrieveResponse =
  ReportsStatusWeightDiagramRetrieveResponses[keyof ReportsStatusWeightDiagramRetrieveResponses]

export type ReportsTopProductsRetrieveData = {
  body?: never
  path?: never
  query: {
    category?: number | null
    currency?: number | null
    date_from: string
    date_to: string
    limit?: number
    /**
     * * `total_value` - total_value
     * * `-total_value` - -total_value
     * * `opportunity_count` - opportunity_count
     * * `-opportunity_count` - -opportunity_count
     */
    ordering?:
      | 'total_value'
      | '-total_value'
      | 'opportunity_count'
      | '-opportunity_count'
    owner?: string | null
    pipeline?: number | null
    status?: number | null
  }
  url: '/reports/top-products'
}

export type ReportsTopProductsRetrieveResponses = {
  200: TopProductResponse
}

export type ReportsTopProductsRetrieveResponse =
  ReportsTopProductsRetrieveResponses[keyof ReportsTopProductsRetrieveResponses]

export type ReportsTopProductsCategoryDistributionRetrieveData = {
  body?: never
  path?: never
  query: {
    category?: number | null
    date_from: string
    date_to: string
    limit?: number
    /**
     * * `total_value` - total_value
     * * `-total_value` - -total_value
     * * `opportunity_count` - opportunity_count
     * * `-opportunity_count` - -opportunity_count
     */
    ordering?:
      | 'total_value'
      | '-total_value'
      | 'opportunity_count'
      | '-opportunity_count'
    owner?: string | null
    pipeline?: number | null
    status?: number | null
  }
  url: '/reports/top-products/category-distribution'
}

export type ReportsTopProductsCategoryDistributionRetrieveResponses = {
  200: CategoryDistributionResponse
}

export type ReportsTopProductsCategoryDistributionRetrieveResponse =
  ReportsTopProductsCategoryDistributionRetrieveResponses[keyof ReportsTopProductsCategoryDistributionRetrieveResponses]

export type ReportsTopProductsCategoryDistributionExportCreateData = {
  body: CategoryDistributionExportRequest
  path?: never
  query?: never
  url: '/reports/top-products/category-distribution/export'
}

export type ReportsTopProductsCategoryDistributionExportCreateResponses = {
  200: ExportReadable
}

export type ReportsTopProductsCategoryDistributionExportCreateResponse =
  ReportsTopProductsCategoryDistributionExportCreateResponses[keyof ReportsTopProductsCategoryDistributionExportCreateResponses]

export type ReportsTopProductsExportCreateData = {
  body: TopProductsExportRequest
  path?: never
  query?: never
  url: '/reports/top-products/export'
}

export type ReportsTopProductsExportCreateResponses = {
  200: ExportReadable
}

export type ReportsTopProductsExportCreateResponse =
  ReportsTopProductsExportCreateResponses[keyof ReportsTopProductsExportCreateResponses]

export type ReportsTypesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/reports/types'
}

export type ReportsTypesRetrieveResponses = {
  200: ReturnReportsTypes
}

export type ReportsTypesRetrieveResponse =
  ReportsTypesRetrieveResponses[keyof ReportsTypesRetrieveResponses]

export type SchemaRetrieveData = {
  body?: never
  path?: never
  query?: {
    format?: 'json' | 'yaml'
    lang?: 'en' | 'it' | 'ro' | 'ru'
  }
  url: '/schema'
}

export type SchemaRetrieveResponses = {
  200: {
    [key: string]: unknown
  }
}

export type SchemaRetrieveResponse =
  SchemaRetrieveResponses[keyof SchemaRetrieveResponses]

export type SearchListData = {
  body?: never
  path?: never
  query?: {
    country?: number
    created_at_from?: string
    created_at_to?: string
    demo_date_from?: string
    demo_date_to?: string
    email?: string
    industry?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    reason?: number
    /**
     * A search term.
     */
    search?: string
    source?: number
    status?: number
    value_from?: string
    value_to?: string
  }
  url: '/search'
}

export type SearchListResponses = {
  200: PaginatedGlobalSearchListReadable
}

export type SearchListResponse = SearchListResponses[keyof SearchListResponses]

export type SearchDynamicListData = {
  body?: never
  path?: never
  query?: {
    /**
     * * `Lead` - Lead
     * * `Opportunity` - Opportunity
     * * `Task` - Task
     * * `Touch` - Touch
     * * `Call` - Call
     * * `Email` - Email
     */
    model_type?: 'Lead' | 'Opportunity' | 'Task' | 'Touch' | 'Call' | 'Email'
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/search/dynamic'
}

export type SearchDynamicListResponses = {
  200: PaginatedReturnDynamicSearchListList
}

export type SearchDynamicListResponse =
  SearchDynamicListResponses[keyof SearchDynamicListResponses]

export type SearchDynamicExportRetrieveData = {
  body?: never
  path?: never
  query?: {
    /**
     * * `Lead` - Lead
     * * `Opportunity` - Opportunity
     * * `Task` - Task
     * * `Touch` - Touch
     * * `Call` - Call
     * * `Email` - Email
     */
    model_type?: 'Lead' | 'Opportunity' | 'Task' | 'Touch' | 'Call' | 'Email'
  }
  url: '/search/dynamic/export'
}

export type SearchDynamicExportRetrieveResponses = {
  /**
   * Excel file in binary format containing invoice reports
   */
  200: Blob | File
}

export type SearchDynamicExportRetrieveResponse =
  SearchDynamicExportRetrieveResponses[keyof SearchDynamicExportRetrieveResponses]

export type SearchDynamicModelFieldsRetrieveData = {
  body?: never
  path?: never
  query?: {
    /**
     * * `Lead` - Lead
     * * `Opportunity` - Opportunity
     * * `Task` - Task
     * * `Touch` - Touch
     * * `Call` - Call
     * * `Email` - Email
     */
    model_type?: 'Lead' | 'Opportunity' | 'Task' | 'Touch' | 'Call' | 'Email'
  }
  url: '/search/dynamic/model-fields'
}

export type SearchDynamicModelFieldsRetrieveResponses = {
  200: ReturnFields
}

export type SearchDynamicModelFieldsRetrieveResponse =
  SearchDynamicModelFieldsRetrieveResponses[keyof SearchDynamicModelFieldsRetrieveResponses]

export type SearchDynamicModelsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/search/dynamic/models'
}

export type SearchDynamicModelsRetrieveResponses = {
  /**
   * Return allowed models
   */
  200: Array<string>
}

export type SearchDynamicModelsRetrieveResponse =
  SearchDynamicModelsRetrieveResponses[keyof SearchDynamicModelsRetrieveResponses]

export type SeniorPositionsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/senior-positions'
}

export type SeniorPositionsListResponses = {
  200: PaginatedSeniorJobPositionListReadable
}

export type SeniorPositionsListResponse =
  SeniorPositionsListResponses[keyof SeniorPositionsListResponses]

export type SeniorPositionsCreateData = {
  body: SeniorJobPositionWritable
  path?: never
  query?: never
  url: '/senior-positions'
}

export type SeniorPositionsCreateResponses = {
  201: SeniorJobPositionReadable
}

export type SeniorPositionsCreateResponse =
  SeniorPositionsCreateResponses[keyof SeniorPositionsCreateResponses]

export type SeniorPositionsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this senior job position.
     */
    id: number
  }
  query?: never
  url: '/senior-positions/{id}'
}

export type SeniorPositionsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type SeniorPositionsDestroyResponse =
  SeniorPositionsDestroyResponses[keyof SeniorPositionsDestroyResponses]

export type SeniorPositionsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this senior job position.
     */
    id: number
  }
  query?: never
  url: '/senior-positions/{id}'
}

export type SeniorPositionsRetrieveResponses = {
  200: SeniorJobPositionReadable
}

export type SeniorPositionsRetrieveResponse =
  SeniorPositionsRetrieveResponses[keyof SeniorPositionsRetrieveResponses]

export type SeniorPositionsPartialUpdateData = {
  body?: PatchedSeniorJobPositionWritable
  path: {
    /**
     * A unique integer value identifying this senior job position.
     */
    id: number
  }
  query?: never
  url: '/senior-positions/{id}'
}

export type SeniorPositionsPartialUpdateResponses = {
  200: SeniorJobPositionReadable
}

export type SeniorPositionsPartialUpdateResponse =
  SeniorPositionsPartialUpdateResponses[keyof SeniorPositionsPartialUpdateResponses]

export type SeniorPositionsUpdateData = {
  body: SeniorJobPositionWritable
  path: {
    /**
     * A unique integer value identifying this senior job position.
     */
    id: number
  }
  query?: never
  url: '/senior-positions/{id}'
}

export type SeniorPositionsUpdateResponses = {
  200: SeniorJobPositionReadable
}

export type SeniorPositionsUpdateResponse =
  SeniorPositionsUpdateResponses[keyof SeniorPositionsUpdateResponses]

export type SeniorPositionsJobPositionsListData = {
  body?: never
  path: {
    senior_position_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/senior-positions/{senior_position_id}/job-positions'
}

export type SeniorPositionsJobPositionsListResponses = {
  200: PaginatedReturnJobPositionListReadable
}

export type SeniorPositionsJobPositionsListResponse =
  SeniorPositionsJobPositionsListResponses[keyof SeniorPositionsJobPositionsListResponses]

export type SeniorPositionsJobPositionsCreateData = {
  body: ReturnJobPositionWritable
  path: {
    senior_position_id: string
  }
  query?: never
  url: '/senior-positions/{senior_position_id}/job-positions'
}

export type SeniorPositionsJobPositionsCreateResponses = {
  201: ReturnJobPositionReadable
}

export type SeniorPositionsJobPositionsCreateResponse =
  SeniorPositionsJobPositionsCreateResponses[keyof SeniorPositionsJobPositionsCreateResponses]

export type SeniorPositionsJobPositionsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this job position.
     */
    id: number
    senior_position_id: string
  }
  query?: never
  url: '/senior-positions/{senior_position_id}/job-positions/{id}'
}

export type SeniorPositionsJobPositionsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type SeniorPositionsJobPositionsDestroyResponse =
  SeniorPositionsJobPositionsDestroyResponses[keyof SeniorPositionsJobPositionsDestroyResponses]

export type SeniorPositionsJobPositionsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this job position.
     */
    id: number
    senior_position_id: string
  }
  query?: never
  url: '/senior-positions/{senior_position_id}/job-positions/{id}'
}

export type SeniorPositionsJobPositionsRetrieveResponses = {
  200: ReturnJobPositionReadable
}

export type SeniorPositionsJobPositionsRetrieveResponse =
  SeniorPositionsJobPositionsRetrieveResponses[keyof SeniorPositionsJobPositionsRetrieveResponses]

export type SeniorPositionsJobPositionsPartialUpdateData = {
  body?: PatchedReturnJobPositionWritable
  path: {
    /**
     * A unique integer value identifying this job position.
     */
    id: number
    senior_position_id: string
  }
  query?: never
  url: '/senior-positions/{senior_position_id}/job-positions/{id}'
}

export type SeniorPositionsJobPositionsPartialUpdateResponses = {
  200: ReturnJobPositionReadable
}

export type SeniorPositionsJobPositionsPartialUpdateResponse =
  SeniorPositionsJobPositionsPartialUpdateResponses[keyof SeniorPositionsJobPositionsPartialUpdateResponses]

export type SeniorPositionsJobPositionsUpdateData = {
  body: ReturnJobPositionWritable
  path: {
    /**
     * A unique integer value identifying this job position.
     */
    id: number
    senior_position_id: string
  }
  query?: never
  url: '/senior-positions/{senior_position_id}/job-positions/{id}'
}

export type SeniorPositionsJobPositionsUpdateResponses = {
  200: ReturnJobPositionReadable
}

export type SeniorPositionsJobPositionsUpdateResponse =
  SeniorPositionsJobPositionsUpdateResponses[keyof SeniorPositionsJobPositionsUpdateResponses]

export type SeniorPositionsJobPositionsListListData = {
  body?: never
  path: {
    senior_position_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/senior-positions/{senior_position_id}/job-positions/list'
}

export type SeniorPositionsJobPositionsListListResponses = {
  200: PaginatedDropdownList
}

export type SeniorPositionsJobPositionsListListResponse =
  SeniorPositionsJobPositionsListListResponses[keyof SeniorPositionsJobPositionsListListResponses]

export type SeniorPositionsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/senior-positions/list'
}

export type SeniorPositionsListListResponses = {
  200: PaginatedDropdownList
}

export type SeniorPositionsListListResponse =
  SeniorPositionsListListResponses[keyof SeniorPositionsListListResponses]

export type SequencesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sequences'
}

export type SequencesListResponses = {
  200: PaginatedSequenceListReadable
}

export type SequencesListResponse =
  SequencesListResponses[keyof SequencesListResponses]

export type SequencesCreateData = {
  body?: SequenceWritable
  path?: never
  query?: never
  url: '/sequences'
}

export type SequencesCreateResponses = {
  201: SequenceReadable
}

export type SequencesCreateResponse =
  SequencesCreateResponses[keyof SequencesCreateResponses]

export type SequencesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/sequences/{id}'
}

export type SequencesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type SequencesDestroyResponse =
  SequencesDestroyResponses[keyof SequencesDestroyResponses]

export type SequencesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/sequences/{id}'
}

export type SequencesRetrieveResponses = {
  200: SequenceReadable
}

export type SequencesRetrieveResponse =
  SequencesRetrieveResponses[keyof SequencesRetrieveResponses]

export type SequencesPartialUpdateData = {
  body?: PatchedSequenceWritable
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/sequences/{id}'
}

export type SequencesPartialUpdateResponses = {
  200: SequenceReadable
}

export type SequencesPartialUpdateResponse =
  SequencesPartialUpdateResponses[keyof SequencesPartialUpdateResponses]

export type SequencesUpdateData = {
  body?: SequenceWritable
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/sequences/{id}'
}

export type SequencesUpdateResponses = {
  200: SequenceReadable
}

export type SequencesUpdateResponse =
  SequencesUpdateResponses[keyof SequencesUpdateResponses]

export type SequencesAddLeadsCreateData = {
  body: SequenceLead
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/sequences/{id}/add-leads'
}

export type SequencesAddLeadsCreateResponses = {
  201: ReturnSuccess
}

export type SequencesAddLeadsCreateResponse =
  SequencesAddLeadsCreateResponses[keyof SequencesAddLeadsCreateResponses]

export type SequencesDuplicateRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this sequence.
     */
    id: number
  }
  query?: never
  url: '/sequences/{id}/duplicate'
}

export type SequencesDuplicateRetrieveResponses = {
  200: ReturnSuccess
}

export type SequencesDuplicateRetrieveResponse =
  SequencesDuplicateRetrieveResponses[keyof SequencesDuplicateRetrieveResponses]

export type SequencesLeadsListData = {
  body?: never
  path: {
    sequence_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sequences/{sequence_id}/leads'
}

export type SequencesLeadsListResponses = {
  200: PaginatedReturnShortLeadSequenceListReadable
}

export type SequencesLeadsListResponse =
  SequencesLeadsListResponses[keyof SequencesLeadsListResponses]

export type SequencesStepsListData = {
  body?: never
  path: {
    sequence_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sequences/{sequence_id}/steps'
}

export type SequencesStepsListResponses = {
  200: PaginatedReturnStepListReadable
}

export type SequencesStepsListResponse =
  SequencesStepsListResponses[keyof SequencesStepsListResponses]

export type SequencesStepsCreateData = {
  body: ReturnStepWritable
  path: {
    sequence_id: string
  }
  query?: never
  url: '/sequences/{sequence_id}/steps'
}

export type SequencesStepsCreateResponses = {
  201: ReturnStepReadable
}

export type SequencesStepsCreateResponse =
  SequencesStepsCreateResponses[keyof SequencesStepsCreateResponses]

export type SequencesStepsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this step.
     */
    id: number
    sequence_id: string
  }
  query?: never
  url: '/sequences/{sequence_id}/steps/{id}'
}

export type SequencesStepsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type SequencesStepsDestroyResponse =
  SequencesStepsDestroyResponses[keyof SequencesStepsDestroyResponses]

export type SequencesStepsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this step.
     */
    id: number
    sequence_id: string
  }
  query?: never
  url: '/sequences/{sequence_id}/steps/{id}'
}

export type SequencesStepsRetrieveResponses = {
  200: ReturnStepReadable
}

export type SequencesStepsRetrieveResponse =
  SequencesStepsRetrieveResponses[keyof SequencesStepsRetrieveResponses]

export type SequencesStepsPartialUpdateData = {
  body?: PatchedReturnStepWritable
  path: {
    /**
     * A unique integer value identifying this step.
     */
    id: number
    sequence_id: string
  }
  query?: never
  url: '/sequences/{sequence_id}/steps/{id}'
}

export type SequencesStepsPartialUpdateResponses = {
  200: ReturnStepReadable
}

export type SequencesStepsPartialUpdateResponse =
  SequencesStepsPartialUpdateResponses[keyof SequencesStepsPartialUpdateResponses]

export type SequencesStepsUpdateData = {
  body: ReturnStepWritable
  path: {
    /**
     * A unique integer value identifying this step.
     */
    id: number
    sequence_id: string
  }
  query?: never
  url: '/sequences/{sequence_id}/steps/{id}'
}

export type SequencesStepsUpdateResponses = {
  200: ReturnStepReadable
}

export type SequencesStepsUpdateResponse =
  SequencesStepsUpdateResponses[keyof SequencesStepsUpdateResponses]

export type SequencesStepsListListData = {
  body?: never
  path: {
    sequence_id: string
  }
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sequences/{sequence_id}/steps/list'
}

export type SequencesStepsListListResponses = {
  200: PaginatedDropdownList
}

export type SequencesStepsListListResponse =
  SequencesStepsListListResponses[keyof SequencesStepsListListResponses]

export type SequencesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sequences/list'
}

export type SequencesListListResponses = {
  200: PaginatedDropdownList
}

export type SequencesListListResponse =
  SequencesListListResponses[keyof SequencesListListResponses]

export type SettingsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/settings'
}

export type SettingsRetrieveResponses = {
  200: SettingReadable
}

export type SettingsRetrieveResponse =
  SettingsRetrieveResponses[keyof SettingsRetrieveResponses]

export type SettingsCreateData = {
  body?: SettingWritable
  path?: never
  query?: never
  url: '/settings'
}

export type SettingsCreateResponses = {
  200: SettingReadable
}

export type SettingsCreateResponse =
  SettingsCreateResponses[keyof SettingsCreateResponses]

export type SourcesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sources'
}

export type SourcesListResponses = {
  200: PaginatedSourceListReadable
}

export type SourcesListResponse =
  SourcesListResponses[keyof SourcesListResponses]

export type SourcesCreateData = {
  body: SourceWritable
  path?: never
  query?: never
  url: '/sources'
}

export type SourcesCreateResponses = {
  201: SourceReadable
}

export type SourcesCreateResponse =
  SourcesCreateResponses[keyof SourcesCreateResponses]

export type SourcesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/sources/{id}'
}

export type SourcesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type SourcesDestroyResponse =
  SourcesDestroyResponses[keyof SourcesDestroyResponses]

export type SourcesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/sources/{id}'
}

export type SourcesRetrieveResponses = {
  200: SourceReadable
}

export type SourcesRetrieveResponse =
  SourcesRetrieveResponses[keyof SourcesRetrieveResponses]

export type SourcesPartialUpdateData = {
  body?: PatchedSourceWritable
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/sources/{id}'
}

export type SourcesPartialUpdateResponses = {
  200: SourceReadable
}

export type SourcesPartialUpdateResponse =
  SourcesPartialUpdateResponses[keyof SourcesPartialUpdateResponses]

export type SourcesUpdateData = {
  body: SourceWritable
  path: {
    /**
     * A unique integer value identifying this lead source.
     */
    id: number
  }
  query?: never
  url: '/sources/{id}'
}

export type SourcesUpdateResponses = {
  200: SourceReadable
}

export type SourcesUpdateResponse =
  SourcesUpdateResponses[keyof SourcesUpdateResponses]

export type SourcesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/sources/list'
}

export type SourcesListListResponses = {
  200: PaginatedDropdownList
}

export type SourcesListListResponse =
  SourcesListListResponses[keyof SourcesListListResponses]

export type TagsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/tags'
}

export type TagsListResponses = {
  200: PaginatedTagListReadable
}

export type TagsListResponse = TagsListResponses[keyof TagsListResponses]

export type TagsCreateData = {
  body: TagWritable
  path?: never
  query?: never
  url: '/tags'
}

export type TagsCreateResponses = {
  201: TagReadable
}

export type TagsCreateResponse = TagsCreateResponses[keyof TagsCreateResponses]

export type TagsDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/tags/{id}'
}

export type TagsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TagsDestroyResponse =
  TagsDestroyResponses[keyof TagsDestroyResponses]

export type TagsRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/tags/{id}'
}

export type TagsRetrieveResponses = {
  200: TagReadable
}

export type TagsRetrieveResponse =
  TagsRetrieveResponses[keyof TagsRetrieveResponses]

export type TagsPartialUpdateData = {
  body?: PatchedTagWritable
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/tags/{id}'
}

export type TagsPartialUpdateResponses = {
  200: TagReadable
}

export type TagsPartialUpdateResponse =
  TagsPartialUpdateResponses[keyof TagsPartialUpdateResponses]

export type TagsUpdateData = {
  body: TagWritable
  path: {
    /**
     * A unique integer value identifying this tag.
     */
    id: number
  }
  query?: never
  url: '/tags/{id}'
}

export type TagsUpdateResponses = {
  200: TagReadable
}

export type TagsUpdateResponse = TagsUpdateResponses[keyof TagsUpdateResponses]

export type TagsColorsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/tags/colors'
}

export type TagsColorsRetrieveResponses = {
  /**
   * Tag colors
   */
  200: Array<string>
}

export type TagsColorsRetrieveResponse =
  TagsColorsRetrieveResponses[keyof TagsColorsRetrieveResponses]

export type TagsListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/tags/list'
}

export type TagsListListResponses = {
  200: PaginatedDropdownList
}

export type TagsListListResponse =
  TagsListListResponses[keyof TagsListListResponses]

export type TaskStatusesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/task-statuses'
}

export type TaskStatusesListResponses = {
  200: PaginatedTaskStatusCreateListReadable
}

export type TaskStatusesListResponse =
  TaskStatusesListResponses[keyof TaskStatusesListResponses]

export type TaskStatusesCreateData = {
  body: TaskStatusCreateWritable
  path?: never
  query?: never
  url: '/task-statuses'
}

export type TaskStatusesCreateResponses = {
  201: TaskStatusCreateReadable
}

export type TaskStatusesCreateResponse =
  TaskStatusesCreateResponses[keyof TaskStatusesCreateResponses]

export type TaskStatusesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this task status.
     */
    id: number
  }
  query?: never
  url: '/task-statuses/{id}'
}

export type TaskStatusesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TaskStatusesDestroyResponse =
  TaskStatusesDestroyResponses[keyof TaskStatusesDestroyResponses]

export type TaskStatusesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this task status.
     */
    id: number
  }
  query?: never
  url: '/task-statuses/{id}'
}

export type TaskStatusesRetrieveResponses = {
  200: TaskStatusCreateReadable
}

export type TaskStatusesRetrieveResponse =
  TaskStatusesRetrieveResponses[keyof TaskStatusesRetrieveResponses]

export type TaskStatusesPartialUpdateData = {
  body?: PatchedTaskStatusUpdateWritable
  path: {
    /**
     * A unique integer value identifying this task status.
     */
    id: number
  }
  query?: never
  url: '/task-statuses/{id}'
}

export type TaskStatusesPartialUpdateResponses = {
  200: TaskStatusUpdateReadable
}

export type TaskStatusesPartialUpdateResponse =
  TaskStatusesPartialUpdateResponses[keyof TaskStatusesPartialUpdateResponses]

export type TaskStatusesUpdateData = {
  body: TaskStatusUpdateWritable
  path: {
    /**
     * A unique integer value identifying this task status.
     */
    id: number
  }
  query?: never
  url: '/task-statuses/{id}'
}

export type TaskStatusesUpdateResponses = {
  200: TaskStatusUpdateReadable
}

export type TaskStatusesUpdateResponse =
  TaskStatusesUpdateResponses[keyof TaskStatusesUpdateResponses]

export type TaskStatusesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/task-statuses/list'
}

export type TaskStatusesListListResponses = {
  200: PaginatedDropdownList
}

export type TaskStatusesListListResponse =
  TaskStatusesListListResponses[keyof TaskStatusesListListResponses]

export type TaskTypesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/task-types'
}

export type TaskTypesListResponses = {
  200: PaginatedTaskTypeListReadable
}

export type TaskTypesListResponse =
  TaskTypesListResponses[keyof TaskTypesListResponses]

export type TaskTypesCreateData = {
  body: TaskTypeWritable
  path?: never
  query?: never
  url: '/task-types'
}

export type TaskTypesCreateResponses = {
  201: TaskTypeReadable
}

export type TaskTypesCreateResponse =
  TaskTypesCreateResponses[keyof TaskTypesCreateResponses]

export type TaskTypesDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/task-types/{id}'
}

export type TaskTypesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TaskTypesDestroyResponse =
  TaskTypesDestroyResponses[keyof TaskTypesDestroyResponses]

export type TaskTypesRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/task-types/{id}'
}

export type TaskTypesRetrieveResponses = {
  200: TaskTypeReadable
}

export type TaskTypesRetrieveResponse =
  TaskTypesRetrieveResponses[keyof TaskTypesRetrieveResponses]

export type TaskTypesPartialUpdateData = {
  body?: PatchedTaskTypeWritable
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/task-types/{id}'
}

export type TaskTypesPartialUpdateResponses = {
  200: TaskTypeReadable
}

export type TaskTypesPartialUpdateResponse =
  TaskTypesPartialUpdateResponses[keyof TaskTypesPartialUpdateResponses]

export type TaskTypesUpdateData = {
  body: TaskTypeWritable
  path: {
    /**
     * A unique integer value identifying this task type.
     */
    id: number
  }
  query?: never
  url: '/task-types/{id}'
}

export type TaskTypesUpdateResponses = {
  200: TaskTypeReadable
}

export type TaskTypesUpdateResponse =
  TaskTypesUpdateResponses[keyof TaskTypesUpdateResponses]

export type TaskTypesAllRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/task-types/all'
}

export type TaskTypesAllRetrieveResponses = {
  200: Dropdown
}

export type TaskTypesAllRetrieveResponse =
  TaskTypesAllRetrieveResponses[keyof TaskTypesAllRetrieveResponses]

export type TaskTypesGenericListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/task-types/generic'
}

export type TaskTypesGenericListResponses = {
  200: PaginatedTaskTypeListReadable
}

export type TaskTypesGenericListResponse =
  TaskTypesGenericListResponses[keyof TaskTypesGenericListResponses]

export type TaskTypesListListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/task-types/list'
}

export type TaskTypesListListResponses = {
  200: PaginatedDropdownList
}

export type TaskTypesListListResponse =
  TaskTypesListListResponses[keyof TaskTypesListListResponses]

export type TaskTypesSystemListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/task-types/system'
}

export type TaskTypesSystemListResponses = {
  200: PaginatedSystemTaskTypeListReadable
}

export type TaskTypesSystemListResponse =
  TaskTypesSystemListResponses[keyof TaskTypesSystemListResponses]

export type TasksListData = {
  body?: never
  path?: never
  query?: {
    client?: Array<number>
    /**
     * Filter tasks by type
     */
    completed?: boolean
    created_by?: string
    /**
     * Filter tasks by deadline
     */
    deadline_end?: string
    /**
     * Filter tasks by deadline
     */
    deadline_start?: string
    lead?: Array<number>
    lead_status?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    priority?: number
    /**
     * A search term.
     */
    search?: string
    status?: number
    /**
     * Filter tasks by status active
     */
    status_active?: boolean
    type?: number
  }
  url: '/tasks'
}

export type TasksListResponses = {
  200: PaginatedReturnTaskListReadable
}

export type TasksListResponse = TasksListResponses[keyof TasksListResponses]

export type TasksCreateData = {
  body: TaskWritable
  path?: never
  query?: never
  url: '/tasks'
}

export type TasksCreateResponses = {
  201: ReturnTaskReadable
}

export type TasksCreateResponse =
  TasksCreateResponses[keyof TasksCreateResponses]

export type TasksDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/tasks/{id}'
}

export type TasksDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TasksDestroyResponse =
  TasksDestroyResponses[keyof TasksDestroyResponses]

export type TasksRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/tasks/{id}'
}

export type TasksRetrieveResponses = {
  200: ReturnTaskReadable
}

export type TasksRetrieveResponse =
  TasksRetrieveResponses[keyof TasksRetrieveResponses]

export type TasksPartialUpdateData = {
  body?: PatchedTaskWritable
  path: {
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/tasks/{id}'
}

export type TasksPartialUpdateResponses = {
  200: ReturnTaskReadable
}

export type TasksPartialUpdateResponse =
  TasksPartialUpdateResponses[keyof TasksPartialUpdateResponses]

export type TasksUpdateData = {
  body: TaskWritable
  path: {
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/tasks/{id}'
}

export type TasksUpdateResponses = {
  200: ReturnTaskReadable
}

export type TasksUpdateResponse =
  TasksUpdateResponses[keyof TasksUpdateResponses]

export type TasksCompleteCreateData = {
  body?: CompleteTask
  path: {
    /**
     * A unique integer value identifying this Sarcină.
     */
    id: number
  }
  query?: never
  url: '/tasks/{id}/complete'
}

export type TasksCompleteCreateResponses = {
  200: ReturnTaskReadable
}

export type TasksCompleteCreateResponse =
  TasksCompleteCreateResponses[keyof TasksCompleteCreateResponses]

export type TasksKanbanListData = {
  body?: never
  path?: never
  query?: {
    client?: Array<number>
    /**
     * Filter tasks by type
     */
    completed?: boolean
    created_by?: string
    /**
     * Filter tasks by deadline
     */
    deadline_end?: string
    /**
     * Filter tasks by deadline
     */
    deadline_start?: string
    lead?: Array<number>
    lead_status?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    owner?: Array<string>
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    pipeline?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<number>
    priority?: number
    /**
     * A search term.
     */
    search?: string
    status?: number
    /**
     * Filter tasks by status active
     */
    status_active?: boolean
    type?: number
  }
  url: '/tasks/kanban'
}

export type TasksKanbanListResponses = {
  200: PaginatedTaskKanbanListReadable
}

export type TasksKanbanListResponse =
  TasksKanbanListResponses[keyof TasksKanbanListResponses]

export type UsersListData = {
  body?: never
  path?: never
  query?: {
    archived?: boolean
    branch?: number
    email?: string
    /**
     * Lead id
     */
    lead?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<string>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/users'
}

export type UsersListResponses = {
  200: PaginatedReturnUserListReadable
}

export type UsersListResponse = UsersListResponses[keyof UsersListResponses]

export type UsersPartialUpdateData = {
  body?: PatchedReturnUserWritable
  path: {
    /**
     * A unique value identifying this user.
     */
    id: string
  }
  query?: never
  url: '/users/{id}'
}

export type UsersPartialUpdateResponses = {
  200: ReturnUserReadable
}

export type UsersPartialUpdateResponse =
  UsersPartialUpdateResponses[keyof UsersPartialUpdateResponses]

export type UsersUpdateData = {
  body: ReturnUserWritable
  path: {
    /**
     * A unique value identifying this user.
     */
    id: string
  }
  query?: never
  url: '/users/{id}'
}

export type UsersUpdateResponses = {
  200: ReturnUserReadable
}

export type UsersUpdateResponse =
  UsersUpdateResponses[keyof UsersUpdateResponses]

export type UsersAllListData = {
  body?: never
  path?: never
  query?: {
    archived?: boolean
    branch?: number
    email?: string
    /**
     * Lead id
     */
    lead?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<string>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/users/all'
}

export type UsersAllListResponses = {
  200: PaginatedReturnUserListReadable
}

export type UsersAllListResponse =
  UsersAllListResponses[keyof UsersAllListResponses]

export type UsersAllowedModulesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/users/allowed-modules'
}

export type UsersAllowedModulesRetrieveResponses = {
  /**
   * Return allowed modules
   */
  200: Array<string>
}

export type UsersAllowedModulesRetrieveResponse =
  UsersAllowedModulesRetrieveResponses[keyof UsersAllowedModulesRetrieveResponses]

export type UsersListListData = {
  body?: never
  path?: never
  query?: {
    archived?: boolean
    branch?: number
    email?: string
    /**
     * Lead id
     */
    lead?: number
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * Multiple values may be separated by commas.
     */
    preference?: Array<string>
    /**
     * A search term.
     */
    search?: string
  }
  url: '/users/list'
}

export type UsersListListResponses = {
  200: PaginatedDropdownList
}

export type UsersListListResponse =
  UsersListListResponses[keyof UsersListListResponses]

export type UsersProfileRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/users/profile'
}

export type UsersProfileRetrieveResponses = {
  200: ReturnProfileReadable
}

export type UsersProfileRetrieveResponse =
  UsersProfileRetrieveResponses[keyof UsersProfileRetrieveResponses]

export type VoipConfigurationListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * A page number within the paginated result set.
     */
    page?: number
    /**
     * Number of results to return per page.
     */
    per_page?: number
    /**
     * * `yeastar` - Yeastar
     */
    provider?: 'yeastar'
    /**
     * A search term.
     */
    search?: string
  }
  url: '/voip/configuration'
}

export type VoipConfigurationListResponses = {
  200: PaginatedVoipConfigurationListReadable
}

export type VoipConfigurationListResponse =
  VoipConfigurationListResponses[keyof VoipConfigurationListResponses]

export type VoipConfigurationCreateData = {
  body: VoipConfigurationWritable
  path?: never
  query?: never
  url: '/voip/configuration'
}

export type VoipConfigurationCreateResponses = {
  201: VoipConfigurationReadable
}

export type VoipConfigurationCreateResponse =
  VoipConfigurationCreateResponses[keyof VoipConfigurationCreateResponses]

export type VoipConfigurationDestroyData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this voip configuration.
     */
    id: number
  }
  query?: never
  url: '/voip/configuration/{id}'
}

export type VoipConfigurationDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VoipConfigurationDestroyResponse =
  VoipConfigurationDestroyResponses[keyof VoipConfigurationDestroyResponses]

export type VoipConfigurationRetrieveData = {
  body?: never
  path: {
    /**
     * A unique integer value identifying this voip configuration.
     */
    id: number
  }
  query?: never
  url: '/voip/configuration/{id}'
}

export type VoipConfigurationRetrieveResponses = {
  200: VoipConfigurationReadable
}

export type VoipConfigurationRetrieveResponse =
  VoipConfigurationRetrieveResponses[keyof VoipConfigurationRetrieveResponses]

export type VoipConfigurationPartialUpdateData = {
  body?: PatchedVoipConfigurationWritable
  path: {
    /**
     * A unique integer value identifying this voip configuration.
     */
    id: number
  }
  query?: never
  url: '/voip/configuration/{id}'
}

export type VoipConfigurationPartialUpdateResponses = {
  200: VoipConfigurationReadable
}

export type VoipConfigurationPartialUpdateResponse =
  VoipConfigurationPartialUpdateResponses[keyof VoipConfigurationPartialUpdateResponses]

export type VoipConfigurationUpdateData = {
  body: VoipConfigurationWritable
  path: {
    /**
     * A unique integer value identifying this voip configuration.
     */
    id: number
  }
  query?: never
  url: '/voip/configuration/{id}'
}

export type VoipConfigurationUpdateResponses = {
  200: VoipConfigurationReadable
}

export type VoipConfigurationUpdateResponse =
  VoipConfigurationUpdateResponses[keyof VoipConfigurationUpdateResponses]

export type VoipConfigurationStatusRetrieveData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter by provider
     */
    provider?: 'yeastar'
  }
  url: '/voip/configuration/status'
}

export type VoipConfigurationStatusRetrieveResponses = {
  200: VoipConfigurationReadable
}

export type VoipConfigurationStatusRetrieveResponse =
  VoipConfigurationStatusRetrieveResponses[keyof VoipConfigurationStatusRetrieveResponses]

export type WebhookLeadCreateData = {
  body?: ReturnSuccess
  path?: never
  query?: never
  url: '/webhook/lead'
}

export type WebhookLeadCreateResponses = {
  200: ReturnSuccess
}

export type WebhookLeadCreateResponse =
  WebhookLeadCreateResponses[keyof WebhookLeadCreateResponses]

export type WebhookMinioCreateData = {
  body?: ReturnSuccess
  path?: never
  query?: never
  url: '/webhook/minio'
}

export type WebhookMinioCreateResponses = {
  200: ReturnSuccess
}

export type WebhookMinioCreateResponse =
  WebhookMinioCreateResponses[keyof WebhookMinioCreateResponses]

export type WebhookTaskCreateData = {
  body?: ReturnSuccess
  path?: never
  query?: never
  url: '/webhook/task'
}

export type WebhookTaskCreateResponses = {
  200: ReturnSuccess
}

export type WebhookTaskCreateResponse =
  WebhookTaskCreateResponses[keyof WebhookTaskCreateResponses]

export type WebhookVoipCreateData = {
  body?: ReturnSuccess
  path?: never
  query?: never
  url: '/webhook/voip'
}

export type WebhookVoipCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type WebhookWhatsappRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/webhook/whatsapp'
}

export type WebhookWhatsappRetrieveResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type WebhookWhatsappCreateData = {
  body?: ReturnSuccess
  path?: never
  query?: never
  url: '/webhook/whatsapp'
}

export type WebhookWhatsappCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type WidgetsRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/widgets'
}

export type WidgetsRetrieveResponses = {
  200: Array<{
    widget_type: string
    title: string
    media_type?: string
    from?: string
    media_url?: string
    redirect_url?: string
    opened?: Array<{
      id?: number
      title?: string
      users?: Array<{
        sso_id?: string
        email?: string
        first_name?: string
        last_name?: string
      }>
      created_by?: string
      created_at?: string
    }>
    completed?: Array<{
      id?: number
      title?: string
      users?: Array<{
        sso_id?: string
        email?: string
        first_name?: string
        last_name?: string
      }>
      created_by?: string
      created_at?: string
    }>
    chart?: Array<{
      time?: string
      value?: number
    }>
  }>
}

export type WidgetsRetrieveResponse =
  WidgetsRetrieveResponses[keyof WidgetsRetrieveResponses]

export type ClientOptions = {
  baseURL: 'https://api.crm.dev.intact.md' | (string & {})
}
